import "./repo.e8f99974.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hIdhk", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), Y = _.prototype;
    return O.prototype = Y, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        Y[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("d0Ch3", function(module, exports) {
!function(t, s) {
    module.exports = s();
}(module.exports, function() {
    "use strict";
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = 31536e6, u = 2628e6, d = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, a = /\[([^\]]+)]|YYYY|YY|Y|M{1,2}|D{1,2}|H{1,2}|m{1,2}|s{1,2}|SSS/g, h = {
        years: o,
        months: u,
        days: r,
        hours: e,
        minutes: i,
        seconds: n,
        milliseconds: 1,
        weeks: 6048e5
    }, c = function(t) {
        return t instanceof g;
    }, f = function(t, s, n) {
        return new g(t, n, s.$l);
    }, m = function(t) {
        return s.p(t) + "s";
    }, l = function(t) {
        return t < 0;
    }, $ = function(t) {
        return l(t) ? Math.ceil(t) : Math.floor(t);
    }, y = function(t) {
        return Math.abs(t);
    }, v = function(t, s) {
        return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
        } : {
            negative: !1,
            format: "" + t + s
        } : {
            negative: !1,
            format: ""
        };
    }, g = function() {
        function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function(s) {
                i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
                var e = t.match(d);
                if (e) {
                    var r = e.slice(2).map(function(t) {
                        return null != t ? Number(t) : 0;
                    });
                    return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
            }
            return this;
        }
        var y = l.prototype;
        return y.calMilliseconds = function() {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function(s, n) {
                return s + (t.$d[n] || 0) * h[n];
            }, 0);
        }, y.parseFromMilliseconds = function() {
            var t = this.$ms;
            this.$d.years = $(t / o), t %= o, this.$d.months = $(t / u), t %= u, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
        }, y.toISOString = function() {
            var t = v(this.$d.years, "Y"), s = v(this.$d.months, "M"), n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"), e = v(this.$d.hours, "H"), r = v(this.$d.minutes, "M"), o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"), d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative, a = e.format || r.format || u.format ? "T" : "", h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
        }, y.toJSON = function() {
            return this.toISOString();
        }, y.format = function(t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss", i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
            };
            return n.replace(a, function(t, s) {
                return s || String(i[t]);
            });
        }, y.as = function(t) {
            return this.$ms / h[m(t)];
        }, y.get = function(t) {
            var s = this.$ms, n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
        }, y.add = function(t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
        }, y.subtract = function(t, s) {
            return this.add(t, s, !0);
        }, y.locale = function(t) {
            var s = this.clone();
            return s.$l = t, s;
        }, y.clone = function() {
            return f(this.$ms, this);
        }, y.humanize = function(s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
        }, y.valueOf = function() {
            return this.asMilliseconds();
        }, y.milliseconds = function() {
            return this.get("milliseconds");
        }, y.asMilliseconds = function() {
            return this.as("milliseconds");
        }, y.seconds = function() {
            return this.get("seconds");
        }, y.asSeconds = function() {
            return this.as("seconds");
        }, y.minutes = function() {
            return this.get("minutes");
        }, y.asMinutes = function() {
            return this.as("minutes");
        }, y.hours = function() {
            return this.get("hours");
        }, y.asHours = function() {
            return this.as("hours");
        }, y.days = function() {
            return this.get("days");
        }, y.asDays = function() {
            return this.as("days");
        }, y.weeks = function() {
            return this.get("weeks");
        }, y.asWeeks = function() {
            return this.as("weeks");
        }, y.months = function() {
            return this.get("months");
        }, y.asMonths = function() {
            return this.as("months");
        }, y.years = function() {
            return this.get("years");
        }, y.asYears = function() {
            return this.as("years");
        }, l;
    }(), p = function(t, s, n) {
        return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
    return function(n, i, e) {
        t = e, s = e().$utils(), e.duration = function(t, s) {
            var n = e.locale();
            return f(t, {
                $l: n
            }, s);
        }, e.isDuration = c;
        var r = i.prototype.add, o = i.prototype.subtract;
        i.prototype.add = function(t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function(t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
    };
});

});

parcelRegister("5Ycxa", function(module, exports) {

$parcel$export(module.exports, "streamDayKey", () => $458c474e15dbdca4$export$4a7006825d11eb6f);
$parcel$export(module.exports, "currentStreamDayKey", () => $458c474e15dbdca4$export$2fab88d2251a140a);
$parcel$export(module.exports, "now", () => $458c474e15dbdca4$export$461939dd4422153);
// The marathon runs past midnight: a 00:04 run belongs to the night that started the
// previous evening. Shifting 6h back makes the Rome-local calendar date the stream day.
const $458c474e15dbdca4$export$dde423b32400664d = 6;
function $458c474e15dbdca4$export$4a7006825d11eb6f(date) {
    const shifted = new Date(new Date(date).getTime() - $458c474e15dbdca4$export$dde423b32400664d * 3600000);
    return shifted.toLocaleDateString('en-CA', {
        timeZone: 'Europe/Rome'
    });
}
function $458c474e15dbdca4$export$2fab88d2251a140a() {
    return new URLSearchParams(window.location.search).get('date') || $458c474e15dbdca4$export$4a7006825d11eb6f(new Date());
}
function $458c474e15dbdca4$export$461939dd4422153() {
    const override = new URLSearchParams(window.location.search).get('date');
    if (!override) return new Date();
    const todayKey = new Date().toLocaleDateString('en-CA', {
        timeZone: 'Europe/Rome'
    });
    const diffDays = Math.round((new Date(override) - new Date(todayKey)) / 86400000);
    return new Date(Date.now() + diffDays * 86400000);
}

});

parcelRegister("72w2x", function(module, exports) {

$parcel$export(module.exports, "orderTimeslots", () => $520192c998cbd54b$export$896e0a64905dded8);
$parcel$export(module.exports, "getStartDate", () => $520192c998cbd54b$export$3ee8fbdbeceaef0e);
$parcel$export(module.exports, "getRunStartDate", () => $520192c998cbd54b$export$ceab48c8fcb84fe8);
/**
 * Reading a `timeslots[]` array the way fungus means it.
 *
 * Both the overlay (`js/data/schedule.js`) and the reveal pages (`js/reveal-shared.js`)
 * need these, and both used to carry their own copy — with a comment in each pointing at
 * the other. One copy now: the two disagreeing is exactly the bug that produces a
 * schedule that is right on one page and wrong on the next.
 */ /**
 * Timeslots are a **linked list**, not an ordered array: the head has
 * `previous_timeslot_id: null`, and the next slot is whichever one points back at the
 * current id. Never sort by id or by date — the API returns them by primary key, and a
 * slot moved in the admin keeps its id.
 *
 * Slots unreachable from the head (a dangling `previous_timeslot_id`) would otherwise
 * vanish, so they are appended at the end. `onOrphans` gets them when there are any; the
 * overlay logs a warning, the reveal pages stay quiet.
 */ function $520192c998cbd54b$export$896e0a64905dded8(timeslots, onOrphans) {
    const byPrevious = new Map(timeslots.map((t)=>{
        var _t_previous_timeslot_id;
        return [
            (_t_previous_timeslot_id = t.previous_timeslot_id) !== null && _t_previous_timeslot_id !== void 0 ? _t_previous_timeslot_id : null,
            t
        ];
    }));
    const ordered = [];
    const seen = new Set();
    let node = byPrevious.get(null);
    while(node && !seen.has(node.id)){
        seen.add(node.id);
        ordered.push(node);
        node = byPrevious.get(node.id);
    }
    const orphans = timeslots.filter((t)=>!seen.has(t.id));
    if (orphans.length && onOrphans) onOrphans(orphans);
    return ordered.concat(orphans);
}
const $520192c998cbd54b$export$3ee8fbdbeceaef0e = (timeslot)=>{
    var _timeslot_projected_start, _ref;
    return (_ref = (_timeslot_projected_start = timeslot === null || timeslot === void 0 ? void 0 : timeslot.projected_start) !== null && _timeslot_projected_start !== void 0 ? _timeslot_projected_start : timeslot === null || timeslot === void 0 ? void 0 : timeslot.start_date) !== null && _ref !== void 0 ? _ref : timeslot === null || timeslot === void 0 ? void 0 : timeslot.date;
};
const $520192c998cbd54b$export$ceab48c8fcb84fe8 = (timeslot)=>{
    const slotStart = $520192c998cbd54b$export$3ee8fbdbeceaef0e(timeslot);
    if (!slotStart) return slotStart;
    var _timeslot_setup_time;
    return new Date(new Date(slotStart).getTime() + ((_timeslot_setup_time = timeslot.setup_time) !== null && _timeslot_setup_time !== void 0 ? _timeslot_setup_time : 0) * 1000);
};

});

parcelRegister("aoyP8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $04af84c5bea1b5af$export$2e2bcd8739ae039);
$parcel$export(module.exports, "create", () => $04af84c5bea1b5af$export$185802fd694ee1f5);
// canvas-confetti v1.9.4 built on 2025-10-25T05:14:56.640Z
var $04af84c5bea1b5af$var$module = {};
// source content
/* globals Map */ (function main(global, module, isWorker, workerSize) {
    var canUseWorker = !!(global.Worker && global.Blob && global.Promise && global.OffscreenCanvas && global.OffscreenCanvasRenderingContext2D && global.HTMLCanvasElement && global.HTMLCanvasElement.prototype.transferControlToOffscreen && global.URL && global.URL.createObjectURL);
    var canUsePaths = typeof Path2D === 'function' && typeof DOMMatrix === 'function';
    var canDrawBitmap = function() {
        // this mostly supports ssr
        if (!global.OffscreenCanvas) return false;
        try {
            var canvas = new OffscreenCanvas(1, 1);
            var ctx = canvas.getContext('2d');
            ctx.fillRect(0, 0, 1, 1);
            var bitmap = canvas.transferToImageBitmap();
            ctx.createPattern(bitmap, 'no-repeat');
        } catch (e) {
            return false;
        }
        return true;
    }();
    function noop() {}
    // create a promise if it exists, otherwise, just
    // call the function directly
    function promise(func) {
        var ModulePromise = module.exports.Promise;
        var Prom = ModulePromise !== void 0 ? ModulePromise : global.Promise;
        if (typeof Prom === 'function') return new Prom(func);
        func(noop, noop);
        return null;
    }
    var bitmapMapper = function(skipTransform, map) {
        // see https://github.com/catdad/canvas-confetti/issues/209
        // creating canvases is actually pretty expensive, so we should create a
        // 1:1 map for bitmap:canvas, so that we can animate the confetti in
        // a performant manner, but also not store them forever so that we don't
        // have a memory leak
        return {
            transform: function(bitmap) {
                if (skipTransform) return bitmap;
                if (map.has(bitmap)) return map.get(bitmap);
                var canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
                var ctx = canvas.getContext('2d');
                ctx.drawImage(bitmap, 0, 0);
                map.set(bitmap, canvas);
                return canvas;
            },
            clear: function() {
                map.clear();
            }
        };
    }(canDrawBitmap, new Map());
    var raf = function() {
        var TIME = Math.floor(1000 / 60);
        var frame, cancel;
        var frames = {};
        var lastFrameTime = 0;
        if (typeof requestAnimationFrame === 'function' && typeof cancelAnimationFrame === 'function') {
            frame = function(cb) {
                var id = Math.random();
                frames[id] = requestAnimationFrame(function onFrame(time) {
                    if (lastFrameTime === time || lastFrameTime + TIME - 1 < time) {
                        lastFrameTime = time;
                        delete frames[id];
                        cb();
                    } else frames[id] = requestAnimationFrame(onFrame);
                });
                return id;
            };
            cancel = function(id) {
                if (frames[id]) cancelAnimationFrame(frames[id]);
            };
        } else {
            frame = function(cb) {
                return setTimeout(cb, TIME);
            };
            cancel = function(timer) {
                return clearTimeout(timer);
            };
        }
        return {
            frame: frame,
            cancel: cancel
        };
    }();
    var getWorker = function() {
        var worker;
        var prom;
        var resolves = {};
        function decorate(worker) {
            function execute(options, callback) {
                worker.postMessage({
                    options: options || {},
                    callback: callback
                });
            }
            worker.init = function initWorker(canvas) {
                var offscreen = canvas.transferControlToOffscreen();
                worker.postMessage({
                    canvas: offscreen
                }, [
                    offscreen
                ]);
            };
            worker.fire = function fireWorker(options, size, done) {
                if (prom) {
                    execute(options, null);
                    return prom;
                }
                var id = Math.random().toString(36).slice(2);
                prom = promise(function(resolve) {
                    function workerDone(msg) {
                        if (msg.data.callback !== id) return;
                        delete resolves[id];
                        worker.removeEventListener('message', workerDone);
                        prom = null;
                        bitmapMapper.clear();
                        done();
                        resolve();
                    }
                    worker.addEventListener('message', workerDone);
                    execute(options, id);
                    resolves[id] = workerDone.bind(null, {
                        data: {
                            callback: id
                        }
                    });
                });
                return prom;
            };
            worker.reset = function resetWorker() {
                worker.postMessage({
                    reset: true
                });
                for(var id in resolves){
                    resolves[id]();
                    delete resolves[id];
                }
            };
        }
        return function() {
            if (worker) return worker;
            if (!isWorker && canUseWorker) {
                var code = [
                    'var CONFETTI, SIZE = {}, module = {};',
                    '(' + main.toString() + ')(this, module, true, SIZE);',
                    'onmessage = function(msg) {',
                    '  if (msg.data.options) {',
                    '    CONFETTI(msg.data.options).then(function () {',
                    '      if (msg.data.callback) {',
                    '        postMessage({ callback: msg.data.callback });',
                    '      }',
                    '    });',
                    '  } else if (msg.data.reset) {',
                    '    CONFETTI && CONFETTI.reset();',
                    '  } else if (msg.data.resize) {',
                    '    SIZE.width = msg.data.resize.width;',
                    '    SIZE.height = msg.data.resize.height;',
                    '  } else if (msg.data.canvas) {',
                    '    SIZE.width = msg.data.canvas.width;',
                    '    SIZE.height = msg.data.canvas.height;',
                    '    CONFETTI = module.exports.create(msg.data.canvas);',
                    '  }',
                    '}'
                ].join('\n');
                try {
                    worker = new Worker(URL.createObjectURL(new Blob([
                        code
                    ])));
                } catch (e) {
                    // eslint-disable-next-line no-console
                    typeof console !== 'undefined' && typeof console.warn === 'function' && console.warn("\uD83C\uDF8A Could not load worker", e);
                    return null;
                }
                decorate(worker);
            }
            return worker;
        };
    }();
    var defaults = {
        particleCount: 50,
        angle: 90,
        spread: 45,
        startVelocity: 45,
        decay: 0.9,
        gravity: 1,
        drift: 0,
        ticks: 200,
        x: 0.5,
        y: 0.5,
        shapes: [
            'square',
            'circle'
        ],
        zIndex: 100,
        colors: [
            '#26ccff',
            '#a25afd',
            '#ff5e7e',
            '#88ff5a',
            '#fcff42',
            '#ffa62d',
            '#ff36ff'
        ],
        // probably should be true, but back-compat
        disableForReducedMotion: false,
        scalar: 1
    };
    function convert(val, transform) {
        return transform ? transform(val) : val;
    }
    function isOk(val) {
        return !(val === null || val === undefined);
    }
    function prop(options, name, transform) {
        return convert(options && isOk(options[name]) ? options[name] : defaults[name], transform);
    }
    function onlyPositiveInt(number) {
        return number < 0 ? 0 : Math.floor(number);
    }
    function randomInt(min, max) {
        // [min, max)
        return Math.floor(Math.random() * (max - min)) + min;
    }
    function toDecimal(str) {
        return parseInt(str, 16);
    }
    function colorsToRgb(colors) {
        return colors.map(hexToRgb);
    }
    function hexToRgb(str) {
        var val = String(str).replace(/[^0-9a-f]/gi, '');
        if (val.length < 6) val = val[0] + val[0] + val[1] + val[1] + val[2] + val[2];
        return {
            r: toDecimal(val.substring(0, 2)),
            g: toDecimal(val.substring(2, 4)),
            b: toDecimal(val.substring(4, 6))
        };
    }
    function getOrigin(options) {
        var origin = prop(options, 'origin', Object);
        origin.x = prop(origin, 'x', Number);
        origin.y = prop(origin, 'y', Number);
        return origin;
    }
    function setCanvasWindowSize(canvas) {
        canvas.width = document.documentElement.clientWidth;
        canvas.height = document.documentElement.clientHeight;
    }
    function setCanvasRectSize(canvas) {
        var rect = canvas.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;
    }
    function getCanvas(zIndex) {
        var canvas = document.createElement('canvas');
        canvas.style.position = 'fixed';
        canvas.style.top = '0px';
        canvas.style.left = '0px';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = zIndex;
        return canvas;
    }
    function ellipse(context, x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
        context.save();
        context.translate(x, y);
        context.rotate(rotation);
        context.scale(radiusX, radiusY);
        context.arc(0, 0, 1, startAngle, endAngle, antiClockwise);
        context.restore();
    }
    function randomPhysics(opts) {
        var radAngle = opts.angle * (Math.PI / 180);
        var radSpread = opts.spread * (Math.PI / 180);
        return {
            x: opts.x,
            y: opts.y,
            wobble: Math.random() * 10,
            wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
            velocity: opts.startVelocity * 0.5 + Math.random() * opts.startVelocity,
            angle2D: -radAngle + (0.5 * radSpread - Math.random() * radSpread),
            tiltAngle: (Math.random() * 0.5 + 0.25) * Math.PI,
            color: opts.color,
            shape: opts.shape,
            tick: 0,
            totalTicks: opts.ticks,
            decay: opts.decay,
            drift: opts.drift,
            random: Math.random() + 2,
            tiltSin: 0,
            tiltCos: 0,
            wobbleX: 0,
            wobbleY: 0,
            gravity: opts.gravity * 3,
            ovalScalar: 0.6,
            scalar: opts.scalar,
            flat: opts.flat
        };
    }
    function updateFetti(context, fetti) {
        fetti.x += Math.cos(fetti.angle2D) * fetti.velocity + fetti.drift;
        fetti.y += Math.sin(fetti.angle2D) * fetti.velocity + fetti.gravity;
        fetti.velocity *= fetti.decay;
        if (fetti.flat) {
            fetti.wobble = 0;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar;
            fetti.wobbleY = fetti.y + 10 * fetti.scalar;
            fetti.tiltSin = 0;
            fetti.tiltCos = 0;
            fetti.random = 1;
        } else {
            fetti.wobble += fetti.wobbleSpeed;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar * Math.cos(fetti.wobble);
            fetti.wobbleY = fetti.y + 10 * fetti.scalar * Math.sin(fetti.wobble);
            fetti.tiltAngle += 0.1;
            fetti.tiltSin = Math.sin(fetti.tiltAngle);
            fetti.tiltCos = Math.cos(fetti.tiltAngle);
            fetti.random = Math.random() + 2;
        }
        var progress = fetti.tick++ / fetti.totalTicks;
        var x1 = fetti.x + fetti.random * fetti.tiltCos;
        var y1 = fetti.y + fetti.random * fetti.tiltSin;
        var x2 = fetti.wobbleX + fetti.random * fetti.tiltCos;
        var y2 = fetti.wobbleY + fetti.random * fetti.tiltSin;
        context.fillStyle = 'rgba(' + fetti.color.r + ', ' + fetti.color.g + ', ' + fetti.color.b + ', ' + (1 - progress) + ')';
        context.beginPath();
        if (canUsePaths && fetti.shape.type === 'path' && typeof fetti.shape.path === 'string' && Array.isArray(fetti.shape.matrix)) context.fill(transformPath2D(fetti.shape.path, fetti.shape.matrix, fetti.x, fetti.y, Math.abs(x2 - x1) * 0.1, Math.abs(y2 - y1) * 0.1, Math.PI / 10 * fetti.wobble));
        else if (fetti.shape.type === 'bitmap') {
            var rotation = Math.PI / 10 * fetti.wobble;
            var scaleX = Math.abs(x2 - x1) * 0.1;
            var scaleY = Math.abs(y2 - y1) * 0.1;
            var width = fetti.shape.bitmap.width * fetti.scalar;
            var height = fetti.shape.bitmap.height * fetti.scalar;
            var matrix = new DOMMatrix([
                Math.cos(rotation) * scaleX,
                Math.sin(rotation) * scaleX,
                -Math.sin(rotation) * scaleY,
                Math.cos(rotation) * scaleY,
                fetti.x,
                fetti.y
            ]);
            // apply the transform matrix from the confetti shape
            matrix.multiplySelf(new DOMMatrix(fetti.shape.matrix));
            var pattern = context.createPattern(bitmapMapper.transform(fetti.shape.bitmap), 'no-repeat');
            pattern.setTransform(matrix);
            context.globalAlpha = 1 - progress;
            context.fillStyle = pattern;
            context.fillRect(fetti.x - width / 2, fetti.y - height / 2, width, height);
            context.globalAlpha = 1;
        } else if (fetti.shape === 'circle') context.ellipse ? context.ellipse(fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI) : ellipse(context, fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI);
        else if (fetti.shape === 'star') {
            var rot = Math.PI / 2 * 3;
            var innerRadius = 4 * fetti.scalar;
            var outerRadius = 8 * fetti.scalar;
            var x = fetti.x;
            var y = fetti.y;
            var spikes = 5;
            var step = Math.PI / spikes;
            while(spikes--){
                x = fetti.x + Math.cos(rot) * outerRadius;
                y = fetti.y + Math.sin(rot) * outerRadius;
                context.lineTo(x, y);
                rot += step;
                x = fetti.x + Math.cos(rot) * innerRadius;
                y = fetti.y + Math.sin(rot) * innerRadius;
                context.lineTo(x, y);
                rot += step;
            }
        } else {
            context.moveTo(Math.floor(fetti.x), Math.floor(fetti.y));
            context.lineTo(Math.floor(fetti.wobbleX), Math.floor(y1));
            context.lineTo(Math.floor(x2), Math.floor(y2));
            context.lineTo(Math.floor(x1), Math.floor(fetti.wobbleY));
        }
        context.closePath();
        context.fill();
        return fetti.tick < fetti.totalTicks;
    }
    function animate(canvas, fettis, resizer, size, done) {
        var animatingFettis = fettis.slice();
        var context = canvas.getContext('2d');
        var animationFrame;
        var destroy;
        var prom = promise(function(resolve) {
            function onDone() {
                animationFrame = destroy = null;
                context.clearRect(0, 0, size.width, size.height);
                bitmapMapper.clear();
                done();
                resolve();
            }
            function update() {
                if (isWorker && !(size.width === workerSize.width && size.height === workerSize.height)) {
                    size.width = canvas.width = workerSize.width;
                    size.height = canvas.height = workerSize.height;
                }
                if (!size.width && !size.height) {
                    resizer(canvas);
                    size.width = canvas.width;
                    size.height = canvas.height;
                }
                context.clearRect(0, 0, size.width, size.height);
                animatingFettis = animatingFettis.filter(function(fetti) {
                    return updateFetti(context, fetti);
                });
                if (animatingFettis.length) animationFrame = raf.frame(update);
                else onDone();
            }
            animationFrame = raf.frame(update);
            destroy = onDone;
        });
        return {
            addFettis: function(fettis) {
                animatingFettis = animatingFettis.concat(fettis);
                return prom;
            },
            canvas: canvas,
            promise: prom,
            reset: function() {
                if (animationFrame) raf.cancel(animationFrame);
                if (destroy) destroy();
            }
        };
    }
    function confettiCannon(canvas, globalOpts) {
        var isLibCanvas = !canvas;
        var allowResize = !!prop(globalOpts || {}, 'resize');
        var hasResizeEventRegistered = false;
        var globalDisableForReducedMotion = prop(globalOpts, 'disableForReducedMotion', Boolean);
        var shouldUseWorker = canUseWorker && !!prop(globalOpts || {}, 'useWorker');
        var worker = shouldUseWorker ? getWorker() : null;
        var resizer = isLibCanvas ? setCanvasWindowSize : setCanvasRectSize;
        var initialized = canvas && worker ? !!canvas.__confetti_initialized : false;
        var preferLessMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion)').matches;
        var animationObj;
        function fireLocal(options, size, done) {
            var particleCount = prop(options, 'particleCount', onlyPositiveInt);
            var angle = prop(options, 'angle', Number);
            var spread = prop(options, 'spread', Number);
            var startVelocity = prop(options, 'startVelocity', Number);
            var decay = prop(options, 'decay', Number);
            var gravity = prop(options, 'gravity', Number);
            var drift = prop(options, 'drift', Number);
            var colors = prop(options, 'colors', colorsToRgb);
            var ticks = prop(options, 'ticks', Number);
            var shapes = prop(options, 'shapes');
            var scalar = prop(options, 'scalar');
            var flat = !!prop(options, 'flat');
            var origin = getOrigin(options);
            var temp = particleCount;
            var fettis = [];
            var startX = canvas.width * origin.x;
            var startY = canvas.height * origin.y;
            while(temp--)fettis.push(randomPhysics({
                x: startX,
                y: startY,
                angle: angle,
                spread: spread,
                startVelocity: startVelocity,
                color: colors[temp % colors.length],
                shape: shapes[randomInt(0, shapes.length)],
                ticks: ticks,
                decay: decay,
                gravity: gravity,
                drift: drift,
                scalar: scalar,
                flat: flat
            }));
            // if we have a previous canvas already animating,
            // add to it
            if (animationObj) return animationObj.addFettis(fettis);
            animationObj = animate(canvas, fettis, resizer, size, done);
            return animationObj.promise;
        }
        function fire(options) {
            var disableForReducedMotion = globalDisableForReducedMotion || prop(options, 'disableForReducedMotion', Boolean);
            var zIndex = prop(options, 'zIndex', Number);
            if (disableForReducedMotion && preferLessMotion) return promise(function(resolve) {
                resolve();
            });
            if (isLibCanvas && animationObj) // use existing canvas from in-progress animation
            canvas = animationObj.canvas;
            else if (isLibCanvas && !canvas) {
                // create and initialize a new canvas
                canvas = getCanvas(zIndex);
                document.body.appendChild(canvas);
            }
            if (allowResize && !initialized) // initialize the size of a user-supplied canvas
            resizer(canvas);
            var size = {
                width: canvas.width,
                height: canvas.height
            };
            if (worker && !initialized) worker.init(canvas);
            initialized = true;
            if (worker) canvas.__confetti_initialized = true;
            function onResize() {
                if (worker) {
                    // TODO this really shouldn't be immediate, because it is expensive
                    var obj = {
                        getBoundingClientRect: function() {
                            if (!isLibCanvas) return canvas.getBoundingClientRect();
                        }
                    };
                    resizer(obj);
                    worker.postMessage({
                        resize: {
                            width: obj.width,
                            height: obj.height
                        }
                    });
                    return;
                }
                // don't actually query the size here, since this
                // can execute frequently and rapidly
                size.width = size.height = null;
            }
            function done() {
                animationObj = null;
                if (allowResize) {
                    hasResizeEventRegistered = false;
                    global.removeEventListener('resize', onResize);
                }
                if (isLibCanvas && canvas) {
                    if (document.body.contains(canvas)) document.body.removeChild(canvas);
                    canvas = null;
                    initialized = false;
                }
            }
            if (allowResize && !hasResizeEventRegistered) {
                hasResizeEventRegistered = true;
                global.addEventListener('resize', onResize, false);
            }
            if (worker) return worker.fire(options, size, done);
            return fireLocal(options, size, done);
        }
        fire.reset = function() {
            if (worker) worker.reset();
            if (animationObj) animationObj.reset();
        };
        return fire;
    }
    // Make default export lazy to defer worker creation until called.
    var defaultFire;
    function getDefaultFire() {
        if (!defaultFire) defaultFire = confettiCannon(null, {
            useWorker: true,
            resize: true
        });
        return defaultFire;
    }
    function transformPath2D(pathString, pathMatrix, x, y, scaleX, scaleY, rotation) {
        var path2d = new Path2D(pathString);
        var t1 = new Path2D();
        t1.addPath(path2d, new DOMMatrix(pathMatrix));
        var t2 = new Path2D();
        // see https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix/DOMMatrix
        t2.addPath(t1, new DOMMatrix([
            Math.cos(rotation) * scaleX,
            Math.sin(rotation) * scaleX,
            -Math.sin(rotation) * scaleY,
            Math.cos(rotation) * scaleY,
            x,
            y
        ]));
        return t2;
    }
    function shapeFromPath(pathData) {
        if (!canUsePaths) throw new Error('path confetti are not supported in this browser');
        var path, matrix;
        if (typeof pathData === 'string') path = pathData;
        else {
            path = pathData.path;
            matrix = pathData.matrix;
        }
        var path2d = new Path2D(path);
        var tempCanvas = document.createElement('canvas');
        var tempCtx = tempCanvas.getContext('2d');
        if (!matrix) {
            // attempt to figure out the width of the path, up to 1000x1000
            var maxSize = 1000;
            var minX = maxSize;
            var minY = maxSize;
            var maxX = 0;
            var maxY = 0;
            var width, height;
            // do some line skipping... this is faster than checking
            // every pixel and will be mostly still correct
            for(var x = 0; x < maxSize; x += 2){
                for(var y = 0; y < maxSize; y += 2)if (tempCtx.isPointInPath(path2d, x, y, 'nonzero')) {
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
            width = maxX - minX;
            height = maxY - minY;
            var maxDesiredSize = 10;
            var scale = Math.min(maxDesiredSize / width, maxDesiredSize / height);
            matrix = [
                scale,
                0,
                0,
                scale,
                -Math.round(width / 2 + minX) * scale,
                -Math.round(height / 2 + minY) * scale
            ];
        }
        return {
            type: 'path',
            path: path,
            matrix: matrix
        };
    }
    function shapeFromText(textData) {
        var text, scalar = 1, color = '#000000', // see https://nolanlawson.com/2022/04/08/the-struggle-of-using-native-emoji-on-the-web/
        fontFamily = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';
        if (typeof textData === 'string') text = textData;
        else {
            text = textData.text;
            scalar = 'scalar' in textData ? textData.scalar : scalar;
            fontFamily = 'fontFamily' in textData ? textData.fontFamily : fontFamily;
            color = 'color' in textData ? textData.color : color;
        }
        // all other confetti are 10 pixels,
        // so this pixel size is the de-facto 100% scale confetti
        var fontSize = 10 * scalar;
        var font = '' + fontSize + 'px ' + fontFamily;
        var canvas = new OffscreenCanvas(fontSize, fontSize);
        var ctx = canvas.getContext('2d');
        ctx.font = font;
        var size = ctx.measureText(text);
        var width = Math.ceil(size.actualBoundingBoxRight + size.actualBoundingBoxLeft);
        var height = Math.ceil(size.actualBoundingBoxAscent + size.actualBoundingBoxDescent);
        var padding = 2;
        var x = size.actualBoundingBoxLeft + padding;
        var y = size.actualBoundingBoxAscent + padding;
        width += padding + padding;
        height += padding + padding;
        canvas = new OffscreenCanvas(width, height);
        ctx = canvas.getContext('2d');
        ctx.font = font;
        ctx.fillStyle = color;
        ctx.fillText(text, x, y);
        var scale = 1 / scalar;
        return {
            type: 'bitmap',
            // TODO these probably need to be transfered for workers
            bitmap: canvas.transferToImageBitmap(),
            matrix: [
                scale,
                0,
                0,
                scale,
                -width * scale / 2,
                -height * scale / 2
            ]
        };
    }
    module.exports = function() {
        return getDefaultFire().apply(this, arguments);
    };
    module.exports.reset = function() {
        getDefaultFire().reset();
    };
    module.exports.create = confettiCannon;
    module.exports.shapeFromPath = shapeFromPath;
    module.exports.shapeFromText = shapeFromText;
})(function() {
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    return this || {};
}(), $04af84c5bea1b5af$var$module, false);
var // end source content
$04af84c5bea1b5af$export$2e2bcd8739ae039 = $04af84c5bea1b5af$var$module.exports;
var $04af84c5bea1b5af$export$185802fd694ee1f5 = $04af84c5bea1b5af$var$module.exports.create;

});

parcelRegister("18ZYM", function(module, exports) {
!function(r, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});

});

var $586fb3a4d38b3e6e$exports = {};
$parcel$extendImportMap({
    "ae4u6": "icon_twitch.274c70b5.png",
    "f4APE": "icon_youtube.6732739e.png"
});

parcelRequire("bHJE2");
const $cd2554817816328b$var$mainApiUrl = "https://fungos-api.italianspeedruncommunity.com";
const $cd2554817816328b$var$fungusApiEndpoint = `${$cd2554817816328b$var$mainApiUrl}/api`;
const $cd2554817816328b$var$queryStringForEvent = window.location.search;
const $cd2554817816328b$var$urlParamsForEvent = new URLSearchParams($cd2554817816328b$var$queryStringForEvent);
const $cd2554817816328b$var$eventId = $cd2554817816328b$var$urlParamsForEvent.get('eventId') || 5;
function $cd2554817816328b$export$ca16cda1b94a8e08(subscribers, label) {
    subscribers.forEach((subscriber)=>{
        try {
            subscriber();
        } catch (error) {
            console.error(`${label} subscriber "${subscriber.name || 'anonymous'}" threw:`, error);
        }
    });
}
let $cd2554817816328b$export$28cf49ad70f82d12 = {
    offsetWriterToken: "5|VdQo5Hqs3jp5rL1PPvJLOgZXF3xYgr4E000DIr7L4b026cb9",
    eventWriteEndpoint: `${$cd2554817816328b$var$fungusApiEndpoint}`,
    apiEndpoint: $cd2554817816328b$var$fungusApiEndpoint,
    liveDataEndpoint: `${$cd2554817816328b$var$fungusApiEndpoint}/events/${$cd2554817816328b$var$eventId}/live`,
    chatDataEndpoint: `${$cd2554817816328b$var$fungusApiEndpoint}/events/${$cd2554817816328b$var$eventId}/chat`,
    adsEndpoint: `${$cd2554817816328b$var$fungusApiEndpoint}/twitch/ads`,
    shoutoutEndpoint: `${$cd2554817816328b$var$fungusApiEndpoint}/twitch/shoutout`,
    liveEventData: [],
    gufDonationData: [],
    incentives: [],
    toCallWhenReady: [],
    toCallWhenUpdated: [],
    firstInit: true,
    shouldSendAds: false,
    adSendingTimeout: null,
    fetchGufInfo: async ()=>{
        try {
            fetch($cd2554817816328b$export$28cf49ad70f82d12.liveDataEndpoint, {
                method: "GET",
                headers: {
                    "Accept": "application/json"
                }
            }).then(async (response)=>{
                const responseCode = response.status;
                if (responseCode !== 200) {
                    console.error("Failed to fetch event info:", response);
                    return;
                }
                const responseJson = await response.json();
                $cd2554817816328b$export$28cf49ad70f82d12.liveEventData = responseJson.data;
                if ($cd2554817816328b$export$28cf49ad70f82d12.firstInit) {
                    $cd2554817816328b$export$ca16cda1b94a8e08($cd2554817816328b$export$28cf49ad70f82d12.toCallWhenReady, 'callWhenReady');
                    $cd2554817816328b$export$28cf49ad70f82d12.firstInit = false;
                }
                $cd2554817816328b$export$ca16cda1b94a8e08($cd2554817816328b$export$28cf49ad70f82d12.toCallWhenUpdated, 'callWhenUpdated');
            });
        } catch (error) {
            console.error(error);
        }
    },
    getTotalDonationOffset: ()=>{
        var _live_liveEventData_live, _live_liveEventData;
        return Number((_live_liveEventData = $cd2554817816328b$export$28cf49ad70f82d12.liveEventData) === null || _live_liveEventData === void 0 ? void 0 : (_live_liveEventData_live = _live_liveEventData.live) === null || _live_liveEventData_live === void 0 ? void 0 : _live_liveEventData_live.donation_offset) || 0;
    },
    getDonationData: ()=>{
        var _live_liveEventData;
        var _live_liveEventData_donations;
        return (_live_liveEventData_donations = (_live_liveEventData = $cd2554817816328b$export$28cf49ad70f82d12.liveEventData) === null || _live_liveEventData === void 0 ? void 0 : _live_liveEventData.donations) !== null && _live_liveEventData_donations !== void 0 ? _live_liveEventData_donations : [];
    },
    getBidWarParents: ()=>{
        var _live_getDonationData_bids, _live_getDonationData;
        var _live_getDonationData_bids_filter;
        return (_live_getDonationData_bids_filter = (_live_getDonationData = $cd2554817816328b$export$28cf49ad70f82d12.getDonationData()) === null || _live_getDonationData === void 0 ? void 0 : (_live_getDonationData_bids = _live_getDonationData.bids) === null || _live_getDonationData_bids === void 0 ? void 0 : _live_getDonationData_bids.filter((bid)=>bid.type === 'bidwar' && bid.parent_id === null)) !== null && _live_getDonationData_bids_filter !== void 0 ? _live_getDonationData_bids_filter : [];
    },
    getFixedBids: ()=>{
        var _live_getDonationData_bids, _live_getDonationData;
        var _live_getDonationData_bids_filter;
        return (_live_getDonationData_bids_filter = (_live_getDonationData = $cd2554817816328b$export$28cf49ad70f82d12.getDonationData()) === null || _live_getDonationData === void 0 ? void 0 : (_live_getDonationData_bids = _live_getDonationData.bids) === null || _live_getDonationData_bids === void 0 ? void 0 : _live_getDonationData_bids.filter((bid)=>bid.type === 'fixed')) !== null && _live_getDonationData_bids_filter !== void 0 ? _live_getDonationData_bids_filter : [];
    },
    getBidWars: ()=>{
        var _live_getDonationData_bids, _live_getDonationData;
        var _live_getDonationData_bids_filter;
        return (_live_getDonationData_bids_filter = (_live_getDonationData = $cd2554817816328b$export$28cf49ad70f82d12.getDonationData()) === null || _live_getDonationData === void 0 ? void 0 : (_live_getDonationData_bids = _live_getDonationData.bids) === null || _live_getDonationData_bids === void 0 ? void 0 : _live_getDonationData_bids.filter((bid)=>bid.type === 'bidwar')) !== null && _live_getDonationData_bids_filter !== void 0 ? _live_getDonationData_bids_filter : [];
    },
    // The API serialises the total as a string ("285.00"). Without Number() the
    // offset is string-concatenated instead of added ("285.00" + 100 = "285.00100"),
    // which Intl.NumberFormat then silently renders back as 285,00 €.
    getTotalDonation: ()=>{
        var _live_getDonationData;
        return Number((_live_getDonationData = $cd2554817816328b$export$28cf49ad70f82d12.getDonationData()) === null || _live_getDonationData === void 0 ? void 0 : _live_getDonationData.total) || 0;
    },
    getTotalDonationsWithOffset: ()=>{
        const totalDonation = $cd2554817816328b$export$28cf49ad70f82d12.getTotalDonation() + $cd2554817816328b$export$28cf49ad70f82d12.getTotalDonationOffset();
        if (totalDonation <= 0) return 0;
        return totalDonation;
    },
    /** TOP DONATORI: each donor and their summed total, highest first. Three at most. */ getDonatorsLeaderboard: ()=>{
        var _live_getDonationData_top_donors, _live_getDonationData;
        var _live_getDonationData_top_donors_map;
        return (_live_getDonationData_top_donors_map = (_live_getDonationData = $cd2554817816328b$export$28cf49ad70f82d12.getDonationData()) === null || _live_getDonationData === void 0 ? void 0 : (_live_getDonationData_top_donors = _live_getDonationData.top_donors) === null || _live_getDonationData_top_donors === void 0 ? void 0 : _live_getDonationData_top_donors.map((donation)=>({
                name: donation.name,
                total: donation.amount_sum
            }))) !== null && _live_getDonationData_top_donors_map !== void 0 ? _live_getDonationData_top_donors_map : [];
    },
    getDonationLeaderboard: ()=>{
        var _live_getDonationData_top_donations, _live_getDonationData;
        var _live_getDonationData_top_donations_map;
        let donationLeaderboard = (_live_getDonationData_top_donations_map = (_live_getDonationData = $cd2554817816328b$export$28cf49ad70f82d12.getDonationData()) === null || _live_getDonationData === void 0 ? void 0 : (_live_getDonationData_top_donations = _live_getDonationData.top_donations) === null || _live_getDonationData_top_donations === void 0 ? void 0 : _live_getDonationData_top_donations.map((donation)=>{
            var _donation_name;
            let filteredDonations = {
                name: (_donation_name = donation.name) !== null && _donation_name !== void 0 ? _donation_name : 'Anonimo',
                total: donation.amount
            };
            return filteredDonations;
        })) !== null && _live_getDonationData_top_donations_map !== void 0 ? _live_getDonationData_top_donations_map : [];
        return donationLeaderboard;
    },
    getInforollRows: ()=>{
        var _live_liveEventData_live, _live_liveEventData;
        return (_live_liveEventData = $cd2554817816328b$export$28cf49ad70f82d12.liveEventData) === null || _live_liveEventData === void 0 ? void 0 : (_live_liveEventData_live = _live_liveEventData.live) === null || _live_liveEventData_live === void 0 ? void 0 : _live_liveEventData_live.inforoll_text;
    },
    // Frozen mode is set per OBS source with ?frozen=true, not by the payload.
    getFreezeInforoll: ()=>new URLSearchParams(location.search).get('frozen') === 'true',
    // frozen_bgm_tracks carries artist/song; frozen_bgms (bare URLs) is the fallback.
    // Uploaded "Frozen BGMs" have no metadata, so artist/song can be null.
    getFreezeInforollMedia: ()=>{
        var _live_liveEventData;
        const l = (_live_liveEventData = $cd2554817816328b$export$28cf49ad70f82d12.liveEventData) === null || _live_liveEventData === void 0 ? void 0 : _live_liveEventData.live;
        var _l_frozen_bgms, _l_frozen_bgm_tracks;
        const tracks = (_l_frozen_bgm_tracks = l === null || l === void 0 ? void 0 : l.frozen_bgm_tracks) !== null && _l_frozen_bgm_tracks !== void 0 ? _l_frozen_bgm_tracks : ((_l_frozen_bgms = l === null || l === void 0 ? void 0 : l.frozen_bgms) !== null && _l_frozen_bgms !== void 0 ? _l_frozen_bgms : []).map((url)=>({
                url: url
            }));
        return tracks.map((t)=>({
                file_name: t.url,
                artist: t.artist || 'frozen media',
                song: t.song || 'frozen media'
            }));
    },
    getFrozenInforollText: ()=>{
        var _live_liveEventData_live, _live_liveEventData;
        var _live_liveEventData_live_frozen_inforoll_text;
        return (_live_liveEventData_live_frozen_inforoll_text = (_live_liveEventData = $cd2554817816328b$export$28cf49ad70f82d12.liveEventData) === null || _live_liveEventData === void 0 ? void 0 : (_live_liveEventData_live = _live_liveEventData.live) === null || _live_liveEventData_live === void 0 ? void 0 : _live_liveEventData_live.frozen_inforoll_text) !== null && _live_liveEventData_live_frozen_inforoll_text !== void 0 ? _live_liveEventData_live_frozen_inforoll_text : '';
    },
    getDonationReason: ()=>{
        var _live_liveEventData_live, _live_liveEventData;
        var _ref;
        return (_ref = "PER " + ((_live_liveEventData = $cd2554817816328b$export$28cf49ad70f82d12.liveEventData) === null || _live_liveEventData === void 0 ? void 0 : (_live_liveEventData_live = _live_liveEventData.live) === null || _live_liveEventData_live === void 0 ? void 0 : _live_liveEventData_live.donation_recipient)) !== null && _ref !== void 0 ? _ref : '';
    },
    getCurrentRun: ()=>{
        var _live_liveEventData;
        var _live_liveEventData_current_timeslot;
        return (_live_liveEventData_current_timeslot = (_live_liveEventData = $cd2554817816328b$export$28cf49ad70f82d12.liveEventData) === null || _live_liveEventData === void 0 ? void 0 : _live_liveEventData.current_timeslot) !== null && _live_liveEventData_current_timeslot !== void 0 ? _live_liveEventData_current_timeslot : [];
    },
    shouldShowLeaderboard: ()=>{
        var _live_liveEventData_live, _live_liveEventData;
        var _live_liveEventData_live_show_leaderboard;
        return (_live_liveEventData_live_show_leaderboard = (_live_liveEventData = $cd2554817816328b$export$28cf49ad70f82d12.liveEventData) === null || _live_liveEventData === void 0 ? void 0 : (_live_liveEventData_live = _live_liveEventData.live) === null || _live_liveEventData_live === void 0 ? void 0 : _live_liveEventData_live.show_leaderboard) !== null && _live_liveEventData_live_show_leaderboard !== void 0 ? _live_liveEventData_live_show_leaderboard : true;
    },
    getDonationGoalAmount: ()=>{
        var _live_liveEventData_live, _live_liveEventData;
        var _live_liveEventData_live_goal_amount;
        return (_live_liveEventData_live_goal_amount = (_live_liveEventData = $cd2554817816328b$export$28cf49ad70f82d12.liveEventData) === null || _live_liveEventData === void 0 ? void 0 : (_live_liveEventData_live = _live_liveEventData.live) === null || _live_liveEventData_live === void 0 ? void 0 : _live_liveEventData_live.goal_amount) !== null && _live_liveEventData_live_goal_amount !== void 0 ? _live_liveEventData_live_goal_amount : 0;
    },
    getDonationGoalFlair: ()=>{
        var _live_liveEventData_live, _live_liveEventData;
        var _live_liveEventData_live_goal_flair;
        return (_live_liveEventData_live_goal_flair = (_live_liveEventData = $cd2554817816328b$export$28cf49ad70f82d12.liveEventData) === null || _live_liveEventData === void 0 ? void 0 : (_live_liveEventData_live = _live_liveEventData.live) === null || _live_liveEventData_live === void 0 ? void 0 : _live_liveEventData_live.goal_flair) !== null && _live_liveEventData_live_goal_flair !== void 0 ? _live_liveEventData_live_goal_flair : '';
    },
    getDonationDeploySurprise: ()=>{
        return true;
    },
    getBreakScreenAds: ()=>{
        var _live_liveEventData_live, _live_liveEventData;
        var _live_liveEventData_live_media;
        return (_live_liveEventData_live_media = (_live_liveEventData = $cd2554817816328b$export$28cf49ad70f82d12.liveEventData) === null || _live_liveEventData === void 0 ? void 0 : (_live_liveEventData_live = _live_liveEventData.live) === null || _live_liveEventData_live === void 0 ? void 0 : _live_liveEventData_live.media) !== null && _live_liveEventData_live_media !== void 0 ? _live_liveEventData_live_media : [];
    },
    parseIncentives: ()=>{
        var _live_getFixedBids;
        $cd2554817816328b$export$28cf49ad70f82d12.incentives = [];
        (_live_getFixedBids = $cd2554817816328b$export$28cf49ad70f82d12.getFixedBids()) === null || _live_getFixedBids === void 0 ? void 0 : _live_getFixedBids.map((rawIncentive)=>{
            let incentive = [];
            incentive.type = 'fixed';
            incentive.name = rawIncentive.name;
            incentive.total = rawIncentive.amount_total;
            incentive.goal = rawIncentive.goal;
            var _rawIncentive_game_name;
            incentive.gameName = (_rawIncentive_game_name = rawIncentive.game_name) !== null && _rawIncentive_game_name !== void 0 ? _rawIncentive_game_name : '';
            var _rawIncentive_game_category;
            incentive.category = (_rawIncentive_game_category = rawIncentive.game_category) !== null && _rawIncentive_game_category !== void 0 ? _rawIncentive_game_category : '';
            $cd2554817816328b$export$28cf49ad70f82d12.incentives.push(incentive);
        });
        const optionIncentives = $cd2554817816328b$export$28cf49ad70f82d12.getBidWars();
        var _optionIncentives_map;
        let parentIds = (_optionIncentives_map = optionIncentives.map((i)=>i.parent_id)) !== null && _optionIncentives_map !== void 0 ? _optionIncentives_map : [];
        let unique = [];
        parentIds.map((i)=>unique[i] = i);
        unique = unique.filter(Number);
        unique.map((parentId)=>{
            let childrenIncentive = optionIncentives.filter((o)=>o.parent_id == parentId);
            let incentive = [];
            let parent = $cd2554817816328b$export$28cf49ad70f82d12.getBidWarParents().find((p)=>p.id == parentId);
            incentive.type = 'option';
            incentive.name = parent.name;
            incentive.total = parent.amount_total;
            var _parent_game_name;
            incentive.gameName = (_parent_game_name = parent.game_name) !== null && _parent_game_name !== void 0 ? _parent_game_name : '';
            var _parent_game_category;
            incentive.category = (_parent_game_category = parent.game_category) !== null && _parent_game_category !== void 0 ? _parent_game_category : '';
            incentive.options = [];
            childrenIncentive.map((childIncentive)=>{
                if (childIncentive.id == null) return;
                let innerIncentive = [];
                innerIncentive.id = childIncentive.id;
                const regex = /^(.*?) -.*$/ig;
                innerIncentive.name = childIncentive.name.replaceAll(regex, '$1');
                innerIncentive.total = Number(childIncentive.amount_total);
                incentive.options.push(innerIncentive);
            });
            incentive.options.sort((a, b)=>b.total - a.total);
            $cd2554817816328b$export$28cf49ad70f82d12.incentives.push(incentive);
        });
    },
    sendAds: ()=>{
        const response = fetch($cd2554817816328b$export$28cf49ad70f82d12.adsEndpoint, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${$cd2554817816328b$export$28cf49ad70f82d12.offsetWriterToken}`,
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).then((data)=>{
            console.log("Sent ads and got back:", data);
        });
    },
    sendShoutout: ()=>{
        const response = fetch($cd2554817816328b$export$28cf49ad70f82d12.shoutoutEndpoint, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${$cd2554817816328b$export$28cf49ad70f82d12.offsetWriterToken}`,
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).then((data)=>{
            console.log("Sent shoutout and got back:", data);
        });
    },
    callWhenReady: (fn)=>{
        $cd2554817816328b$export$28cf49ad70f82d12.toCallWhenReady.push(fn);
    },
    callWhenUpdated: (fn)=>{
        $cd2554817816328b$export$28cf49ad70f82d12.toCallWhenUpdated.push(fn);
    }
};
window.live = $cd2554817816328b$export$28cf49ad70f82d12;
// Deprecated alias: this module was called `strapi` when the backend was Strapi.
// Kept because staff type it into the devtools console on air.
window.strapi = $cd2554817816328b$export$28cf49ad70f82d12;
window.playBgm = false;
window.cake = false;
$cd2554817816328b$export$28cf49ad70f82d12.callWhenReady(function() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    window.cake = urlParams.get('cake') === 'true' || false;
    if (window.cake) console.log("The cake is a lie.");
    $cd2554817816328b$export$28cf49ad70f82d12.shouldSendAds = urlParams.get('sendAds') === 'true' || false;
    if ($cd2554817816328b$export$28cf49ad70f82d12.shouldSendAds) {
        $cd2554817816328b$export$28cf49ad70f82d12.adSendingTimeout = setTimeout($cd2554817816328b$export$28cf49ad70f82d12.sendAds, 10000);
        console.log("Sending ads in 10 seconds.");
    }
    const shouldSendShoutout = urlParams.get('sendShoutout') === 'true' || false;
    if (shouldSendShoutout) setTimeout(function() {
        $cd2554817816328b$export$28cf49ad70f82d12.sendShoutout();
        console.log("Sending shoutout.");
    }, 120000);
// ?bgm=true is wired by js/audio/jukebox.js, from init.
});




var $5Ycxa = parcelRequire("5Ycxa");

var $72w2x = parcelRequire("72w2x");

var $hIdhk = parcelRequire("hIdhk");

var $d0Ch3 = parcelRequire("d0Ch3");
$hIdhk.extend($d0Ch3);
var $5021709502222fe8$exports = {};
!function(e, i) {
    $5021709502222fe8$exports = i();
}($5021709502222fe8$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


$hIdhk.extend($5021709502222fe8$exports);
var $79875697e1136500$exports = {};
$79875697e1136500$exports = $parcel$resolve("ae4u6");


var $53823d6b0a7af858$exports = {};
$53823d6b0a7af858$exports = $parcel$resolve("f4APE");


let $19fa0b0de9ebfc4b$export$60974f670aa8d75e = {
    schedule: [],
    playingNow: undefined,
    currentGameIndex: -1,
    nextRun: undefined,
    next5: [],
    toCallOnRefresh: [],
    lastScheduleSignature: '',
    callWhenRefreshed: (fn)=>{
        $19fa0b0de9ebfc4b$export$60974f670aa8d75e.toCallOnRefresh.push(fn);
    },
    getTotalDonationsOffset: ()=>{
        return (0, $cd2554817816328b$export$28cf49ad70f82d12).getTotalDonationOffset();
    },
    // Runs on every /live poll: projected_start moves for every later slot the moment
    // staff close out the current one, so the derived schedule can never be cached.
    refreshSchedule: ()=>{
        $19fa0b0de9ebfc4b$export$60974f670aa8d75e.refreshScheduleRemote();
    },
    // Both live in js/timeslot.js: the reveal pages need the same two rules, and two
    // copies drifting apart is how a schedule ends up right on one page and wrong on
    // the next.
    orderTimeslots: (timeslots)=>(0, $72w2x.orderTimeslots)(timeslots, (orphans)=>{
            console.warn("Timeslots orphaned from the chain:", orphans);
        }),
    getStartDate: $72w2x.getStartDate,
    getRunStartDate: $72w2x.getRunStartDate,
    refreshScheduleRemote: ()=>{
        var _live_getCurrentRun;
        // Breaks are dropped except the leading one and the one on air right now: if the
        // current slot (the overnight "Nanna%") is filtered out, setSchedule() cannot find
        // it and slices from the top, so the break screen shows yesterday's runs.
        const currentId = (_live_getCurrentRun = (0, $cd2554817816328b$export$28cf49ad70f82d12).getCurrentRun()) === null || _live_getCurrentRun === void 0 ? void 0 : _live_getCurrentRun.id;
        const filteredSchedule = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.orderTimeslots($19fa0b0de9ebfc4b$export$60974f670aa8d75e.fetchSchedule()).filter((l, i)=>l.type === 'run' || l.type === 'break' && (i === 0 || l.id === currentId));
        $19fa0b0de9ebfc4b$export$60974f670aa8d75e.setSchedule(filteredSchedule);
        // The subscribers restart animations, so only wake them when the schedule the
        // viewer can see actually moved — not on every 15s poll.
        const signature = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.currentGameIndex + '|' + JSON.stringify(filteredSchedule.map((run)=>[
                run.id,
                $19fa0b0de9ebfc4b$export$60974f670aa8d75e.getStartDate(run)
            ]));
        if (signature === $19fa0b0de9ebfc4b$export$60974f670aa8d75e.lastScheduleSignature) return;
        $19fa0b0de9ebfc4b$export$60974f670aa8d75e.lastScheduleSignature = signature;
        console.log("SCHEDULE CHANGED:", $19fa0b0de9ebfc4b$export$60974f670aa8d75e.schedule, "PLAYING NOW:", $19fa0b0de9ebfc4b$export$60974f670aa8d75e.playingNow, "INDEX:", $19fa0b0de9ebfc4b$export$60974f670aa8d75e.currentGameIndex);
        (0, $cd2554817816328b$export$ca16cda1b94a8e08)($19fa0b0de9ebfc4b$export$60974f670aa8d75e.toCallOnRefresh, 'callWhenRefreshed');
    },
    setSchedule: (runs)=>{
        $19fa0b0de9ebfc4b$export$60974f670aa8d75e.schedule = runs;
        // Playing now must be the slot the backend marks as current
        let currentRun = (0, $cd2554817816328b$export$28cf49ad70f82d12).getCurrentRun();
        const currentRunIndex = runs.findIndex((run)=>run.id === currentRun.id);
        const slicedSchedule = runs.filter((run, i)=>i >= currentRunIndex);
        $19fa0b0de9ebfc4b$export$60974f670aa8d75e.currentGameIndex = currentRunIndex;
        $19fa0b0de9ebfc4b$export$60974f670aa8d75e.playingNow = slicedSchedule.at(0);
        $19fa0b0de9ebfc4b$export$60974f670aa8d75e.nextRun = slicedSchedule.at(1);
        $19fa0b0de9ebfc4b$export$60974f670aa8d75e.next5 = slicedSchedule.slice(1, 7);
    },
    showSchedulePreview: ()=>{
        const runPreviewUl = document.querySelector('#run-preview ul');
        runPreviewUl.innerHTML = '';
        const seizureWarningText = "\u26A0 !! ";
        if (typeof $19fa0b0de9ebfc4b$export$60974f670aa8d75e.playingNow !== 'undefined') {
            var _schedule_playingNow_submission, _schedule_playingNow;
            let seizureWarning = (_schedule_playingNow = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.playingNow) === null || _schedule_playingNow === void 0 ? void 0 : (_schedule_playingNow_submission = _schedule_playingNow.submission) === null || _schedule_playingNow_submission === void 0 ? void 0 : _schedule_playingNow_submission.seizure_warning;
            runPreviewUl.appendChild($19fa0b0de9ebfc4b$export$60974f670aa8d75e.getNewPreviewRunElement($19fa0b0de9ebfc4b$export$60974f670aa8d75e.playingNow, `PLAYING NOW: ${seizureWarning ? seizureWarningText : ''}`));
        }
        let i = 1;
        $19fa0b0de9ebfc4b$export$60974f670aa8d75e.next5.forEach((run)=>{
            var _run_submission;
            let seizureWarning = run === null || run === void 0 ? void 0 : (_run_submission = run.submission) === null || _run_submission === void 0 ? void 0 : _run_submission.seizure_warning;
            runPreviewUl.appendChild($19fa0b0de9ebfc4b$export$60974f670aa8d75e.getNewPreviewRunElement(run, `NEXT RUN #${i}: ${seizureWarning ? seizureWarningText : ''}`));
            i++;
        });
    },
    getNewPreviewRunElement: (run, prefix)=>{
        var _run_submission;
        let now = $hIdhk((0, $5Ycxa.now)());
        const startDate = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.getStartDate(run);
        let startsIn = $hIdhk.duration(now.diff(startDate));
        const isPast = now.isAfter(startDate);
        const startsInText = isPast ? "started since" : "starts in";
        let runElement = document.createElement('li');
        runElement.innerHTML = `${prefix}${run.name} ${(_run_submission = run.submission) === null || _run_submission === void 0 ? void 0 : _run_submission.category} (est. ${$19fa0b0de9ebfc4b$export$60974f670aa8d75e.getDurationFromSeconds(run.duration).humanize()}, ${startsInText}: ${startsIn.humanize()})`;
        return runElement;
    },
    fetchSchedule: ()=>{
        var _live_liveEventData;
        var _live_liveEventData_timeslots;
        return (_live_liveEventData_timeslots = (_live_liveEventData = (0, $cd2554817816328b$export$28cf49ad70f82d12).liveEventData) === null || _live_liveEventData === void 0 ? void 0 : _live_liveEventData.timeslots) !== null && _live_liveEventData_timeslots !== void 0 ? _live_liveEventData_timeslots : [];
    },
    getPlayingNow: ()=>{
        return (0, $cd2554817816328b$export$28cf49ad70f82d12).getCurrentRun();
    },
    getTimeslotById: (timeslotId)=>{
        timeslotId = parseInt(timeslotId);
        console.log(`Searching for run ${timeslotId}`, $19fa0b0de9ebfc4b$export$60974f670aa8d75e.schedule);
        let filteredRuns = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.schedule.filter((run)=>{
            return run.id === timeslotId;
        });
        console.log(filteredRuns);
        var _filteredRuns_;
        return (_filteredRuns_ = filteredRuns[0]) !== null && _filteredRuns_ !== void 0 ? _filteredRuns_ : [];
    },
    getNextRun: (index)=>{
        var _schedule_next5_index;
        return (_schedule_next5_index = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.next5[index]) !== null && _schedule_next5_index !== void 0 ? _schedule_next5_index : [];
    },
    updateCurrentTime: ()=>{
        const now = $hIdhk((0, $5Ycxa.now)());
        document.querySelector('#current-time').innerHTML = now.format();
        document.querySelector('#date>.date-date').innerHTML = now.format('DD-MM-YYYY');
        document.querySelector('#time>.date-time').innerHTML = now.format('HH:mm');
    },
    // Who is on screen right now. These read playingNow, so they live with the schedule
    // rather than with the live payload -- they used to sit in live.js and reach back
    // into schedule, which was the last dependency pointing the wrong way.
    getRunner: (ord)=>{
        var _schedule_getPlayingNow_submission;
        var _schedule_getPlayingNow_submission_runners_filter_;
        return (_schedule_getPlayingNow_submission_runners_filter_ = (_schedule_getPlayingNow_submission = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.getPlayingNow().submission) === null || _schedule_getPlayingNow_submission === void 0 ? void 0 : _schedule_getPlayingNow_submission.runners.filter((r)=>r.order === ord - 1)[0]) !== null && _schedule_getPlayingNow_submission_runners_filter_ !== void 0 ? _schedule_getPlayingNow_submission_runners_filter_ : null;
    },
    // The override is per timeslot, so it replaces every plate that has a runner behind
    // it -- plate 1 always shows it, plate 2 stays empty on a solo run.
    getRunnerName: (ord)=>{
        var _schedule_playingNow, _runner_user;
        const runner = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.getRunner(ord);
        const override = (_schedule_playingNow = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.playingNow) === null || _schedule_playingNow === void 0 ? void 0 : _schedule_playingNow.player_name_override;
        if (override && (runner || ord === 1)) return override;
        var _runner_user_name;
        return (_runner_user_name = runner === null || runner === void 0 ? void 0 : (_runner_user = runner.user) === null || _runner_user === void 0 ? void 0 : _runner_user.name) !== null && _runner_user_name !== void 0 ? _runner_user_name : '';
    },
    getRunnerSocials: (ord)=>{
        var _schedule_getRunner_user, _schedule_getRunner;
        var _schedule_getRunner_user_layout_socials;
        return (_schedule_getRunner_user_layout_socials = (_schedule_getRunner = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.getRunner(ord)) === null || _schedule_getRunner === void 0 ? void 0 : (_schedule_getRunner_user = _schedule_getRunner.user) === null || _schedule_getRunner_user === void 0 ? void 0 : _schedule_getRunner_user.layout_socials) !== null && _schedule_getRunner_user_layout_socials !== void 0 ? _schedule_getRunner_user_layout_socials : [];
    },
    getRunnerSocialsData: (ord)=>{
        var _schedule_getRunnerSocials_filter_map;
        return (_schedule_getRunnerSocials_filter_map = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.getRunnerSocials(ord).filter((social)=>social.type === 'twitch' || social.type === 'youtube').map(function(social) {
            var _social_handle;
            const handle = (_social_handle = social === null || social === void 0 ? void 0 : social.handle) !== null && _social_handle !== void 0 ? _social_handle : '';
            var _social_type;
            const type = (_social_type = social === null || social === void 0 ? void 0 : social.type) !== null && _social_type !== void 0 ? _social_type : '';
            let icon = '';
            if (type === 'twitch') icon = new URL($79875697e1136500$exports);
            else if (type === 'youtube') icon = new URL($53823d6b0a7af858$exports);
            return {
                handle: handle,
                icon: icon
            };
        })) !== null && _schedule_getRunnerSocials_filter_map !== void 0 ? _schedule_getRunnerSocials_filter_map : [];
    },
    getHostName: ()=>{
        var _schedule_playingNow;
        var _schedule_playingNow_reader;
        return (_schedule_playingNow_reader = (_schedule_playingNow = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.playingNow) === null || _schedule_playingNow === void 0 ? void 0 : _schedule_playingNow.reader) !== null && _schedule_playingNow_reader !== void 0 ? _schedule_playingNow_reader : '';
    },
    getCouch: ()=>{
        var _schedule_playingNow;
        var _schedule_playingNow_couch;
        return (_schedule_playingNow_couch = (_schedule_playingNow = $19fa0b0de9ebfc4b$export$60974f670aa8d75e.playingNow) === null || _schedule_playingNow === void 0 ? void 0 : _schedule_playingNow.couch) !== null && _schedule_playingNow_couch !== void 0 ? _schedule_playingNow_couch : '';
    },
    getBreakScreenHost: ()=>{
        return $19fa0b0de9ebfc4b$export$60974f670aa8d75e.getHostName();
    },
    getDurationFromSeconds: (seconds)=>{
        return $hIdhk.duration({
            hours: Math.floor(seconds / 3600),
            minutes: seconds % 3600 / 60,
            seconds: seconds % 60
        });
    }
};
window.schedule = $19fa0b0de9ebfc4b$export$60974f670aa8d75e;
// Deprecated alias: this module was called `oengus` when the schedule came from Oengus.
window.oengus = $19fa0b0de9ebfc4b$export$60974f670aa8d75e;



var $bHJE2 = parcelRequire("bHJE2");

let $da5008b34906a1ca$export$d083befd4444a793 = {
    rowHeight: 90,
    initialYOffset: 0,
    rowsYOffset: 0,
    rows: [
        "One morning, when **Gregor Samsa** woke from troubled dreams, he found",
        "himself transformed in his bed into a **horrible vermin**. He lay on his",
        "armour-like back, and if he lifted his head a little he could see",
        "his brown belly, slightly **domed** and **divided** by arches into stiff sections."
    ],
    currentRows: [],
    rowsEl: undefined,
    totalSteps: 0,
    advanceTimeout: 7000,
    advanceInterval: -1,
    currentInforollNumber: 0,
    freezeInforoll: false,
    frozenInforollText: '',
    initVariables: ()=>{
        $da5008b34906a1ca$export$d083befd4444a793.initialYOffset = -$da5008b34906a1ca$export$d083befd4444a793.rowHeight;
        $da5008b34906a1ca$export$d083befd4444a793.rowsYOffset = $da5008b34906a1ca$export$d083befd4444a793.initialYOffset;
        $da5008b34906a1ca$export$d083befd4444a793.rowsEl = document.getElementById("infobar-rows");
        $da5008b34906a1ca$export$d083befd4444a793.totalSteps = $da5008b34906a1ca$export$d083befd4444a793.rowsEl.children.length + 2;
    },
    createDomElements: ()=>{
        var _inforoll_currentRows;
        let rowParent = document.getElementById("infobar-rows");
        rowParent.innerHTML = "";
        if ($da5008b34906a1ca$export$d083befd4444a793.freezeInforoll) $da5008b34906a1ca$export$d083befd4444a793.rows = [
            [
                $da5008b34906a1ca$export$d083befd4444a793.frozenInforollText
            ]
        ];
        else $da5008b34906a1ca$export$d083befd4444a793.rows = $da5008b34906a1ca$export$d083befd4444a793.getRows();
        var _inforoll_rows_inforoll_currentInforollNumber;
        $da5008b34906a1ca$export$d083befd4444a793.currentRows = (_inforoll_rows_inforoll_currentInforollNumber = $da5008b34906a1ca$export$d083befd4444a793.rows[$da5008b34906a1ca$export$d083befd4444a793.currentInforollNumber]) !== null && _inforoll_rows_inforoll_currentInforollNumber !== void 0 ? _inforoll_rows_inforoll_currentInforollNumber : [];
        (_inforoll_currentRows = $da5008b34906a1ca$export$d083befd4444a793.currentRows) === null || _inforoll_currentRows === void 0 ? void 0 : _inforoll_currentRows.forEach((row)=>{
            var rowNode = document.createElement("div");
            rowNode.className = 'infobar-row bar-height';
            const rowText = row.replaceAll(/[*][*](.*?)[*][*]/g, '<span class="hl">$1</span>');
            rowNode.innerHTML = rowText;
            rowParent.appendChild(rowNode);
        });
    },
    getRows: ()=>{
        var _live_getInforollRows;
        var _live_getInforollRows_split_map;
        $da5008b34906a1ca$export$d083befd4444a793.rows = (_live_getInforollRows_split_map = (_live_getInforollRows = (0, $cd2554817816328b$export$28cf49ad70f82d12).getInforollRows()) === null || _live_getInforollRows === void 0 ? void 0 : _live_getInforollRows.split("\n\n").map((block)=>block.split("\n"))) !== null && _live_getInforollRows_split_map !== void 0 ? _live_getInforollRows_split_map : [];
        return $da5008b34906a1ca$export$d083befd4444a793.rows;
    },
    /** Resolved by clearIntervalAndReset() when the block has finished scrolling. */ finished: undefined,
    /**
   * Scrolls one inforoll block, then resolves. The cycle driver decides what comes
   * next — this used to call overlayRenderer.showDonationGoalProgressBar() directly,
   * which was one half of the import cycle.
   */ play: ()=>{
        const done = new Promise((resolve)=>{
            $da5008b34906a1ca$export$d083befd4444a793.finished = resolve;
        });
        $da5008b34906a1ca$export$d083befd4444a793.start();
        // A frozen bar never advances, so nothing would resolve it. Report done at once;
        // the driver's `haltAfter` is what parks the cycle.
        if ($da5008b34906a1ca$export$d083befd4444a793.freezeInforoll) $da5008b34906a1ca$export$d083befd4444a793.finished();
        return done;
    },
    start: ()=>{
        $da5008b34906a1ca$export$d083befd4444a793.freezeInforoll = (0, $cd2554817816328b$export$28cf49ad70f82d12).getFreezeInforoll();
        $da5008b34906a1ca$export$d083befd4444a793.frozenInforollText = (0, $cd2554817816328b$export$28cf49ad70f82d12).getFrozenInforollText();
        $da5008b34906a1ca$export$d083befd4444a793.createDomElements();
        $da5008b34906a1ca$export$d083befd4444a793.initVariables();
        if (!$da5008b34906a1ca$export$d083befd4444a793.freezeInforoll) $da5008b34906a1ca$export$d083befd4444a793.advanceInterval = setInterval($da5008b34906a1ca$export$d083befd4444a793.advanceNextRow, $da5008b34906a1ca$export$d083befd4444a793.advanceTimeout);
        else $da5008b34906a1ca$export$d083befd4444a793.rowsEl.classList.add("frozen");
        $da5008b34906a1ca$export$d083befd4444a793.rowsEl.style.opacity = 1;
        $da5008b34906a1ca$export$d083befd4444a793.advanceNextRow();
    },
    advanceNextRow: ()=>{
        (0, $bHJE2.default)({
            targets: $da5008b34906a1ca$export$d083befd4444a793.rowsEl,
            translateY: $da5008b34906a1ca$export$d083befd4444a793.rowsYOffset,
            easing: 'easeInOutQuad',
            duration: 250
        });
        $da5008b34906a1ca$export$d083befd4444a793.rowsYOffset -= $da5008b34906a1ca$export$d083befd4444a793.rowHeight;
        if ($da5008b34906a1ca$export$d083befd4444a793.freezeInforoll) return;
        if ($da5008b34906a1ca$export$d083befd4444a793.rowsYOffset <= -$da5008b34906a1ca$export$d083befd4444a793.rowHeight * $da5008b34906a1ca$export$d083befd4444a793.totalSteps) {
            $da5008b34906a1ca$export$d083befd4444a793.currentInforollNumber++;
            if ($da5008b34906a1ca$export$d083befd4444a793.currentInforollNumber >= $da5008b34906a1ca$export$d083befd4444a793.rows.length) $da5008b34906a1ca$export$d083befd4444a793.currentInforollNumber = 0;
            // console.log("Advancing inforoll", inforoll.currentInforollNumber);
            setTimeout($da5008b34906a1ca$export$d083befd4444a793.clearIntervalAndReset, 250);
            $da5008b34906a1ca$export$d083befd4444a793.rowsEl.style.opacity = 0;
        }
    },
    clearIntervalAndReset: ()=>{
        var _inforoll_finished;
        clearInterval($da5008b34906a1ca$export$d083befd4444a793.advanceInterval);
        (0, $bHJE2.default)({
            targets: $da5008b34906a1ca$export$d083befd4444a793.rowsEl,
            translateY: 0,
            easing: 'steps(1)'
        });
        (_inforoll_finished = $da5008b34906a1ca$export$d083befd4444a793.finished) === null || _inforoll_finished === void 0 ? void 0 : _inforoll_finished.call($da5008b34906a1ca$export$d083befd4444a793);
    }
};
window.inforoll = $da5008b34906a1ca$export$d083befd4444a793;
window.infoBar = $da5008b34906a1ca$export$d083befd4444a793; // deprecated alias



var $bHJE2 = parcelRequire("bHJE2");


window.confetti = (parcelRequire("aoyP8"));
var $be3f8327a460878c$var$decodeEntities = function() {
    // Avoids re-creating the element on every call.
    const element = document.createElement('div');
    return function decodeHTMLEntities(str) {
        if (str && typeof str === 'string') {
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
            element.innerHTML = str;
            str = element.textContent;
            element.textContent = '';
        }
        return str;
    };
}();
const $be3f8327a460878c$export$7f0207607007e8df = {
    totalDonationsCounter: 0,
    oldGoalDonationPercent: 0,
    goalDonationPercent: 0,
    goalDonationPercentCounter: 0,
    surpriseDeployed: false,
    goalDonationLeftDefault: -1192,
    goalDonationLeft: -1192,
    shownDonationGoalProgressBar: false,
    isAnimatingDonationGoalProgressBar: false,
    shouldResetDonationGoalPosition: false,
    shouldUpdateDonationGoal: false,
    animateTotal: (donationsTotal)=>{
        const el = document.getElementById('donation-amount-number');
        const elShadow = document.getElementById('donation-amount-number-shadow');
        const breakDonationAmount = document.querySelector('#break-donations .donation-total');
        (0, $bHJE2.default)({
            targets: $be3f8327a460878c$export$7f0207607007e8df,
            totalDonationsCounter: donationsTotal,
            round: 100,
            easing: 'easeOutExpo',
            update: function() {
                let formattedNumber = new Intl.NumberFormat('it-IT', {
                    style: 'currency',
                    currency: 'EUR'
                }).format($be3f8327a460878c$export$7f0207607007e8df.totalDonationsCounter);
                el.innerHTML = formattedNumber;
                elShadow.innerHTML = formattedNumber;
                breakDonationAmount.innerHTML = formattedNumber;
            }
        });
    },
    updateDonations: ()=>{
        $be3f8327a460878c$export$7f0207607007e8df.animateTotal((0, $cd2554817816328b$export$28cf49ad70f82d12).getTotalDonationsWithOffset());
    },
    updateDonationReason: ()=>{
        document.getElementById('donation-reason').innerHTML = (0, $cd2554817816328b$export$28cf49ad70f82d12).getDonationReason();
        document.querySelector('#break-donations .donation-reason').innerHTML = (0, $cd2554817816328b$export$28cf49ad70f82d12).getDonationReason();
    },
    /** What the three donor rows currently show, so a no-op poll animates nothing. */ renderedDonors: [],
    donorRows: ()=>[
            1,
            2,
            3
        ].map((n)=>({
                name: document.querySelector(`.donator-leaderboard .leaderboard-${n} .name`),
                amount: document.querySelector(`.donator-leaderboard .leaderboard-${n} .amount`)
            })),
    /**
   * Renders the whole TOP DONATORI board from one list, in one pass.
   *
   * It used to be three independent updates staggered 1.5 s apart, each shifting its
   * own slice of rows down and inserting at the top. On a rank swap that left a row
   * holding stale content copied from the row above — the same donor showing twice —
   * until that row's own turn came round three seconds later. Rendering all three rows
   * from the same source list cannot produce that.
   */ updateDonatorsLeaderboard: ()=>{
        const donors = (0, $cd2554817816328b$export$28cf49ad70f82d12).getDonatorsLeaderboard();
        const money = (v)=>new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'EUR'
            }).format(v);
        const next = [
            0,
            1,
            2
        ].map((i)=>{
            var _donors_i_name;
            return donors[i] ? {
                name: (_donors_i_name = donors[i].name) !== null && _donors_i_name !== void 0 ? _donors_i_name : '',
                amount: money(donors[i].total)
            } : {
                name: '',
                amount: ''
            };
        });
        const shown = $be3f8327a460878c$export$7f0207607007e8df.renderedDonors;
        if (next.every((row, i)=>{
            var _shown_i, _shown_i1;
            return ((_shown_i = shown[i]) === null || _shown_i === void 0 ? void 0 : _shown_i.name) === row.name && ((_shown_i1 = shown[i]) === null || _shown_i1 === void 0 ? void 0 : _shown_i1.amount) === row.amount;
        })) return;
        // A donation that moves nobody is just a number ticking up: write it and stay
        // still. Reordering the board is what earns the animation.
        const reordered = next.some((row, i)=>{
            var _shown_i;
            var _shown_i_name;
            return ((_shown_i_name = (_shown_i = shown[i]) === null || _shown_i === void 0 ? void 0 : _shown_i.name) !== null && _shown_i_name !== void 0 ? _shown_i_name : '') !== row.name;
        });
        $be3f8327a460878c$export$7f0207607007e8df.renderedDonors = next;
        const rows = $be3f8327a460878c$export$7f0207607007e8df.donorRows();
        const write = (i)=>{
            rows[i].name.innerHTML = next[i].name;
            rows[i].amount.innerHTML = next[i].amount;
        };
        if (!reordered) {
            rows.forEach((_, i)=>write(i));
            return;
        }
        // Fade every row out, write all three at once while none is visible, fade back in.
        // Writing each row at its own midpoint left a 120 ms window in which the row above
        // already showed its new donor and this one still showed the old copy of it.
        const targets = rows.flatMap((row)=>[
                row.name,
                row.amount
            ]);
        const cascade = (el, i)=>Math.floor(i / 2) * 120; // per row, not per element
        let written = false;
        const writeAll = ()=>{
            if (written) return;
            written = true;
            rows.forEach((_, i)=>write(i));
        };
        (0, $bHJE2.default).timeline({
            easing: 'easeInOutQuad',
            complete: writeAll
        }) // in case it is cut short
        .add({
            targets: targets,
            opacity: 0,
            translateX: 20,
            duration: 200,
            delay: cascade,
            complete: writeAll
        }).add({
            targets: targets,
            opacity: 1,
            translateX: 0,
            duration: 200,
            delay: cascade
        }, '+=60');
    },
    maybeUpdateDonationGoal: ()=>{
        if (!$be3f8327a460878c$export$7f0207607007e8df.shouldUpdateDonationGoal) return;
        $be3f8327a460878c$export$7f0207607007e8df.updateDonationGoal();
    },
    updateDonationGoal: ()=>{
        $be3f8327a460878c$export$7f0207607007e8df.maybeResetDonationGoalPosition();
        const flairObjectiveEl = document.querySelector('#donation-progress .flair-objective');
        flairObjectiveEl.innerHTML = (0, $cd2554817816328b$export$28cf49ad70f82d12).getDonationGoalFlair();
        const flairObjectiveAmountEl = document.querySelector('#donation-progress .donation-totals');
        const donationGoalAmount = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR'
        }).format((0, $cd2554817816328b$export$28cf49ad70f82d12).getDonationGoalAmount());
        const totalDonations = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR'
        }).format((0, $cd2554817816328b$export$28cf49ad70f82d12).getTotalDonationsWithOffset());
        flairObjectiveAmountEl.innerHTML = totalDonations + ' / ' + donationGoalAmount;
        $be3f8327a460878c$export$7f0207607007e8df.goalDonationPercent = (0, $cd2554817816328b$export$28cf49ad70f82d12).getTotalDonationsWithOffset() * 100 / (0, $cd2554817816328b$export$28cf49ad70f82d12).getDonationGoalAmount();
        if ($be3f8327a460878c$export$7f0207607007e8df.goalDonationPercent > 100) $be3f8327a460878c$export$7f0207607007e8df.goalDonationPercent = 100;
        const minX = $be3f8327a460878c$export$7f0207607007e8df.goalDonationLeftDefault;
        const toAdd = 4;
        let currentLeft = minX * $be3f8327a460878c$export$7f0207607007e8df.goalDonationPercent / 100;
        currentLeft -= toAdd;
        $be3f8327a460878c$export$7f0207607007e8df.goalDonationLeft = minX - currentLeft;
        if ($be3f8327a460878c$export$7f0207607007e8df.shownDonationGoalProgressBar) $be3f8327a460878c$export$7f0207607007e8df.animateDonationGoalProgressBar();
    },
    getGoalAnimationDuration: ()=>{
        return ($be3f8327a460878c$export$7f0207607007e8df.goalDonationPercent - $be3f8327a460878c$export$7f0207607007e8df.oldGoalDonationPercent) * 50;
    },
    enableUpdatingDonationGoal: ()=>{
        $be3f8327a460878c$export$7f0207607007e8df.shouldUpdateDonationGoal = true;
        $be3f8327a460878c$export$7f0207607007e8df.maybeUpdateDonationGoal();
    },
    disenableUpdatingDonationGoal: ()=>{
        $be3f8327a460878c$export$7f0207607007e8df.shouldUpdateDonationGoal = false;
    },
    resetDonationGoalPosition: ()=>{
        // console.log("Resetting goal bar position");
        $be3f8327a460878c$export$7f0207607007e8df.shownDonationGoalProgressBar = false;
        $be3f8327a460878c$export$7f0207607007e8df.goalDonationPercent = 0;
        $be3f8327a460878c$export$7f0207607007e8df.oldGoalDonationPercent = 0;
        $be3f8327a460878c$export$7f0207607007e8df.goalDonationPercentCounter = 0;
        document.querySelector('#donation-progress .donation-bar-progressbar').style.left = $be3f8327a460878c$export$7f0207607007e8df.goalDonationLeftDefault + 'px';
    },
    maybeResetDonationGoalPosition: ()=>{
        if ($be3f8327a460878c$export$7f0207607007e8df.shouldResetDonationGoalPosition) {
            $be3f8327a460878c$export$7f0207607007e8df.resetDonationGoalPosition();
            $be3f8327a460878c$export$7f0207607007e8df.shouldResetDonationGoalPosition = false;
        }
    },
    animateDonationGoalProgressBar: ()=>{
        if ($be3f8327a460878c$export$7f0207607007e8df.shouldResetDonationGoalPosition) return;
        if ($be3f8327a460878c$export$7f0207607007e8df.isAnimatingDonationGoalProgressBar) return;
        if ($be3f8327a460878c$export$7f0207607007e8df.goalDonationPercent === $be3f8327a460878c$export$7f0207607007e8df.oldGoalDonationPercent) return;
        $be3f8327a460878c$export$7f0207607007e8df.isAnimatingDonationGoalProgressBar = true;
        const flairPercentEl = document.querySelector('#donation-progress .donation-bar-progressbar .percent');
        const currentGoalDonationPercent = $be3f8327a460878c$export$7f0207607007e8df.goalDonationPercent;
        (0, $bHJE2.default)({
            targets: $be3f8327a460878c$export$7f0207607007e8df,
            goalDonationPercentCounter: $be3f8327a460878c$export$7f0207607007e8df.goalDonationPercent,
            round: 10,
            easing: 'easeOutCirc',
            duration: $be3f8327a460878c$export$7f0207607007e8df.getGoalAnimationDuration(),
            delay: 1000,
            update: function() {
                flairPercentEl.innerHTML = parseInt($be3f8327a460878c$export$7f0207607007e8df.goalDonationPercentCounter) + '%';
            },
            complete: function() {
                $be3f8327a460878c$export$7f0207607007e8df.shownDonationGoalProgressBar = true;
                $be3f8327a460878c$export$7f0207607007e8df.isAnimatingDonationGoalProgressBar = false;
                $be3f8327a460878c$export$7f0207607007e8df.oldGoalDonationPercent = currentGoalDonationPercent;
            }
        });
        (0, $bHJE2.default)({
            targets: '#donation-progress .donation-bar-progressbar',
            left: $be3f8327a460878c$export$7f0207607007e8df.goalDonationLeft,
            easing: 'easeOutCirc',
            duration: $be3f8327a460878c$export$7f0207607007e8df.getGoalAnimationDuration(),
            delay: 1000,
            complete: function() {
                if (!(0, $cd2554817816328b$export$28cf49ad70f82d12).getDonationDeploySurprise()) return;
                if (!$be3f8327a460878c$export$7f0207607007e8df.shouldUpdateDonationGoal) return;
                if ($be3f8327a460878c$export$7f0207607007e8df.surpriseDeployed) return;
                if ($be3f8327a460878c$export$7f0207607007e8df.goalDonationPercent >= 100) {
                    window.confetti.default({
                        particleCount: 200,
                        spread: 200,
                        origin: {
                            y: 0.2,
                            x: 0.6
                        },
                        zIndex: 50
                    });
                    window.confetti.default({
                        particleCount: 200,
                        spread: 150,
                        origin: {
                            y: 0.2,
                            x: 0.4
                        },
                        zIndex: 50
                    });
                    window.confetti.default({
                        particleCount: 200,
                        spread: 140,
                        origin: {
                            y: 0.2
                        },
                        zIndex: 50
                    });
                    $be3f8327a460878c$export$7f0207607007e8df.surpriseDeployed = true;
                }
            }
        });
    },
    /** Resolved when the goal bar has finished its stay on screen. */ goalFinished: undefined,
    /** Segment wrapper: shows the bar, resolves when it retracts. */ playDonationGoal: ()=>{
        const done = new Promise((resolve)=>{
            $be3f8327a460878c$export$7f0207607007e8df.goalFinished = resolve;
        });
        $be3f8327a460878c$export$7f0207607007e8df.showDonationGoalProgressBar();
        return done;
    },
    showDonationGoalProgressBar: ()=>{
        $be3f8327a460878c$export$7f0207607007e8df.enableUpdatingDonationGoal();
        const donationGoalDuration = 10000;
        const donationGoalEnterAnimationDuration = 500;
        (0, $bHJE2.default)({
            targets: '#donation-progress',
            duration: donationGoalEnterAnimationDuration,
            opacity: 1,
            direction: 'alternate',
            easing: 'easeInOutExpo',
            endDelay: donationGoalDuration
        });
        (0, $bHJE2.default)({
            targets: [
                '#donation-progress .donation-flair',
                '#donation-progress .donation-totals'
            ],
            duration: donationGoalEnterAnimationDuration,
            top: 4,
            direction: 'alternate',
            easing: 'easeInOutExpo',
            endDelay: donationGoalDuration
        });
        (0, $bHJE2.default)({
            targets: [
                '#donation-progress .donation-bar-container'
            ],
            duration: donationGoalEnterAnimationDuration,
            bottom: 10,
            direction: 'alternate',
            easing: 'easeInOutExpo',
            endDelay: donationGoalDuration,
            complete: function() {
                var _donationsRenderer_goalFinished;
                $be3f8327a460878c$export$7f0207607007e8df.shouldResetDonationGoalPosition = true;
                $be3f8327a460878c$export$7f0207607007e8df.disenableUpdatingDonationGoal();
                (_donationsRenderer_goalFinished = $be3f8327a460878c$export$7f0207607007e8df.goalFinished) === null || _donationsRenderer_goalFinished === void 0 ? void 0 : _donationsRenderer_goalFinished.call($be3f8327a460878c$export$7f0207607007e8df);
            }
        });
        $be3f8327a460878c$export$7f0207607007e8df.animateDonationGoalProgressBar();
    },
    shownLeaderboard: false,
    maybeShowLeaderboard: ()=>{
        const leaderboardElement = document.querySelector('#donation-leaderboards');
        if ((0, $cd2554817816328b$export$28cf49ad70f82d12).shouldShowLeaderboard()) {
            leaderboardElement.classList.remove('hidden');
            if ($be3f8327a460878c$export$7f0207607007e8df.shownLeaderboard) return;
            (0, $bHJE2.default)({
                targets: leaderboardElement,
                duration: 5000,
                opacity: 1,
                easing: 'easeInOutExpo'
            });
        } else leaderboardElement.classList.add('hidden');
    },
    updateDonationLeaderboard: ()=>{
        const donationLeaderboard = (0, $cd2554817816328b$export$28cf49ad70f82d12).getDonationLeaderboard();
        donationLeaderboard.forEach((d, i)=>{
            const selector = `#break-donations .donation-leaderboard .leaderboard-${i + 1}`;
            const donationLeaderboardElement = document.querySelector(selector);
            donationLeaderboardElement.querySelector(".name").innerHTML = d.name;
            const formattedAmount = new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'EUR'
            }).format(d.total);
            donationLeaderboardElement.querySelector(".amount").innerHTML = formattedAmount;
        });
    },
    startDonationLeaderboardToggleLoop: ()=>{
        const crossFadeDelay = 30000;
        const crossFadeDuration = 1500;
        (0, $bHJE2.default)({
            targets: '#break-donations .donation-leaderboard',
            opacity: 1,
            easing: 'easeInOutQuad',
            duration: crossFadeDuration,
            delay: crossFadeDelay / 2,
            endDelay: crossFadeDelay / 2,
            direction: 'alternate',
            loop: true
        });
        (0, $bHJE2.default)({
            targets: '#break-donations .donator-leaderboard',
            opacity: 0,
            easing: 'easeInOutQuad',
            duration: crossFadeDuration,
            delay: crossFadeDelay / 2,
            endDelay: crossFadeDelay / 2,
            direction: 'alternate',
            loop: true
        });
    },
    showBreakDonationContainer: ()=>{
        setTimeout(function() {
            (0, $bHJE2.default)({
                targets: [
                    '#break-donations'
                ],
                opacity: 1,
                easing: 'linear',
                duration: 1500
            });
        }, 1000);
    }
};
window.donationsRenderer = $be3f8327a460878c$export$7f0207607007e8df;
window.anime = (0, $bHJE2.default);



var $bHJE2 = parcelRequire("bHJE2");

/**
 * Shrink-to-fit, used by the game tab title and the break screen's run names. Steps the
 * font size down 1 px at a time until the text stops overflowing, floor 10 px.
 *
 * Needs the web fonts loaded to measure anything meaningful — that is why the tests
 * await document.fonts.ready before asserting on anything it touches.
 */ const $28bc6842b9ad21c7$export$b94583dc679500d = {
    decreaseFontSizeUntilItFits (element, extraFontDecrease = 0) {
        while($28bc6842b9ad21c7$export$b94583dc679500d.isElementOverflowing(element)){
            console.log("Overflowing title: decreasing font size");
            let fontSize = parseInt(window.getComputedStyle(element).fontSize);
            console.log("Current font size:", fontSize);
            element.style.fontSize = fontSize - 1 + 'px';
            if (fontSize <= 10) break;
        }
        if (extraFontDecrease > 0) {
            let fontSize = parseInt(window.getComputedStyle(element).fontSize);
            element.style.fontSize = fontSize - extraFontDecrease + 'px';
        }
        element.classList.remove('calculating');
    },
    isElementOverflowing: (element)=>{
        return element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight;
    }
};
window.fitText = $28bc6842b9ad21c7$export$b94583dc679500d;


const $58023c6713a64ee8$export$f1bc67d49dee77a6 = {
    runnerNameShowDelay: 105000,
    runnerNameShowDuration: 2000,
    runnerSocialShowDelay: 15000,
    gameTabFilled: false,
    /**
   * Which cell of the console sprite each `platform.name` from fungus gets. The sprite
   * only draws a handful of consoles; everything else, PC included, falls back to PC.
   * Spring has a single gamepad image, so the cell only moves the picture in autumn.
   */ platformIconCells: {
        'PC': 2,
        'PlayStation 2': 3,
        'GameCube': 4,
        'NES': 5,
        'Famicom': 5,
        'PlayStation': 6,
        'Nintendo Switch': 7,
        'SNES': 8,
        'Super Nintendo': 8,
        'Super Famicom': 8
    },
    platformIconFallbackCell: 2,
    platformIconCell: (platform)=>{
        var _currentRunRenderer_platformIconCells_platform;
        return (_currentRunRenderer_platformIconCells_platform = $58023c6713a64ee8$export$f1bc67d49dee77a6.platformIconCells[platform]) !== null && _currentRunRenderer_platformIconCells_platform !== void 0 ? _currentRunRenderer_platformIconCells_platform : $58023c6713a64ee8$export$f1bc67d49dee77a6.platformIconFallbackCell;
    },
    /**
   * Consoles too narrow for a square cell come as their own image instead of a sprite
   * cell. The value becomes `data-icon` on `.platform`, which game-tab.scss maps to the file.
   */ platformIconSingles: {
        'Game Boy': 'gameboy',
        'Game Boy Color': 'gameboy',
        'Game Boy Advance': 'gameboy',
        'Super Game Boy': 'gameboy',
        'Game Boy Player': 'gameboy',
        'Xbox 360': 'xbox360',
        'Wii': 'wii'
    },
    updateRunnerName: ()=>{
        document.querySelectorAll('.current-runner-1 .runner-name').forEach((el)=>{
            el.innerHTML = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getRunnerName(1);
        });
        document.querySelectorAll('.current-runner-2 .runner-name').forEach((el)=>{
            el.innerHTML = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getRunnerName(2);
        });
    },
    fadeInOutRunnerName: (ord)=>{
        const runnerName = document.querySelectorAll('.current-runner-' + ord + ' .runner-name');
        if ((0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getRunnerSocialsData(ord).length === 0) {
            runnerName.forEach(function(e) {
                e.style.opacity = 1;
            });
            setTimeout(function() {
                $58023c6713a64ee8$export$f1bc67d49dee77a6.fadeInOutRunnerName(ord);
            }, $58023c6713a64ee8$export$f1bc67d49dee77a6.runnerNameShowDelay);
        } else {
            runnerName.forEach(function(e) {
                e.style.opacity = 0;
            });
            (0, $bHJE2.default)({
                targets: runnerName,
                opacity: 1,
                duration: $58023c6713a64ee8$export$f1bc67d49dee77a6.runnerNameShowDuration,
                endDelay: $58023c6713a64ee8$export$f1bc67d49dee77a6.runnerNameShowDelay / 4,
                easing: 'easeInOutExpo',
                direction: 'alternate',
                complete: function() {
                    $58023c6713a64ee8$export$f1bc67d49dee77a6.fadeInOutRunnerSocials(ord);
                }
            });
        }
    },
    fadeInOutRunnerSocials: (ord)=>{
        const socialHandle = document.querySelectorAll('.current-runner-' + ord + ' .social .handle');
        const socialIcon = document.querySelectorAll('.current-runner-' + ord + ' .social .icon');
        let socials = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getRunnerSocialsData(ord);
        let handleTimeline = (0, $bHJE2.default).timeline();
        let iconTimeline = (0, $bHJE2.default).timeline();
        socials.forEach(function callback(socialData, i) {
            handleTimeline.add({
                targets: socialHandle,
                opacity: 1,
                duration: $58023c6713a64ee8$export$f1bc67d49dee77a6.runnerNameShowDuration,
                endDelay: $58023c6713a64ee8$export$f1bc67d49dee77a6.runnerSocialShowDelay,
                easing: 'easeInOutExpo',
                begin: function() {
                    socialHandle.forEach(function(el) {
                        el.innerHTML = socialData.handle;
                    });
                }
            }).add({
                targets: socialHandle,
                opacity: 0,
                duration: $58023c6713a64ee8$export$f1bc67d49dee77a6.runnerNameShowDuration,
                easing: 'easeInOutExpo',
                complete: function() {
                    if (i === socials.length - 1) $58023c6713a64ee8$export$f1bc67d49dee77a6.fadeInOutRunnerName(ord);
                }
            });
            iconTimeline.add({
                targets: socialIcon,
                translateX: {
                    value: 43,
                    duration: 200
                },
                opacity: [
                    {
                        value: 0,
                        duration: 0
                    },
                    {
                        value: 1,
                        duration: 200
                    }
                ],
                endDelay: $58023c6713a64ee8$export$f1bc67d49dee77a6.runnerSocialShowDelay + 3600,
                easing: 'easeInOutExpo',
                begin: function() {
                    socialIcon.forEach(function(el) {
                        el.src = socialData.icon;
                    });
                }
            }).add({
                targets: socialIcon,
                translateX: {
                    value: 0,
                    duration: 200
                },
                opacity: {
                    value: 0,
                    duration: 200
                },
                easing: 'easeInOutExpo'
            });
        });
    },
    updateCurrentRunInfo: ()=>{
        var _playingNow_submission, _playingNow_submission_platform, _playingNow_submission1, _playingNow_submission2, _playingNow_submission3;
        if ($58023c6713a64ee8$export$f1bc67d49dee77a6.gameTabFilled) return;
        const titleElement = document.querySelector('#current-run-game-tab .title');
        const categoryElement = document.querySelector('#current-run-game-tab .category');
        const elapsedElement = document.querySelector('#current-run-game-tab .elapsed');
        const platformElement = document.querySelector('#current-run-game-tab .platform');
        const yearElement = document.querySelector('#current-run-game-tab .year');
        let playingNow = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getPlayingNow();
        var _playingNow_name;
        const gameName = (_playingNow_name = playingNow === null || playingNow === void 0 ? void 0 : playingNow.name) !== null && _playingNow_name !== void 0 ? _playingNow_name : '';
        var _playingNow_submission_category;
        const categoryName = (_playingNow_submission_category = playingNow === null || playingNow === void 0 ? void 0 : (_playingNow_submission = playingNow.submission) === null || _playingNow_submission === void 0 ? void 0 : _playingNow_submission.category) !== null && _playingNow_submission_category !== void 0 ? _playingNow_submission_category : '';
        var _playingNow_submission_platform_name;
        const platform = (_playingNow_submission_platform_name = playingNow === null || playingNow === void 0 ? void 0 : (_playingNow_submission1 = playingNow.submission) === null || _playingNow_submission1 === void 0 ? void 0 : (_playingNow_submission_platform = _playingNow_submission1.platform) === null || _playingNow_submission_platform === void 0 ? void 0 : _playingNow_submission_platform.name) !== null && _playingNow_submission_platform_name !== void 0 ? _playingNow_submission_platform_name : '';
        titleElement.innerHTML = gameName;
        categoryElement.innerHTML = categoryName;
        platformElement.innerHTML = platform;
        platformElement.style.setProperty('--platform-cell', $58023c6713a64ee8$export$f1bc67d49dee77a6.platformIconCell(platform));
        const single = $58023c6713a64ee8$export$f1bc67d49dee77a6.platformIconSingles[platform];
        if (single) platformElement.dataset.icon = single;
        else delete platformElement.dataset.icon;
        if (!!gameName) titleElement.classList.add('show');
        if (!!categoryName) categoryElement.classList.add('show');
        if (!!platform) platformElement.classList.add('show');
        var _playingNow_duration;
        let estimateDuration = (_playingNow_duration = playingNow === null || playingNow === void 0 ? void 0 : playingNow.duration) !== null && _playingNow_duration !== void 0 ? _playingNow_duration : 0;
        let estimate = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getDurationFromSeconds(estimateDuration);
        elapsedElement.innerHTML = estimate.format('HH:mm:ss');
        if (estimateDuration !== 0) elapsedElement.classList.add('show');
        const year = playingNow === null || playingNow === void 0 ? void 0 : (_playingNow_submission2 = playingNow.submission) === null || _playingNow_submission2 === void 0 ? void 0 : _playingNow_submission2.year;
        yearElement.innerHTML = year;
        if (!!year) yearElement.classList.add('show');
        if (!!gameName) $58023c6713a64ee8$export$f1bc67d49dee77a6.gameTabFilled = true;
        const currentRunElement = document.querySelector('.info-bg');
        currentRunElement.classList.remove('r16-9');
        currentRunElement.classList.remove('r4-3');
        var _playingNow_ratio_override, _ref;
        const runRatio = (_ref = (_playingNow_ratio_override = playingNow === null || playingNow === void 0 ? void 0 : playingNow.ratio_override) !== null && _playingNow_ratio_override !== void 0 ? _playingNow_ratio_override : playingNow === null || playingNow === void 0 ? void 0 : (_playingNow_submission3 = playingNow.submission) === null || _playingNow_submission3 === void 0 ? void 0 : _playingNow_submission3.aspect_ratio) !== null && _ref !== void 0 ? _ref : '16:9';
        let ratio = '';
        if (runRatio === '4:3') ratio = 'r4-3';
        else ratio = 'r16-9';
        console.log("Ratio:", ratio);
        currentRunElement.classList.add(ratio);
        (0, $28bc6842b9ad21c7$export$b94583dc679500d).decreaseFontSizeUntilItFits(titleElement);
    },
    updateHostName: ()=>{
        $58023c6713a64ee8$export$f1bc67d49dee77a6.setHostName((0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getHostName());
    },
    setHostName: (hostName)=>{
        const hostNameElement = document.querySelector('#host .host-name');
        hostNameElement.innerHTML = hostName;
    },
    updateCouch: ()=>{
        const couchElement = document.querySelector('#couch');
        const couchNamesElement = couchElement.querySelector('.couch-names');
        const couchNames = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getCouch();
        couchNamesElement.innerHTML = couchNames;
        if (!couchNames) couchElement.style.opacity = 0;
        else couchElement.style.opacity = 1;
    },
    updateBreakScreenHost: ()=>{
        const breakHostElement = document.querySelector('#break-host');
        const breakHostNameElement = breakHostElement.querySelector('.break-host-name');
        const breakHostName = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getBreakScreenHost();
        breakHostNameElement.innerHTML = breakHostName;
        if (!breakHostName) breakHostElement.style.opacity = 0;
        else breakHostElement.style.opacity = 1;
    }
};
window.currentRunRenderer = $58023c6713a64ee8$export$f1bc67d49dee77a6;



var $bHJE2 = parcelRequire("bHJE2");


var $5Ycxa = parcelRequire("5Ycxa");

var $hIdhk = parcelRequire("hIdhk");

$hIdhk.extend((parcelRequire("d0Ch3")));

$hIdhk.extend((parcelRequire("18ZYM")));
var $420617c15e237139$exports = {};

!function(e, o) {
    $420617c15e237139$exports = o((parcelRequire("hIdhk")));
}($420617c15e237139$exports, function(e) {
    "use strict";
    function o(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = o(e), n = {
        name: "it",
        weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),
        weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
        weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
        months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
        weekStart: 1,
        monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "tra %s",
            past: "%s fa",
            s: "qualche secondo",
            m: "un minuto",
            mm: "%d minuti",
            h: "un'ora",
            hh: "%d ore",
            d: "un giorno",
            dd: "%d giorni",
            M: "un mese",
            MM: "%d mesi",
            y: "un anno",
            yy: "%d anni"
        },
        ordinal: function(e) {
            return e + "\xba";
        }
    };
    return t.default.locale(n, null, !0), n;
});


function $08f0832b872ea799$export$eb11d1adfbce682d(dateTo) {
    let now = $hIdhk((0, $5Ycxa.now)());
    if (dateTo === undefined || dateTo === null) return {
        label: '',
        duration: ''
    };
    // "DOMANI" means the next *stream* day, not the next calendar day: the
    // marathon runs past midnight, so a 00:04 slot seen at 22:20 is still tonight.
    // Anything before 6 AM counts as the day before, same rule the schedule uses.
    if ((0, $5Ycxa.streamDayKey)(dateTo) > (0, $5Ycxa.streamDayKey)(now.valueOf())) return {
        label: '',
        duration: 'DOMANI'
    };
    let differenceInHoursRound = $hIdhk(dateTo).diff(now, "hours");
    let differenceInHours = $hIdhk(dateTo).diff(now, "hours", true);
    const minuteRemainder = differenceInHours % differenceInHoursRound || differenceInHours % 1;
    // >= 30M "IN MENO DI" H+1 || < 30M "FRA CIRCA"
    const moreThanHalfHour = minuteRemainder >= 0.5;
    let label = '';
    if (differenceInHoursRound > 0) label = moreThanHalfHour ? 'in meno di' : 'fra circa';
    else label = moreThanHalfHour ? 'fra circa' : 'in meno di';
    if (moreThanHalfHour) differenceInHoursRound += 1;
    // console.log(now, dateTo, differenceInHoursRound, differenceInHours, minuteRemainder);
    if (differenceInHoursRound < 1) differenceInHoursRound = 1;
    return {
        label: label,
        duration: $hIdhk.duration('PT' + differenceInHoursRound + 'H').locale('it').humanize().replace(/' /, "'")
    };
}
window.getWaitTime = $08f0832b872ea799$export$eb11d1adfbce682d;



/**
 * The scrambler behind the break screen's end-of-schedule filler.
 *
 * When the schedule runs out, each empty row renders `> GIOCATORE n PREMI START <` as
 * four `.fizzle` spans; this flickers random ones through junk characters so the rows do
 * not sit there dead. The Portal easter egg drives the same spans, which is why these
 * helpers live on their own — they are the one thing break-schedule-renderer and
 * still-alive.js share, and putting them here keeps those two from importing each other.
 *
 * No imports on purpose. Keep it that way.
 */ const $818d3a3bda89ca30$export$f73f740dd10d792b = {
    /** Spans currently showing junk, so two timers cannot scramble the same one. */ fizzling: [],
    fizzleWatcherInterval: undefined,
    getFizzle (row, index) {
        return document.querySelector('#break-next .fizzle-' + index + '.row-' + row);
    },
    fizzleTimer: (level, interval)=>{
        const fizzleIntervalN = setInterval(function() {
            $818d3a3bda89ca30$export$f73f740dd10d792b.fizzleOneRandom(level);
        }, interval);
        setTimeout(function() {
            clearInterval(fizzleIntervalN);
        }, $818d3a3bda89ca30$export$f73f740dd10d792b.getRandomNumber(100 * level, 400 * level));
    },
    getFizzleable () {
        return document.querySelectorAll('#break-next .fizzle');
    },
    fizzleOneRandom: (level)=>{
        let words = [
            "SOGG",
            "IORNO"
        ];
        const fizzleable = $818d3a3bda89ca30$export$f73f740dd10d792b.getFizzleable();
        const toFizzle = fizzleable[$818d3a3bda89ca30$export$f73f740dd10d792b.getRandomNumber(0, fizzleable.length)];
        const word = words[$818d3a3bda89ca30$export$f73f740dd10d792b.getRandomNumber(0, words.length)];
        $818d3a3bda89ca30$export$f73f740dd10d792b.fizzleOneWithWord(toFizzle, word, level);
    },
    fizzleOneWithWord (toFizzle, word, level) {
        if ($818d3a3bda89ca30$export$f73f740dd10d792b.fizzling.includes(toFizzle)) return;
        $818d3a3bda89ca30$export$f73f740dd10d792b.fizzling.push(toFizzle);
        const oldContents = toFizzle.innerHTML;
        toFizzle.innerHTML = word;
        const timeoutDuration = $818d3a3bda89ca30$export$f73f740dd10d792b.getRandomNumber(600 * level, 900 * level);
        setTimeout(function() {
            toFizzle.innerHTML = oldContents;
            var index = $818d3a3bda89ca30$export$f73f740dd10d792b.fizzling.indexOf(toFizzle);
            if (index !== -1) $818d3a3bda89ca30$export$f73f740dd10d792b.fizzling.splice(index, 1);
        }, timeoutDuration);
    },
    getRandomNumber (min, max) {
        return parseInt(Math.random() * (max - min) + min);
    }
};
window.fizzle = $818d3a3bda89ca30$export$f73f740dd10d792b;



var $bHJE2 = parcelRequire("bHJE2");


var $bHJE2 = parcelRequire("bHJE2");


const $534c039c68d25dba$export$5167e49cdb69acbf = {
    currentBgmIndex: 0,
    currentBgmScrollIndex: 0,
    maxBgmScrollIndex: 2,
    bgmScrollMaxLeft: 0,
    bgmScrollLeft: 0,
    bgmScrollElements: [],
    bgmCurrentTitle: '',
    scrollBgmInterval: null,
    scrollBgmLoop: ()=>{
        $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollElements = document.querySelectorAll('#media-player .media-title-text');
        $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollMaxLeft = $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollElements[$534c039c68d25dba$export$5167e49cdb69acbf.currentBgmScrollIndex].clientWidth;
        $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollElements.forEach((element, i)=>{
            element.style.order = i;
        });
        $534c039c68d25dba$export$5167e49cdb69acbf.scrollBgmInterval = setInterval(function() {
            $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollElements.forEach((element)=>{
                element.style.left = $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollLeft + 'px';
            });
            $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollLeft -= 1;
            if ($534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollLeft <= $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollMaxLeft * -1) {
                $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollLeft = 0;
                $534c039c68d25dba$export$5167e49cdb69acbf.currentBgmScrollIndex++;
                if ($534c039c68d25dba$export$5167e49cdb69acbf.currentBgmScrollIndex > $534c039c68d25dba$export$5167e49cdb69acbf.maxBgmScrollIndex) $534c039c68d25dba$export$5167e49cdb69acbf.currentBgmScrollIndex = 0;
                $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollElements.forEach((element)=>{
                    let order = parseInt(element.style.order);
                    order--;
                    if (order < 0) order += $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollElements.length;
                    element.style.order = order;
                });
                $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollMaxLeft = $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollElements[$534c039c68d25dba$export$5167e49cdb69acbf.currentBgmScrollIndex].clientWidth;
            }
        }, 30);
    },
    clearTtsFilename: ()=>{
        console.log("Clearing tts filename");
        try {
            fetch((0, $cd2554817816328b$export$28cf49ad70f82d12).chatDataEndpoint, {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${(0, $cd2554817816328b$export$28cf49ad70f82d12).offsetWriterToken}`,
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            }).then(async (data)=>{
                const responseCode = data.status;
                if (responseCode !== 204) {
                    console.error("Failed to clear tts filename");
                    return;
                }
                console.log("Cleared tts filename");
            });
        } catch (error) {
            console.error(error);
        }
    },
    canUseNewAudioChat: false,
    getChatAudio: ()=>{
        var _live_liveEventData_live, _live_liveEventData;
        const filename = (_live_liveEventData = (0, $cd2554817816328b$export$28cf49ad70f82d12).liveEventData) === null || _live_liveEventData === void 0 ? void 0 : (_live_liveEventData_live = _live_liveEventData.live) === null || _live_liveEventData_live === void 0 ? void 0 : _live_liveEventData_live.tts_filename;
        if (!filename) return null;
        return mainApiUrl + filename;
    },
    getNextRunBgms: ()=>{
        var _schedule_getNextRun_submission, _schedule_getNextRun;
        var _schedule_getNextRun_submission_bgms;
        return (_schedule_getNextRun_submission_bgms = (_schedule_getNextRun = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getNextRun(0)) === null || _schedule_getNextRun === void 0 ? void 0 : (_schedule_getNextRun_submission = _schedule_getNextRun.submission) === null || _schedule_getNextRun_submission === void 0 ? void 0 : _schedule_getNextRun_submission.bgms) !== null && _schedule_getNextRun_submission_bgms !== void 0 ? _schedule_getNextRun_submission_bgms : [];
    },
    getNextRunBgm: ()=>{
        let bgms = [];
        if ((0, $cd2554817816328b$export$28cf49ad70f82d12).getFreezeInforoll()) bgms = (0, $cd2554817816328b$export$28cf49ad70f82d12).getFreezeInforollMedia();
        else bgms = $534c039c68d25dba$export$5167e49cdb69acbf.getNextRunBgms();
        if (bgms.length == 0) return [];
        if (bgms.length <= $534c039c68d25dba$export$5167e49cdb69acbf.currentBgmIndex) $534c039c68d25dba$export$5167e49cdb69acbf.currentBgmIndex = 0;
        var _bgms_jukebox_currentBgmIndex;
        return (_bgms_jukebox_currentBgmIndex = bgms[$534c039c68d25dba$export$5167e49cdb69acbf.currentBgmIndex]) !== null && _bgms_jukebox_currentBgmIndex !== void 0 ? _bgms_jukebox_currentBgmIndex : [];
    },
    playNextRunBgmWithDelay: ()=>{
        setTimeout($534c039c68d25dba$export$5167e49cdb69acbf.playNextRunBgm, 6000);
    },
    setBgmMediaTitles: (nextRunBgm)=>{
        const titleArray = [
            (nextRunBgm === null || nextRunBgm === void 0 ? void 0 : nextRunBgm.artist) || '',
            (nextRunBgm === null || nextRunBgm === void 0 ? void 0 : nextRunBgm.song) || ''
        ];
        $534c039c68d25dba$export$5167e49cdb69acbf.bgmCurrentTitle = titleArray.join(' - ');
        (0, $bHJE2.default)({
            targets: '#media-player .media-title-container',
            opacity: 0,
            duration: 2000,
            easing: 'linear',
            complete: ()=>{
                $534c039c68d25dba$export$5167e49cdb69acbf.bgmScrollLeft = 0;
                clearInterval($534c039c68d25dba$export$5167e49cdb69acbf.scrollBgmInterval);
                document.querySelectorAll('#media-player .media-title-text').forEach((element)=>element.innerText = $534c039c68d25dba$export$5167e49cdb69acbf.bgmCurrentTitle);
                $534c039c68d25dba$export$5167e49cdb69acbf.scrollBgmLoop();
                (0, $bHJE2.default)({
                    targets: '#media-player .media-title-container',
                    opacity: 1,
                    duration: 2000,
                    easing: 'linear'
                });
            }
        });
    },
    playNextRunBgm: ()=>{
        let nextRunBgm = $534c039c68d25dba$export$5167e49cdb69acbf.getNextRunBgm();
        if (!nextRunBgm || nextRunBgm.length == 0) return;
        console.log("Next run BGM not empty, playing", nextRunBgm);
        $534c039c68d25dba$export$5167e49cdb69acbf.playBgm(nextRunBgm);
        $534c039c68d25dba$export$5167e49cdb69acbf.currentBgmIndex++;
    },
    maxChatAudio: 6,
    currentChatAudio: 0,
    disableChatAudio: true,
    queueNextChatAudio: ()=>{
        console.log("Playing next chat audio in 12s");
        setTimeout($534c039c68d25dba$export$5167e49cdb69acbf.playChatAudio, 12000);
    },
    playChatAudio: (force = false, path = null)=>{
        if ($534c039c68d25dba$export$5167e49cdb69acbf.disableChatAudio) return;
        if (!$534c039c68d25dba$export$5167e49cdb69acbf.canUseNewAudioChat && !force) {
            console.log("Cannot set new audio chat until flag is cleared.");
            $534c039c68d25dba$export$5167e49cdb69acbf.queueNextChatAudio();
            return;
        }
        const chatAudioUrl = path || $534c039c68d25dba$export$5167e49cdb69acbf.getChatAudio();
        if (!chatAudioUrl) {
            $534c039c68d25dba$export$5167e49cdb69acbf.queueNextChatAudio();
            return;
        }
        $534c039c68d25dba$export$5167e49cdb69acbf.canUseNewAudioChat = false;
        const audio = document.querySelector("#chat-audio audio");
        if (!force && $534c039c68d25dba$export$5167e49cdb69acbf.currentChatAudio >= $534c039c68d25dba$export$5167e49cdb69acbf.maxChatAudio) {
            $534c039c68d25dba$export$5167e49cdb69acbf.playOutroChatAudio();
            console.log("Disabling chat audio.");
            $534c039c68d25dba$export$5167e49cdb69acbf.disableChatAudio = true;
            return;
        }
        $534c039c68d25dba$export$5167e49cdb69acbf.clearTtsFilename();
        const sourceSelector = audio.querySelector("source");
        const bgmType = 'audio/wav';
        const bgmUrl = chatAudioUrl;
        sourceSelector.type = bgmType;
        sourceSelector.src = bgmUrl;
        console.log("Audio chat", bgmType, bgmUrl);
        audio.load();
        audio.volume = 0.19;
        $534c039c68d25dba$export$5167e49cdb69acbf.actualMaxBgmVolume = 0.01;
        (0, $bHJE2.default)({
            targets: $534c039c68d25dba$export$5167e49cdb69acbf.getBgmAudioElement(),
            duration: 2000,
            easing: 'linear',
            volume: $534c039c68d25dba$export$5167e49cdb69acbf.actualMaxBgmVolume
        });
        audio.play();
        $534c039c68d25dba$export$5167e49cdb69acbf.currentChatAudio++;
        console.log("Current chat audio count:", $534c039c68d25dba$export$5167e49cdb69acbf.currentChatAudio);
    },
    playIntroChatAudio: ()=>{
        $534c039c68d25dba$export$5167e49cdb69acbf.playChatAudio(true, 'resources/chat/intro.wav');
    },
    playOutroChatAudio: ()=>{
        $534c039c68d25dba$export$5167e49cdb69acbf.playChatAudio(true, 'resources/chat/outro.wav');
    },
    getBgmAudioElement: ()=>{
        return document.querySelector("#media-player audio");
    },
    resetBgmVolume: ()=>{
        $534c039c68d25dba$export$5167e49cdb69acbf.actualMaxBgmVolume = $534c039c68d25dba$export$5167e49cdb69acbf.maxBgmVolume;
        (0, $bHJE2.default)({
            targets: $534c039c68d25dba$export$5167e49cdb69acbf.getBgmAudioElement(),
            duration: 2000,
            easing: 'linear',
            volume: $534c039c68d25dba$export$5167e49cdb69acbf.actualMaxBgmVolume
        });
    },
    setChatAudioAsPlayable: ()=>{
        console.log("Can now play new audio chat.");
        $534c039c68d25dba$export$5167e49cdb69acbf.canUseNewAudioChat = true;
    },
    maxBgmVolume: 0.2,
    actualMaxBgmVolume: 0.2,
    playBgm: (bgm)=>{
        $534c039c68d25dba$export$5167e49cdb69acbf.setBgmMediaTitles(bgm);
        const audio = $534c039c68d25dba$export$5167e49cdb69acbf.getBgmAudioElement();
        const sourceSelector = audio.querySelector("source");
        const bgmType = 'audio/mpeg';
        const bgmUrl = bgm.file_name;
        sourceSelector.type = bgmType;
        sourceSelector.src = bgmUrl;
        console.log("BGM", bgmType, bgmUrl);
        audio.load();
        audio.volume = 0;
        (0, $bHJE2.default)({
            targets: audio,
            duration: 500,
            easing: 'linear',
            volume: $534c039c68d25dba$export$5167e49cdb69acbf.actualMaxBgmVolume
        });
        audio.play();
    }
};
/**
 * Attaches the audio players. Called from init after the first poll; does nothing
 * unless the page was opened with ?bgm=true.
 */ $534c039c68d25dba$export$5167e49cdb69acbf.setUp = ()=>{
    const bgm = new URLSearchParams(window.location.search).get('bgm') === 'true';
    if (!bgm) return;
    window.playBgm = true;
    console.log("BGM enabled, setting up event listeners and playing first BGM...");
    const audio = $534c039c68d25dba$export$5167e49cdb69acbf.getBgmAudioElement();
    audio.addEventListener("ended", $534c039c68d25dba$export$5167e49cdb69acbf.playNextRunBgmWithDelay, false);
    audio.volume = $534c039c68d25dba$export$5167e49cdb69acbf.actualMaxBgmVolume;
    $534c039c68d25dba$export$5167e49cdb69acbf.playNextRunBgmWithDelay();
    const chatAudio = document.querySelector("#chat-audio audio");
    chatAudio.addEventListener("ended", $534c039c68d25dba$export$5167e49cdb69acbf.resetBgmVolume, false);
    chatAudio.addEventListener("ended", $534c039c68d25dba$export$5167e49cdb69acbf.setChatAudioAsPlayable, false);
    chatAudio.addEventListener("ended", $534c039c68d25dba$export$5167e49cdb69acbf.queueNextChatAudio, false);
};
window.jukebox = $534c039c68d25dba$export$5167e49cdb69acbf;




var $hIdhk = parcelRequire("hIdhk");
const $c64ec2433c4d57c2$export$93cdb28a12c58527 = {
    lyrics: [
        [
            {
                text: [
                    "THIS",
                    "WAS",
                    "A",
                    "TRIUMPH"
                ],
                delayForNextRow: 3763
            },
            {
                text: [
                    "I'M",
                    "MAKING",
                    "A NOTE",
                    "HERE"
                ],
                delayForNextRow: 2221
            },
            {
                text: [
                    "HUGE",
                    "SUCCESS.",
                    "IT'S HARD",
                    "TO OVER-"
                ],
                delayForNextRow: 4773
            },
            {
                text: [
                    "STATE",
                    "MY",
                    "SATIS",
                    "FACTION"
                ],
                delayForNextRow: 5238,
                function: 'fadeOutAdBreak'
            }
        ],
        [
            {
                text: [
                    "APER",
                    "TURE",
                    "SCIE",
                    "NCE"
                ],
                delayForNextRow: 3749,
                ascii: 'aperture'
            },
            {
                text: [
                    "WE DO",
                    "WHAT WE",
                    "MUST, BECAUSE",
                    "WE CAN"
                ],
                delayForNextRow: 5272
            },
            {
                text: [
                    "FOR THE",
                    "GOOD OF",
                    "ALL OF",
                    "US"
                ],
                delayForNextRow: 3240
            },
            {
                text: [
                    "EXCEPT",
                    "THE ONES",
                    "WHO ARE",
                    "DEAD"
                ],
                delayForNextRow: 2236,
                ascii: 'nuclear'
            }
        ],
        [
            {
                text: [
                    "BUT",
                    "THERE'S",
                    "NO",
                    "SENSE"
                ],
                delayForNextRow: 1512,
                ascii: 'aperture'
            },
            {
                text: [
                    "CRYING",
                    "OVER",
                    "EVERY",
                    "MISTAKE"
                ],
                delayForNextRow: 2498
            },
            {
                text: [
                    "YOU",
                    "JUST",
                    "KEEP",
                    "ON TRYING"
                ],
                delayForNextRow: 1994
            },
            {
                text: [
                    "TILL YOU",
                    "RUN OUT",
                    "OF",
                    "CAKE"
                ],
                delayForNextRow: 2115
            }
        ],
        [
            {
                text: [
                    "AND THE",
                    "SCIENCE",
                    "GETS",
                    "DONE"
                ],
                delayForNextRow: 1902,
                ascii: 'atom'
            },
            {
                text: [
                    "AND YOU",
                    "MAKE A",
                    "NEAT",
                    "GUN"
                ],
                delayForNextRow: 1986
            },
            {
                text: [
                    "FOR THE",
                    "PEOPLE",
                    "WHO",
                    "ARE"
                ],
                delayForNextRow: 1854,
                ascii: 'aperture'
            },
            {
                text: [
                    "STI",
                    "LL",
                    "AL",
                    "IVE"
                ],
                delayForNextRow: 7393
            }
        ],
        [
            {
                text: [
                    "I'M",
                    "NOT",
                    "EVEN",
                    "ANGRY"
                ],
                delayForNextRow: 4225,
                ascii: 'isc'
            },
            {
                text: [
                    "I'M",
                    "BEING",
                    "SO SINCERE",
                    "RIGHT NOW"
                ],
                delayForNextRow: 5022
            },
            {
                text: [
                    "EVEN",
                    "THOUGH",
                    "YOU BROKE",
                    "MY HEART"
                ],
                delayForNextRow: 3505,
                ascii: 'heart'
            },
            {
                text: [
                    "AND",
                    "KIL",
                    "LED",
                    "ME"
                ],
                delayForNextRow: 3230
            }
        ],
        [
            {
                text: [
                    "AND",
                    "TORE ME",
                    "TO",
                    "PIECES"
                ],
                delayForNextRow: 3993,
                ascii: 'explosion'
            },
            {
                text: [
                    "AND THREW",
                    "EVERY PIECE",
                    "INTO",
                    "A FIRE"
                ],
                delayForNextRow: 5278,
                ascii: 'fire'
            },
            {
                text: [
                    "AS THEY",
                    "BURNED",
                    "IT HURT",
                    "BECAUSE"
                ],
                delayForNextRow: 3240
            },
            {
                text: [
                    "I WAS",
                    "SO",
                    "HAPPY",
                    "FOR YOU"
                ],
                delayForNextRow: 2245,
                ascii: 'ok'
            }
        ],
        [
            {
                text: [
                    "NOW THESE",
                    "POINTS",
                    "OF",
                    "DATA"
                ],
                delayForNextRow: 2004
            },
            {
                text: [
                    "MAKE",
                    "A",
                    "BEAUTIFUL",
                    "LINE"
                ],
                delayForNextRow: 2018,
                ascii: 'pingui'
            },
            {
                text: [
                    "AND",
                    "WE'RE",
                    "OUT OF",
                    "BETA"
                ],
                delayForNextRow: 1984
            },
            {
                text: [
                    "WE'RE",
                    "RELEASING",
                    "ON",
                    "TIME"
                ],
                delayForNextRow: 1994
            }
        ],
        [
            {
                text: [
                    "SO I'M",
                    "GLAD",
                    "I GOT",
                    "BURNED"
                ],
                delayForNextRow: 2023,
                ascii: 'explosion'
            },
            {
                text: [
                    "THINK",
                    "OF ALL",
                    "THE THINGS",
                    "WE LEARNED"
                ],
                delayForNextRow: 1994,
                ascii: 'atom'
            },
            {
                text: [
                    "FOR THE",
                    "PEOPLE",
                    "WHO",
                    "ARE"
                ],
                delayForNextRow: 1757,
                ascii: 'aperture'
            },
            {
                text: [
                    "STI",
                    "LL",
                    "AL",
                    "IVE"
                ],
                delayForNextRow: 7726
            }
        ],
        [
            {
                text: [
                    "GO",
                    "AHEAD",
                    "AND",
                    "LEAVE ME"
                ],
                delayForNextRow: 4012,
                ascii: 'noTasto'
            },
            {
                text: [
                    "I THINK",
                    "I PREFER",
                    "TO STAY",
                    "INSIDE"
                ],
                delayForNextRow: 4978
            },
            {
                text: [
                    "MAYBE",
                    "YOU'LL",
                    "FIND",
                    "SOMEONE ELSE"
                ],
                delayForNextRow: 3534,
                ascii: 'isc'
            },
            {
                text: [
                    "TO",
                    "HE",
                    "LP",
                    "YOU?"
                ],
                delayForNextRow: 3476
            }
        ],
        [
            {
                text: [
                    "MAYBE",
                    "BLACK",
                    "MESA",
                    "?"
                ],
                delayForNextRow: 3761,
                ascii: 'blackMesa'
            },
            {
                text: [
                    "THAT WAS",
                    "A JOKE",
                    "HAHA",
                    "FAT CHANCE"
                ],
                delayForNextRow: 5254
            },
            {
                text: [
                    "ANYWAY",
                    "THIS",
                    "CAKE",
                    "IS GREAT"
                ],
                delayForNextRow: 3235,
                ascii: 'cake'
            },
            {
                text: [
                    "IT'S SO",
                    "DELICIOUS",
                    "AND",
                    "MOIST"
                ],
                delayForNextRow: 2255
            }
        ],
        [
            {
                text: [
                    "LOOK AT",
                    "ME",
                    "STILL",
                    "TALKING"
                ],
                delayForNextRow: 2008,
                ascii: 'atom'
            },
            {
                text: [
                    "WHEN",
                    "THERE'S",
                    "SCIENCE",
                    "TO DO"
                ],
                delayForNextRow: 2245
            },
            {
                text: [
                    "WHEN I",
                    "LOOK",
                    "OUT",
                    "THERE"
                ],
                delayForNextRow: 1733,
                ascii: 'aperture'
            },
            {
                text: [
                    "IT MAKES",
                    "ME GLAD",
                    "I'M NOT",
                    "YOU"
                ],
                delayForNextRow: 2042
            }
        ],
        [
            {
                text: [
                    "I'VE",
                    "EXPERIMENTS",
                    "TO",
                    "RUN"
                ],
                delayForNextRow: 1960,
                'ascii': 'atom'
            },
            {
                text: [
                    "THERE IS",
                    "RESEARCH",
                    "TO",
                    "BE DONE"
                ],
                delayForNextRow: 2023,
                ascii: 'aperture'
            },
            {
                text: [
                    "ON THE",
                    "PEOPLE",
                    "WHO",
                    "ARE"
                ],
                delayForNextRow: 1743
            },
            {
                text: [
                    "STI",
                    "LL",
                    "AL",
                    "IVE"
                ],
                delayForNextRow: 2260
            }
        ],
        [
            {
                text: [
                    "PS: AND",
                    "BELIEVE",
                    "ME I",
                    "AM"
                ],
                delayForNextRow: 1868,
                ascii: 'isc'
            },
            {
                text: [
                    "STI",
                    "LL",
                    "AL",
                    "IVE"
                ],
                delayForNextRow: 1873
            },
            {
                text: [
                    "PPS: I'M",
                    "DOING",
                    "SCIENCE",
                    "AND I'M"
                ],
                delayForNextRow: 1999
            },
            {
                text: [
                    "STI",
                    "LL",
                    "AL",
                    "IVE"
                ],
                delayForNextRow: 2231
            }
        ],
        [
            {
                text: [
                    "PPPS: I FEEL",
                    "FANTASTIC",
                    "AND",
                    "I'M"
                ],
                delayForNextRow: 1762,
                ascii: 'aperture'
            },
            {
                text: [
                    "STI",
                    "LL",
                    "AL",
                    "IVE"
                ],
                delayForNextRow: 2231
            },
            {
                text: [
                    "WHILE",
                    "YOU'RE",
                    "DYING",
                    "I'LL BE"
                ],
                delayForNextRow: 1516,
                ascii: 'interloper1'
            },
            {
                text: [
                    "STI",
                    "LL",
                    "AL",
                    "IVE"
                ],
                delayForNextRow: 2221,
                ascii: 'aperture'
            }
        ],
        [
            {
                text: [
                    "AND WHEN",
                    "YOU'RE DEAD",
                    "I WILL",
                    "BE"
                ],
                delayForNextRow: 2008,
                ascii: 'interloper2'
            },
            {
                text: [
                    "ST",
                    "ILL",
                    "AL",
                    "IVE"
                ],
                delayForNextRow: 2023,
                ascii: 'cake'
            },
            {
                text: [
                    "GRAZIE",
                    "ISC",
                    "0xFREE",
                    "0xC0CC0"
                ],
                delayForNextRow: 2004
            },
            {
                text: [
                    "SAVE",
                    "PIETRO",
                    "SAVE",
                    "THE WORLD"
                ],
                delayForNextRow: 4000,
                ascii: 'isc'
            }
        ]
    ],
    singLevel (level) {
        for(let currentRow = 0; currentRow < 4; currentRow++)$c64ec2433c4d57c2$export$93cdb28a12c58527.singRow(level, currentRow, false, true);
    },
    singRow (level, row, autoAdvance = true, useTimer = false) {
        const currentRow = $c64ec2433c4d57c2$export$93cdb28a12c58527.lyrics[level][row];
        console.log("song currentRow", currentRow);
        if (currentRow.ascii) $c64ec2433c4d57c2$export$93cdb28a12c58527.showSongAscii(currentRow.ascii);
        if (currentRow.function) $c64ec2433c4d57c2$export$93cdb28a12c58527[currentRow.function]();
        for(let currentWord = 0; currentWord < 4; currentWord++){
            let toFizzle = (0, $818d3a3bda89ca30$export$f73f740dd10d792b).getFizzle(row + 1, currentWord + 1);
            setTimeout(function() {
                (0, $818d3a3bda89ca30$export$f73f740dd10d792b).fizzleOneWithWord(toFizzle, currentRow.text[currentWord], 7);
            }, 140 * currentWord + row * 2400 * (useTimer ? 1 : 0));
        }
        if (!autoAdvance) return;
        row++;
        if (row >= 4) {
            row = 0;
            level++;
        }
        if (level >= $c64ec2433c4d57c2$export$93cdb28a12c58527.lyrics.length) {
            console.log("song ended");
            setTimeout(function() {
                (0, $bHJE2.default)({
                    targets: '.break-opacity',
                    duration: 3000,
                    easing: 'linear',
                    opacity: 0,
                    complete: function() {
                        document.querySelector(".ad-container").style.display = 'block';
                        document.querySelector(".incentive-container").style.display = 'flex';
                        document.querySelector(".song-container").style.display = 'none';
                        (0, $bHJE2.default)({
                            targets: '.break-opacity',
                            duration: 3000,
                            easing: 'linear',
                            opacity: 1
                        });
                    }
                });
            }, 8000);
            return;
        }
        console.log("song level, row", level, row);
        setTimeout(function() {
            $c64ec2433c4d57c2$export$93cdb28a12c58527.singRow(level, row);
        }, currentRow.delayForNextRow);
    },
    showSongAscii: (asciiName)=>{
        const heart = `                          .,---.
                        ,/XM#MMMX;,
                      -%##########M%,
                     -@######%  $###@=
      .,--,         -H#######$   $###M:
   ,;$M###MMX;     .;##########$;HM###X=
,/@###########H=      ;################+
-+#############M/,      %##############+
%M###############=      /##############:
H################      .M#############;.
@###############M      ,@###########M:.
X################,      -$=X#######@:
/@##################%-     +######$-
.;##################X     .X#####+,
 .;H################/     -X####+.
   ,;X##############,       .MM/
      ,:+$H@M#######M#$-    .$$=
           .,-=;+$@###X:    ;/=.
                  .,/X$;   .::,
                      .,    ..`;
        const aperture = `             .,-:;//;:=,
         . :H@@@MM@M#H/.,+%;,
      ,/X+ +M@@M@MM%=,-%HMMM@X/,
     -+@MM; $M@@MH+-,;XMMMM@MMMM@+-
    ;@M@@M- XM@X;. -+XXXXXHHH@M@M#@/.
  ,%MM@@MH ,@%=            .---=-=:=,.
  -@#@@@MX .,              -%HX$$%%%+;
 =-./@M@M$                  .;@MMMM@MM:
 X@/ -$MM/                    .+MM@@@M$
,@M@H: :@:                    . -X#@@@@-
,@@@MMX, .                    /H- ;@M@M=
.H@@@@M@+,                    %MM+..%#$.
 /MMMM@MMH/.                  XM@MH; -;
  /%+%$XHH@$=              , .H@@@@MX,
   .=--------.           -%H.,@@@@@MX,
   .%MM@@@HHHXX$$$%+- .:$MMX -M@@MM%.
     =XMMM@MM@MM#H;,-+HMM@M+ /MMMX=
       =%@M@M#@$-.=$@MM@@@M; %M%=
         ,:+$+-,/H#MMMMMMM@- -,
               =++%%%%+/:-.`;
        const nuclear = `             =+$HM####@H%;,
          /H###############M$,
          ,@################+
           .H##############+
             X############/
              $##########/
               %########/
                /X/;;+X/

                 -XHHX-
                ,######,
#############X  .M####M.  X#############
##############-   -//-   -##############
X##############%,      ,+##############X
-##############X        X##############-
 %############%          %############%
  %##########;            ;##########%
   ;#######M=              =M#######;
    .+M###@,                ,@###M+.
       :XH.                  .HX:`;
        const atom = `                 =/;;/-
                +:    //
               /;      /;
              -X        H.
.//;;;:;;-,   X=        :+   .-;:=;:;%;.
M-       ,=;;;#:,      ,:#;;:=,       ,@
:%           :%.=/++++/=.$=           %=
 ,%;         %/:+/;,,/++:+/         ;+.
   ,+/.    ,;@+,        ,%H;,    ,/+,
      ;+;;/= @.  .H##X   -X :///+;
      ;+=;;;.@,  .XM@$.  =X.//;=%/.
   ,;:      :@%=        =$H:     .+%-
 ,%=         %;-///==///-//         =%,
;+           :%-;;;;;;;;-X-           +:
@-      .-;;;;M-        =M/;;;-.      -X
 :;;::;;-.    %-        :+    ,-;;-;:==
              ,X        H.
               ;/      %=
                //    +;
                 ,////,`;
        const fire = `                     -$-
                    .H##H,
                   +######+
                .+#########H.
              -$############@.
            =H###############@  -X:
          .$##################:  @#@-
     ,;  .M###################;  H###;
   ;@#:  @###################@  ,#####:
 -M###.  M#################@.  ;######H
 M####-  +###############$   =@#######X
 H####$   -M###########+   :#########M,
  /####X-   =########%   :M########@/.
    ,;%H@X;   .$###X   :##MM@%+;:-
                 ..
  -/;:-,.              ,,-==+M########H
 -##################@HX%%+%%$%%%+:,,
    .-/H%%%+%%$H@###############M@+=:/+:
/XHX%:#####MH%=    ,---:;;;;/&&XHM,:###$
$@#MX %+;-                           .`;
        const ok = `                                     :X-
                                  :X###
                                ;@####@
                              ;M######X
                            -@########$
                          .$##########@
                         =M############-
                        +##############$
                      .H############$=.
         ,/:         ,M##########M;.
      -+@###;       =##########M;
   =%M#######;     :#########M/
-$M###########;   :########/
 ,;X###########; =#######$.
     ;H#########+######M=
       ,+#############+
          /M########@-
            ;M#####%
              +####:
               ,$M-`;
        const explosion = `            .+
             /M;
              H#@:              ;,
              -###H-          -@/
               %####$.  -;  .%#X
                M#####+;#H :M#M.
..          .+/;%#############-
 -/%H%+;-,    +##############/
    .:$M###MH$%+############X  ,--=;-
        -/H#####################H+=.
           .+#################X.
         =%M####################H;.
            /@###############+;;/%%;,
         -%###################$
       ;H######################M=
    ,%#####MH$%;+#####M###-/@####%
  :$H%+;=-      -####X.,H#   -+M##@-
 .              ,###;    ;      =$##+
                .#H,               :XH,
                 +                   .;-`;
        const blackMesa = `           .-;+$XHHHHHHX$+;-.
        ,;X@@X%/;=----=:/%X@@X/,
      =$@@%=.              .=+H@X:
    -XMX:                      =XMX=
   /@@:                          =H@+
  %@X,                            .$@$
 +@X.                               $@%
-@@,                                .@@=
%@%                                  +@$
H@:                                  :@H
H@:         :HHHHHHHHHHHHHHHHHHX,    =@H
%@%         ;@M@@@@@@@@@@@@@@@@@H-   +@$
=@@,        :@@@@@@@@@@@@@@@@@@@@@= .@@:
 +@X        :@@@@@@@@@@@@@@@M@@@@@@:%@%
  $@$,      ;@@@@@@@@@@@@@@@@@M@@@@@@$.
   +@@HHHHHHH@@@@@@@@@@@@@@@@@@@@@@@+
    =X@@@@@@@@@@@@@@@@@@@@@@@@@@@@X=
      :$@@@@@@@@@@@@@@@@@@@M@@@@$:
        ,;$@@@@@@@@@@@@@@@@@@X/-
           .-;+$XXHHHHHX$+;-.`;
        const cake = `            ,:/+/-
            /M/              .,-=;//;-
       .:/= ;MH/,    ,=/+%$XH@MM#@:
      -$##@+$###@H@MMM#######H:.    -/H#
 .,H@H@ X######@ -H#####@+-     -+H###@X
  .,@##H;      +XM##M/,     =%@###@X;-
X%-  :M##########$.    .:%M###@%:
M##H,   +H@@@$/-.  ,;$M###@%,          -
M####M=,,---,.-%%H####M$:          ,+@##
@##################@/.         :%H##@$-
M###############H,         ;HM##M$=
#################.    .=$M##M$=
################H..;XM##M$=          .:+
M###################@%=           =+@MH%
@#################M/.         =+H#X%=
=+M###############M,      ,/X#H+:,
  .;XM###########H=   ,/X#H+:;
     .=+HM#######M+/+HM@+=.
         ,:/%XM####H/.
              ,.:=-.`;
        const glados = `       #+ @      # #              M#@
 .    .X  X.%##@;# #   +@#######X. @H%
   ,==.   ,######M+  -#####%M####M-    #
  :H##M%:=##+ .M##M,;#####/+#######% ,M#
 .M########=  =@#@.=#####M=M#######=  X#
 :@@MMM##M.  -##M.,#######M#######. =  M
             @##..###:.    .H####. @@ X,
   ############: ###,/####;  /##= @#. M
           ,M## ;##,@#M;/M#M  @# X#% X#
.%=   ######M## ##.M#:   ./#M ,M #M ,#$
##/         $## #+;#: #### ;#/ M M- @# :
#+ #M@MM###M-;M #:$#-##$H# .#X @ + $#. #
      ######/.: #%=# M#:MM./#.-#  @#: H#
+,.=   @###: /@ %#,@  ##@X #,-#@.##% .@#
#####+;/##/ @##  @#,+       /#M    . X,
   ;###M#@ M###H .#M-     ,##M  ;@@; ###
   .M#M##H ;####X ,@#######M/ -M###$  -H
    .M###%  X####H  .@@MM@;  ;@#M@
      H#M    /@####/      ,++.  / ==-,
               ,=/:, .+X@MMH@#H  #####$=`;
        const isc = `
        
        
        
        
  .@@@@    -+#@@@@%#=.      .=*%@@@@%#= 
  =@@@#  =@@@@@@@@@@@@=   =%@@@@@@@@@=-:
  #@@@+ =@@@%:   .+@@#- =@@@@%=:...:-*: 
  @@@@: #@@@*      :.  *@@@%:     =%*   
 :@@@@  =@@@@@%#*=:   =@@@%     =@@-    
 +@@@*   :*@@@@@@@@@+ %@@@-    =@#.     
 %@@@-      .:-+#@@@@+%@@@+             
.@@@@. +@#.      #@@@+-@@@@+            
=@@@% @@@@@*=--+#@@@#  =@@@@@#+++*#*    
#@@@+ .+@@@@@@@@@@%-    .+@@@@@@@@@@*   `;
        const lfr = `              **.                       
             +#+                        
           -*#=   .       :             
        .-=-+#*:=#+:.   .+:             
           -+**=-.     =*-              
        .=**=.       -++=   .:          
       :**-        :++++      --        
      :*+.       .=++++.       :=       
      ++        -+++++:         -=      
     :+:      :======-          .*.     
     :+     :==========-:.       +:     
     .+      .::-==========-:.  .+:     
      =:          .:-======-:   =+      
       =.          .-====-.    -+:      
        -.        :----:     .=+-       
         .:      ----.     .-==.        
            .  .--:     .-==-.          
              :-.   ..:::..             
            .:.`;
        const mdm = `            .:--==+++++==-:.            
         :=++++---=+:=+--=+++=:         
      .=++=-:++ =- + =.-==-:++++=.      
    .=++=+-.:-=:.::+.+.:=-.=++++++=.    
   -+++= .:=.:-++++++++++-=+++++++++-   
  =++- :: --+++----------=+++++++++++=  
 -+++++-:=++=--++---:-+++=--+++-=-.+++- 
.++++++++++--++++.    .++++==++ -:-:.-+.
=+++++++++--+++++:     =:::-+++--=-:=++=
++++++++++.++             . :+-=-.:::=++
+++--::=++.++              .::-++=-+++++
=++ ==::++:=+=:...     ::-=++:+++++++++=
.++=---:-++:=++++=     -++++:=+=-=+++++:
 -++:..::=++--+++=    :+++--++-.-:.=++= 
  =++.==-.=+++----====----=+=--:::.=+=  
   -+++.:++++==++++===+++==:.=:.++++-   
    .=++:++++. +=.=:::=:.-.=-.::++=.    
      .=++++-:....-.+-.=.-:.++++=:      
        .:=+++=+-=+:::-+==+++=:.        
            .:-===+++++==-:.`;
        const bolognaNerd = `            :-=+*##%%##**=-:            
        .-*%%%%%%%%%%%%%%%%%%*=.        
      :*%%%%%%%%%%%%#*#**#*%%%%%*:      
    :*%%%%%%%%%%%%%%++++++=%%%%%%%#:    
   =%%%%%%%%%%%%%%%%%-+**=+%%%%%%%%%+   
  *%%%%%%%%%%%%%%%%#=======*%%%%%%%%%*  
 +%%%%%%%%%%%%%%%%%%+***+*+#%%%%%%%%%%* 
:%%%%%%%%%%%%%%*#%%%%=#%%+#%%%%%%%%%%%%-
*%%%%%%%%%%%%%*+***=#=#%%+#%%%%%%%%%%%%*
#%%%%%%%%%%%%%=%%+*=#-+++==%%%%%%%%%%%%%
#%%%%%%%%%%%%**%*++#++****=+%%%%%%%%%%%%
*%%%%%%%%%%%%-%%+*=%-######=%%%%%%%%%%%*
:%%%%%%%%%%#+*#:**+*=%%%%%%-#%%%%%%%%%%-
 +%%%%%%%%%=#+*#***#***+*#+%=%%%%%%%%%* 
  *%%%%%%%%=#+#+*++**+*#++*#=%%%%%%%%*  
   +%%%%%%%=* : + :+.: = + #=%%%%%%%+   
    :#%%%%%=#-#-*-=+-+-*-==%=%%%%%#-    
      -*%%%#****************#%%%#-      
        .=*%%%%%%%%%%%%%%%%%%#=.        
            :-+*##%%%%##*+=:`;
        const pingui = `                                        
         :-.                            
       .*++++--:                        
      .****+=-:.                        
  +==+***+*+:                           
 .=*++=.:=+=:-                          
   *#=-+::+++=====:                     
   =#*-.  *++*-                         
    =#+  .-=++=.                        
     .++.     .                         
       :*=.     .               =-:-==+-
        =#*-::   .-          :=++++++:  
       :=**--==.  -==-:::--==++++*+:    
    :=+===++--==-:-..=#*++++++**+:      
  .+++++++***+++-:--=.-**#**#+-         
 =*+++++*##**+++-::--..-**=:            
-#*++=++#%##*+++-::.-=::*:              
%#*+++====+++++=-:::=-::*.              
====------::::-:....::..-`;
        const noTasto = `
                          =***=:.       
                         *%#*#%%%%+     
                       .:*%%%%@@@@@%    
                       -+*#@@@@@@@@@:   
     ==:                *%@%%%@@@@@*    
 :=+==++=:              #%%@@%%@%%+     
  .++===++*++++-:::::-=+*%@%##%%%%*-.   
    .--:::+****+======++==#*+====+=---. 
             ::::-------=+*++=--::---=- 
                        -+*===+--::::-: 
                       :-**=**=::::::-: 
                       -=*##==--:::::-- 
                       =+%#+--=---:::--.
                      -=*%*=====------- 
                     .++*#+*++*==------ 
                   -*%%+***++**====-==: 
               ---=#@@%***#+***+======  
             -+**++=+*%%%#*+#*+=+====-  `;
        const interloper1 = `
                 ::-=-.                 
             .+%@@@#@@@@%*:             
           :#@@@@@@=@@@@@@@%=           
          =@@@#%@@@%=@@@@@@@@=          
          @@@@@#***#-%%#****%@          
          -@@@@@@@@@+-#%@@@@@=          
           -%@@%%%@@#+@@@@@%=           
             ++@@@+%#+@@@#=             
           .*@:+@@ %#+%-                
          .@@@%...+@-.-@:               
          .@@@@@*%@@@-:@-               
          :@@@@@@@@@@@@@=               
          :@@@@@@@@@@@%=.               
          :@@@@@@@@@@@+                 
           .+@@@@@@@@@=                 
            .@@@@@@@@@=                 
            .@@@@@@@@@-                 
            .@@@@@@@@@-                 
            .@@@@@@@@@:                 
             +++++++++.                 `;
        const interloper2 = `
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2592}\u{2592}\u{2592}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2593}\u{2588}\u{2588}\u{2588}\u{2588}\u{2593}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2593}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2592}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2592}\u{2588}\u{2588}\u{2588}\u{2593}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2593}\u{2593}\u{2593}\u{2593}\u{2592}\u{2588}\u{2588}\u{2588}\u{2593}\u{2593}\u{2593}\u{2593}\u{2588}\u{2588}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2592}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2593}\u{2592}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2592}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2593}\u{2593}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2593}\u{2593}\u{2588}\u{2588}\u{2588}\u{2593}\u{2588}\u{2593}\u{2593}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2593}\u{2588}\u{2592}\u{2593}\u{2588}\u{2588}\u{2591}\u{2588}\u{2593}\u{2593}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2588}\u{2588}\u{2588}\u{2588}\u{2591}\u{2591}\u{2591}\u{2593}\u{2588}\u{2592}\u{2591}\u{2592}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2593}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2591}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2592}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2593}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2593}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2592}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}
\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2593}\u{2593}\u{2593}\u{2593}\u{2593}\u{2593}\u{2593}\u{2593}\u{2593}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}\u{2591}`;
        const ascii = {
            heart: heart,
            aperture: aperture,
            nuclear: nuclear,
            atom: atom,
            fire: fire,
            ok: ok,
            explosion: explosion,
            blackMesa: blackMesa,
            cake: cake,
            glados: glados,
            isc: isc,
            lfr: lfr,
            mdm: mdm,
            bolognaNerd: bolognaNerd,
            pingui: pingui,
            noTasto: noTasto,
            interloper1: interloper1,
            interloper2: interloper2
        };
        const asciiElement = document.querySelector('#song-ascii');
        asciiElement.innerHTML = '';
        $c64ec2433c4d57c2$export$93cdb28a12c58527.showNextChar(asciiElement, ascii[asciiName]);
    },
    asciiTimer: undefined,
    showNextChar: (element, text, index = 0)=>{
        if ($c64ec2433c4d57c2$export$93cdb28a12c58527.asciiTimer) clearTimeout($c64ec2433c4d57c2$export$93cdb28a12c58527.asciiTimer);
        $c64ec2433c4d57c2$export$93cdb28a12c58527.asciiTimer = setTimeout(function() {
            $c64ec2433c4d57c2$export$93cdb28a12c58527.appendAscii(element, text.charAt(index));
            index++;
            if (index >= text.length) return;
            $c64ec2433c4d57c2$export$93cdb28a12c58527.appendAscii(element, text.charAt(index));
            index++;
            if (index >= text.length) return;
            $c64ec2433c4d57c2$export$93cdb28a12c58527.showNextChar(element, text, index);
        }, 1);
    },
    appendAscii: (element, char)=>{
        element.innerHTML += char;
    },
    fadeOutAdBreak: ()=>{
        (0, $bHJE2.default)({
            targets: '.break-opacity',
            duration: 3000,
            easing: 'linear',
            opacity: 0,
            complete: function() {
                document.querySelector(".ad-container").style.display = 'none';
                document.querySelector(".incentive-container").style.display = 'none';
                document.querySelector(".break-opacity").style.opacity = 1;
            }
        });
    },
    /**
   * Called by the fizzle watcher when the break screen has exactly six filler rows.
   * Everything past the early return is the dormant performance.
   */ startSong: ()=>{
        if (!window.playBgm) {
            console.log("Requested song, but no playBgm function.");
            return;
        }
        console.log("Requested song.");
        console.log("Song available from", "2024-10-27", $hIdhk().format());
        if (!window.cake && !$hIdhk().isAfter("2024-10-27")) {
            console.log("Song is not yet available.");
            return;
        }
        return; // dormant — remove to bring the song back
    }
};
window.stillAlive = $c64ec2433c4d57c2$export$93cdb28a12c58527;


const $846c6604f52b4faa$export$73a1920e79733bc4 = {
    breakNextGameNameAlternateAnimation: undefined,
    breakNextGameCategoryAlternateAnimation: undefined,
    endCounter: 1,
    getRunnerFormattedString: (run)=>{
        var _run_submission_runners, _run_submission;
        var _run_submission_runners_map;
        const runners = (_run_submission_runners_map = run === null || run === void 0 ? void 0 : (_run_submission = run.submission) === null || _run_submission === void 0 ? void 0 : (_run_submission_runners = _run_submission.runners) === null || _run_submission_runners === void 0 ? void 0 : _run_submission_runners.map((r)=>{
            var _r_user;
            return (_r_user = r.user) === null || _r_user === void 0 ? void 0 : _r_user.name;
        })) !== null && _run_submission_runners_map !== void 0 ? _run_submission_runners_map : [];
        return runners.join(' <span class="no-hl">e</span> ');
    },
    getRunElapsedFormattedString: (run)=>{
        var _run_duration;
        let estimateDuration = (_run_duration = run === null || run === void 0 ? void 0 : run.duration) !== null && _run_duration !== void 0 ? _run_duration : 0;
        let estimate = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getDurationFromSeconds(estimateDuration);
        return estimate.format('HH:mm:ss');
    },
    updateAndShowAllBreakRuns: ()=>{
        // The schedule redraws on every schedule change…
        let timeline = (0, $bHJE2.default).timeline();
        $846c6604f52b4faa$export$73a1920e79733bc4.updateBreakNextRun(timeline);
        for(let x = 1; x <= 5; x++)$846c6604f52b4faa$export$73a1920e79733bc4.updateBreakNextNthRun(x, timeline);
    // The ad/incentive carousel is driven by breakCarousel (js/break-carousel.js),
    // which init wires to the same schedule refresh and starts exactly once.
    },
    updateBreakRunCommonData: (rootElement, data, index)=>{
        var _data_submission, _data_submission1;
        const nameElement = document.querySelector(rootElement + ' .what .name');
        const categoryElement = document.querySelector(rootElement + ' .what .category');
        const runnerElement = document.querySelector(rootElement + ' .who .name');
        const elapsedElement = document.querySelector(rootElement + ' .who .elapsed');
        let changed = false;
        var _ref;
        changed = (_ref = nameElement.innerHTML === (data === null || data === void 0 ? void 0 : data.name)) !== null && _ref !== void 0 ? _ref : '';
        var _ref1;
        changed = (_ref1 = categoryElement.innerHTML === (data === null || data === void 0 ? void 0 : (_data_submission = data.submission) === null || _data_submission === void 0 ? void 0 : _data_submission.category)) !== null && _ref1 !== void 0 ? _ref1 : '';
        const runnerFormattedString = $846c6604f52b4faa$export$73a1920e79733bc4.getRunnerFormattedString(data);
        var _data_name;
        const gameName = (_data_name = data === null || data === void 0 ? void 0 : data.name) !== null && _data_name !== void 0 ? _data_name : '';
        var _data_submission_category;
        const categoryName = (_data_submission_category = data === null || data === void 0 ? void 0 : (_data_submission1 = data.submission) === null || _data_submission1 === void 0 ? void 0 : _data_submission1.category) !== null && _data_submission_category !== void 0 ? _data_submission_category : '';
        nameElement.innerHTML = gameName;
        categoryElement.innerHTML = categoryName;
        runnerElement.innerHTML = runnerFormattedString;
        elapsedElement.innerHTML = $846c6604f52b4faa$export$73a1920e79733bc4.getRunElapsedFormattedString(data);
        const whoElement = document.querySelector(rootElement + ' .who');
        if (runnerFormattedString === '') whoElement.classList.add('hide');
        else whoElement.classList.remove('hide');
        if (gameName === '' && categoryName === '') {
            const chevronElement = document.querySelector(rootElement + ' .chevron');
            chevronElement.classList.add('hide');
            const endElement = document.querySelector(rootElement + ' .end');
            endElement.classList.remove('hide');
            const endElementSpan = document.querySelector(rootElement + ' .end span');
            endElementSpan.innerHTML = "> <span class='fizzle fizzle-1 row-" + $846c6604f52b4faa$export$73a1920e79733bc4.endCounter + "'>GIOCATORE</span> <span class='fizzle fizzle-2 row-" + $846c6604f52b4faa$export$73a1920e79733bc4.endCounter + "'>" + $846c6604f52b4faa$export$73a1920e79733bc4.endCounter + "</span> <span class='fizzle fizzle-3 row-" + $846c6604f52b4faa$export$73a1920e79733bc4.endCounter + "'>PREMI</span> <span class='fizzle fizzle-4 row-" + $846c6604f52b4faa$export$73a1920e79733bc4.endCounter + "'>START</span> <";
            $846c6604f52b4faa$export$73a1920e79733bc4.endCounter++;
        }
        if (index === 0) {
            nameElement.classList.remove('alternate');
            categoryElement.classList.remove('alternate');
            if (nameElement.getBoundingClientRect().top !== categoryElement.getBoundingClientRect().top) {
                nameElement.classList.add('alternate');
                categoryElement.classList.add('alternate');
            }
        }
        (0, $28bc6842b9ad21c7$export$b94583dc679500d).decreaseFontSizeUntilItFits(nameElement, 2);
        return changed;
    },
    startFizzleWatcher: ()=>{
        const fizzleableLength = (0, $818d3a3bda89ca30$export$f73f740dd10d792b).getFizzleable().length / 4;
        console.log("Started fizzle watcher: length", fizzleableLength);
        if (fizzleableLength <= 0) return;
        // Exactly six filler rows is the cue the Portal easter egg listens for. It is
        // dormant, so in practice this always falls through to the scrambler.
        if (fizzleableLength === 6) {
            (0, $c64ec2433c4d57c2$export$93cdb28a12c58527).startSong();
            return;
        }
        const fizzleInterval = 720000 / (fizzleableLength + 1) / 2;
        console.log("Fizzling every", fizzleInterval);
        (0, $818d3a3bda89ca30$export$f73f740dd10d792b).fizzleWatcherInterval = setInterval(function() {
            (0, $818d3a3bda89ca30$export$f73f740dd10d792b).fizzleTimer(4, 25);
            console.log("Fizzled");
        }, fizzleInterval);
    },
    updateBreakNextRun: (timeline)=>{
        const nextRun = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getNextRun(0);
        const rootElement = '#break-next .next-run';
        if (nextRun.length === 0) return;
        $846c6604f52b4faa$export$73a1920e79733bc4.updateBreakRunCommonData(rootElement, nextRun, 0);
        $846c6604f52b4faa$export$73a1920e79733bc4.showBreakRun(rootElement, timeline, 0);
        console.log("NEXT RUN:", nextRun);
    },
    updateBreakNextNthRun: (index, timeline)=>{
        const nextRun = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getNextRun(index);
        const rootElement = '#break-next .future-runs .game:nth-child(' + index + ')';
        $846c6604f52b4faa$export$73a1920e79733bc4.updateBreakRunCommonData(rootElement, nextRun, index);
        const timeInElement = document.querySelector(rootElement + ' .when .in');
        const timeEstimateElement = document.querySelector(rootElement + ' .when .estimate');
        // .when .in/.estimate
        const waitTime = (0, $08f0832b872ea799$export$eb11d1adfbce682d)((0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getRunStartDate(nextRun));
        timeInElement.innerHTML = waitTime.label;
        timeEstimateElement.innerHTML = waitTime.duration;
        $846c6604f52b4faa$export$73a1920e79733bc4.showBreakRun(rootElement, timeline, index);
    },
    showBreakRun: (rootElement, timeline, index)=>{
        const animeData = {
            targets: rootElement,
            opacity: 1,
            easing: 'easeInOutQuad',
            duration: 2000,
            delay: index === 0 ? 1500 : 0
        };
        if (!!timeline) timeline.add(animeData, '-=1000');
        else (0, $bHJE2.default)(animeData);
        if (index === 0) {
            $846c6604f52b4faa$export$73a1920e79733bc4.breakNextGameNameAlternateAnimation = (0, $bHJE2.default)({
                // hides name if alternate mode is on
                targets: document.querySelector(rootElement + ' .name.alternate'),
                opacity: 0,
                easing: 'linear',
                duration: 250,
                direction: 'alternate',
                loop: true,
                delay: 4000,
                endDelay: 3000
            });
            $846c6604f52b4faa$export$73a1920e79733bc4.breakNextGameCategoryAlternateAnimation = (0, $bHJE2.default)({
                // shows category if alternate mode is on
                targets: document.querySelector(rootElement + ' .category.alternate'),
                opacity: 1,
                easing: 'linear',
                duration: 250,
                direction: 'alternate',
                loop: true,
                delay: 4000,
                endDelay: 3000
            });
        }
    }
};
window.breakScheduleRenderer = $846c6604f52b4faa$export$73a1920e79733bc4;



var $bHJE2 = parcelRequire("bHJE2");

const $1c96bf6ab9cbc36f$export$1939100814978ddc = {
    breakIncentivesShowDuration: 15000,
    currentAdBreakIndex: 0,
    /**
   * Shows one ad and resolves when it has faded back out. Resolves `false` when there
   * is no ad at that index, so the driver can move straight on.
   *
   * This used to chain into startBreakIncentiveLoop() and back again, which is how the
   * carousel drove itself — and how, with no ads *and* no incentives, it degenerated
   * into a setTimeout(…, 0) busy loop.
   */ playAd: (adIndex)=>new Promise((resolve)=>{
            var _live_getBreakScreenAds_adIndex;
            const adUrl = (_live_getBreakScreenAds_adIndex = (0, $cd2554817816328b$export$28cf49ad70f82d12).getBreakScreenAds()[adIndex]) !== null && _live_getBreakScreenAds_adIndex !== void 0 ? _live_getBreakScreenAds_adIndex : '';
            if (adUrl === '') {
                resolve(false);
                return;
            }
            const adImage = document.querySelector('.ad-container');
            adImage.style.backgroundImage = `url(${adUrl})`;
            (0, $bHJE2.default)({
                targets: '.ad-container',
                duration: 1000,
                easing: 'linear',
                opacity: [
                    {
                        value: 1
                    },
                    {
                        value: 0,
                        delay: $1c96bf6ab9cbc36f$export$1939100814978ddc.breakIncentivesShowDuration
                    }
                ],
                complete: ()=>resolve(true)
            });
        }),
    /** Shows one incentive and resolves when it has faded back out. */ playBreakIncentive: (incentive)=>new Promise((resolve)=>{
            $1c96bf6ab9cbc36f$export$1939100814978ddc.populateAndShowBreakIncentive(incentive, resolve);
        }),
    populateAndShowBreakIncentive: (incentive, onDone)=>{
        (0, $bHJE2.default)({
            targets: '.incentive-break .incentive-container',
            duration: 1000,
            easing: 'linear',
            opacity: [
                {
                    value: 1
                },
                {
                    value: 0,
                    delay: $1c96bf6ab9cbc36f$export$1939100814978ddc.breakIncentivesShowDuration
                }
            ],
            complete: ()=>onDone === null || onDone === void 0 ? void 0 : onDone()
        });
        $1c96bf6ab9cbc36f$export$1939100814978ddc.populateBreakIncentiveGameData(incentive);
        if (incentive.type === 'fixed') $1c96bf6ab9cbc36f$export$1939100814978ddc.populateBreakFixedIncentiveData(incentive);
        else if (incentive.type === 'option') $1c96bf6ab9cbc36f$export$1939100814978ddc.populateBreakOptionIncentiveData(incentive);
    },
    populateBreakIncentiveGameData: (incentive)=>{
        const titleContainerElement = document.querySelector('.incentive-break .incentive-container .incentive-title');
        const gameNameElement = titleContainerElement.querySelector('.data .game-name');
        const descriptionElement = titleContainerElement.querySelector('.data .description');
        gameNameElement.innerHTML = incentive.gameName;
        descriptionElement.innerHTML = incentive.name;
        const fixedContainerElement = document.querySelector('.incentive-break .incentive-container .incentive-break-data .incentive-fixed');
        const optionContainerElement = document.querySelector('.incentive-break .incentive-container .incentive-break-data .incentive-bars');
        if (incentive.type === 'fixed') {
            fixedContainerElement.style.display = 'flex';
            optionContainerElement.style.display = 'none';
        } else {
            fixedContainerElement.style.display = 'none';
            optionContainerElement.style.display = 'flex';
        }
    },
    populateBreakFixedIncentiveData: (incentive)=>{
        const containerElement = document.querySelector('.incentive-break .incentive-container .incentive-break-data .incentive-fixed');
        const innerCircle = containerElement.querySelector('.circle.inner svg path');
        const percentElement = containerElement.querySelector('.totals .percent');
        const totalElement = containerElement.querySelector('.totals .total');
        let formattedTotal = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR'
        }).format(incentive.total);
        let goalTotal = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR'
        }).format(incentive.goal);
        totalElement.innerHTML = formattedTotal + ' / ' + goalTotal;
        const percent = parseInt(incentive.total * 100 / incentive.goal);
        percentElement.innerHTML = percent + '%';
        innerCircle.style.strokeDasharray = percent + ', 100';
    },
    populateBreakOptionIncentiveData: (incentive)=>{
        var _incentive_options_, _incentive_options_1, _incentive_options_2;
        const containerElement = document.querySelector('.incentive-break .incentive-container .incentive-break-data .incentive-bars');
        const bar1Element = containerElement.querySelector('.bar-1');
        const bar2Element = containerElement.querySelector('.bar-2');
        const bar3Element = containerElement.querySelector('.bar-3');
        const bar1Total = bar1Element.querySelector('.total');
        const bar2Total = bar2Element.querySelector('.total');
        const bar3Total = bar3Element.querySelector('.total');
        const bar1Option = bar1Element.querySelector('.name');
        const bar2Option = bar2Element.querySelector('.name');
        const bar3Option = bar3Element.querySelector('.name');
        var _incentive_options__total;
        const firstTotal = (_incentive_options__total = (_incentive_options_ = incentive.options[0]) === null || _incentive_options_ === void 0 ? void 0 : _incentive_options_.total) !== null && _incentive_options__total !== void 0 ? _incentive_options__total : 0;
        var _incentive_options__total1;
        const secondTotal = (_incentive_options__total1 = (_incentive_options_1 = incentive.options[1]) === null || _incentive_options_1 === void 0 ? void 0 : _incentive_options_1.total) !== null && _incentive_options__total1 !== void 0 ? _incentive_options__total1 : 0;
        var _incentive_options__total2;
        const thirdTotal = (_incentive_options__total2 = (_incentive_options_2 = incentive.options[2]) === null || _incentive_options_2 === void 0 ? void 0 : _incentive_options_2.total) !== null && _incentive_options__total2 !== void 0 ? _incentive_options__total2 : 0;
        const hasAllZero = firstTotal === 0 && secondTotal === 0 && thirdTotal === 0;
        const hasOption1 = incentive.options[0] !== undefined;
        const hasOption2 = incentive.options[1] !== undefined;
        const hasOption3 = incentive.options[2] !== undefined;
        bar1Element.style.display = 'flex';
        bar2Element.style.display = 'flex';
        bar3Element.style.display = 'flex';
        if (hasOption1) {
            bar1Total.innerHTML = new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'EUR'
            }).format(firstTotal);
            bar1Option.innerHTML = incentive.options[0].name;
        } else bar1Element.style.display = 'none';
        if (hasOption2) {
            bar2Total.innerHTML = new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'EUR'
            }).format(secondTotal);
            bar2Option.innerHTML = incentive.options[1].name;
        } else bar2Element.style.display = 'none';
        if (hasOption3) {
            bar3Total.innerHTML = new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'EUR'
            }).format(thirdTotal);
            bar3Option.innerHTML = incentive.options[2].name;
        } else bar3Element.style.display = 'none';
        if (hasOption1 && hasOption2) {
            if (hasAllZero) {
                bar2Element.style.marginLeft = 0;
                bar3Element.style.marginLeft = 0;
            } else {
                bar2Element.style.marginLeft = -(390 - 390 * (secondTotal - thirdTotal) / (firstTotal - thirdTotal));
                bar3Element.style.marginLeft = -390;
            }
        }
        const noOptionElement = containerElement.querySelector('.no-options');
        if (!hasOption1) noOptionElement.style.display = 'flex';
        else noOptionElement.style.display = 'none';
    }
};
window.breakIncentivesRenderer = $1c96bf6ab9cbc36f$export$1939100814978ddc;



var $bHJE2 = parcelRequire("bHJE2");
const $54c5c48ea8e293c0$export$d25884e0854c2eaf = {
    logoCrossFadeDelay: 30000,
    logoCrossFadeDuration: 1500,
    logoIdNextMapping: {
        'isc-logo': 'guf-tag',
        'guf-tag': 'isc-logo'
    },
    fadeInLogo: (logoId)=>{
        const logoElementId = logoId;
        const nextLogoId = $54c5c48ea8e293c0$export$d25884e0854c2eaf.logoIdNextMapping[logoId];
        (0, $bHJE2.default)({
            targets: [
                '#' + logoElementId,
                '#' + nextLogoId
            ],
            opacity: function(el, i) {
                const opacityValue = i === 0 ? 1 : 0;
                return opacityValue;
            },
            easing: 'easeInOutQuad',
            duration: $54c5c48ea8e293c0$export$d25884e0854c2eaf.logoCrossFadeDuration,
            endDelay: $54c5c48ea8e293c0$export$d25884e0854c2eaf.logoCrossFadeDelay,
            complete: function() {
                $54c5c48ea8e293c0$export$d25884e0854c2eaf.fadeInLogo(nextLogoId);
            }
        });
    }
};
window.logoCrossFade = $54c5c48ea8e293c0$export$d25884e0854c2eaf;



var $bHJE2 = parcelRequire("bHJE2");


const $0722f6f5174d6b24$export$1fea12d189dd0123 = {
    hideBreakDonationContainerAndShowClinicInBreak: ()=>{
        (0, $bHJE2.default)({
            targets: [
                '#break-donations'
            ],
            opacity: 0,
            easing: 'linear',
            duration: 1500,
            complete: function() {
                $0722f6f5174d6b24$export$1fea12d189dd0123.showClinicInBreak();
            }
        });
    },
    hideClinicInBreakAndShowBreakDonationContainer: ()=>{
        (0, $bHJE2.default)({
            targets: [
                '#clinic-container-break'
            ],
            opacity: 0,
            easing: 'linear',
            duration: 1500,
            complete: function() {
                (0, $be3f8327a460878c$export$7f0207607007e8df).showBreakDonationContainer();
            }
        });
    },
    moveTimeout: 20,
    clinicMoveAnimationInterval: null,
    totalClinicAnimationDuration: 13000,
    moveClinic: (clinicVan)=>{
        $0722f6f5174d6b24$export$1fea12d189dd0123.clinicMoveAnimationInterval = setTimeout(function() {
            clinicVan.style.left = (parseInt(clinicVan.style.left) || 0) + 1 + 'px';
            $0722f6f5174d6b24$export$1fea12d189dd0123.moveClinic(clinicVan);
        }, $0722f6f5174d6b24$export$1fea12d189dd0123.moveTimeout);
    },
    // Prima Colombia, poi Repubblica Democratica del Congo, poi Gaza, poi Ucraina e alla fine Italia.
    // Removed from the repo along with the infobar set — see flagRenderer.clinicVideoOrder
    // for what has to change to bring them back.
    clinicVideoOrder: [
        'resources/infobar/clinic/Break-Clinica-COL.mp4',
        'resources/infobar/clinic/Break-Clinica-COD.mp4',
        'resources/infobar/clinic/Break-Clinica-PAL.mp4',
        'resources/infobar/clinic/Break-Clinica-UKR.mp4',
        'resources/infobar/clinic/Break-Clinica-ITA.mp4'
    ],
    // Manual mapping: [runIndex, videoIdx] — video switches at the given run index (inclusive).
    // runIndex -1 = before event. Entries must be sorted ascending by runIndex.
    clinicVideoMapping: [
        [
            -1,
            0
        ],
        // COL
        [
            5,
            1
        ],
        // COD
        [
            7,
            2
        ],
        // PAL
        [
            9,
            3
        ],
        // UKR
        [
            12,
            4
        ],
        // ITA
        [
            14,
            0
        ],
        // COL
        [
            17,
            1
        ],
        // COD
        [
            20,
            2
        ],
        // PAL
        [
            23,
            3
        ],
        // UKR
        [
            26,
            4
        ] // ITA
    ],
    _resolveClinicVideo: (gameIndex)=>{
        const mapping = $0722f6f5174d6b24$export$1fea12d189dd0123.clinicVideoMapping;
        let videoIdx = mapping[0][1];
        for (const [run, vid] of mapping)if (gameIndex >= run) videoIdx = vid;
        return videoIdx;
    },
    getCorrectClinicVideo: ()=>{
        const videoOrder = $0722f6f5174d6b24$export$1fea12d189dd0123.clinicVideoOrder;
        const videoIdx = $0722f6f5174d6b24$export$1fea12d189dd0123._resolveClinicVideo((0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).currentGameIndex);
        console.log(`Video index: ${videoIdx} (${videoOrder[videoIdx]})`);
        return videoOrder[videoIdx];
    },
    showClinicInBreak: async ()=>{
        console.log("Showing clinic...");
        const clinicVan = document.querySelector('#clinic-van-break');
        clinicVan.style.left = '-310px';
        clinicVan.style.transform = '';
        const clinicContainer = document.querySelector('#clinic-container-break');
        const clinicVideoBg = clinicContainer.querySelector('video');
        clinicVideoBg.querySelector('source').src = $0722f6f5174d6b24$export$1fea12d189dd0123.getCorrectClinicVideo();
        clinicVideoBg.load();
        await new Promise((resolve)=>{
            clinicVideoBg.oncanplaythrough = resolve;
            clinicVideoBg.onerror = resolve;
            console.log("Loaded clinic video.");
        });
        console.log("Playing clinic video.");
        clinicVideoBg.play();
        clinicContainer.style.display = 'block';
        (0, $bHJE2.default)({
            targets: clinicContainer,
            opacity: 1,
            easing: 'linear',
            duration: 1500,
            complete: function() {
                setTimeout(function() {
                    $0722f6f5174d6b24$export$1fea12d189dd0123.hideClinicInBreakAndShowBreakDonationContainer();
                }, $0722f6f5174d6b24$export$1fea12d189dd0123.totalClinicAnimationDuration);
                setTimeout(function() {
                    $0722f6f5174d6b24$export$1fea12d189dd0123.moveTimeout = 18;
                    $0722f6f5174d6b24$export$1fea12d189dd0123.moveClinic(clinicVan);
                }, 600);
                (0, $bHJE2.default)({
                    delay: 600,
                    targets: clinicVan,
                    translateX: [
                        {
                            value: 0,
                            duration: 0
                        },
                        {
                            value: 600,
                            duration: 700
                        }
                    ],
                    rotate: [
                        {
                            value: 0,
                            duration: 100
                        },
                        {
                            value: 5,
                            duration: 600
                        },
                        {
                            value: 0,
                            duration: 200
                        }
                    ],
                    easing: 'easeOutCubic',
                    complete: function() {
                        const bobbing = (0, $bHJE2.default)({
                            targets: clinicVan,
                            loop: true,
                            scaleX: [
                                {
                                    value: 0.98,
                                    duration: 350,
                                    easing: 'easeInOutCubic'
                                },
                                {
                                    value: 1.02,
                                    duration: 350,
                                    easing: 'easeInOutCubic'
                                }
                            ],
                            scaleY: [
                                {
                                    value: 1.01,
                                    duration: 300,
                                    easing: 'easeInOutCubic'
                                },
                                {
                                    value: 0.99,
                                    duration: 300,
                                    easing: 'easeInOutCubic'
                                }
                            ]
                        });
                        setTimeout(function() {
                            bobbing.pause();
                            console.log("Stopping clinic move animation in break...", $0722f6f5174d6b24$export$1fea12d189dd0123.clinicMoveAnimationInterval);
                            clearInterval($0722f6f5174d6b24$export$1fea12d189dd0123.clinicMoveAnimationInterval);
                            $0722f6f5174d6b24$export$1fea12d189dd0123.clinicMoveAnimationInterval = null;
                            console.log("Hiding clinic...");
                            clinicVan.style.left = '-310px';
                            clinicVan.transform = '';
                        }, $0722f6f5174d6b24$export$1fea12d189dd0123.totalClinicAnimationDuration + 1000);
                    }
                });
            }
        });
    }
};
window.breakClinic = $0722f6f5174d6b24$export$1fea12d189dd0123;
const $0722f6f5174d6b24$export$202fa63ff075abc0 = {
    moveTimeout: 20,
    clinicMoveAnimationInterval: null,
    moveClinic: (clinicVan)=>{
        $0722f6f5174d6b24$export$202fa63ff075abc0.clinicMoveAnimationInterval = setTimeout(function() {
            clinicVan.style.left = (parseInt(clinicVan.style.left) || 0) + 1 + 'px';
            $0722f6f5174d6b24$export$202fa63ff075abc0.moveClinic(clinicVan);
        }, $0722f6f5174d6b24$export$202fa63ff075abc0.moveTimeout);
    },
    // Prima Colombia, poi Repubblica Democratica del Congo, poi Gaza, poi Ucraina e alla fine Italia.
    //
    // The files themselves are no longer in the repo: 97 MB of mp4 for a segment that is
    // not on air. Plain strings on purpose — `new URL(…, import.meta.url)` is a build-time
    // dependency and parcel fails the whole build when the target is missing. Putting the
    // videos back means restoring them under this path *and* switching these back to
    // `new URL()` so parcel fingerprints and rewrites them.
    clinicVideoOrder: [
        'resources/infobar/clinic/Infobar-Clinica-COL.mp4',
        'resources/infobar/clinic/Infobar-Clinica-COD.mp4',
        'resources/infobar/clinic/Infobar-Clinica-PAL.mp4',
        'resources/infobar/clinic/Infobar-Clinica-UKR.mp4',
        'resources/infobar/clinic/Infobar-Clinica-ITA.mp4'
    ],
    getCorrectClinicVideo: ()=>{
        const videoOrder = $0722f6f5174d6b24$export$202fa63ff075abc0.clinicVideoOrder;
        const videoIdx = $0722f6f5174d6b24$export$1fea12d189dd0123._resolveClinicVideo((0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).currentGameIndex);
        console.log(`Video index: ${videoIdx} (${videoOrder[videoIdx]})`);
        return videoOrder[videoIdx];
    },
    debugClinicVideoMapping: ()=>{
        const videoOrder = $0722f6f5174d6b24$export$202fa63ff075abc0.clinicVideoOrder;
        const rows = [];
        for(let i = -1; i <= (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).schedule.length - 1; i++){
            var _schedule_schedule_i;
            const videoIdx = $0722f6f5174d6b24$export$1fea12d189dd0123._resolveClinicVideo(i);
            var _schedule_schedule_i_name;
            const gameName = i === -1 ? '(before event)' : (_schedule_schedule_i_name = (_schedule_schedule_i = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).schedule[i]) === null || _schedule_schedule_i === void 0 ? void 0 : _schedule_schedule_i.name) !== null && _schedule_schedule_i_name !== void 0 ? _schedule_schedule_i_name : '(unknown)';
            rows.push({
                index: i,
                game: gameName,
                video: videoOrder[videoIdx].split('/').pop()
            });
        }
        console.table(rows);
    },
    showClinic: async ()=>{
        console.log("Showing clinic...");
        const clinicVan = document.querySelector('#clinic-van');
        clinicVan.style.left = '110px';
        clinicVan.style.transform = '';
        const clinicContainer = document.querySelector('#clinic-container');
        const clinicVideoBg = clinicContainer.querySelector('video');
        clinicVideoBg.querySelector('source').src = $0722f6f5174d6b24$export$202fa63ff075abc0.getCorrectClinicVideo();
        clinicVideoBg.load();
        await new Promise((resolve)=>{
            clinicVideoBg.oncanplaythrough = resolve;
            clinicVideoBg.onerror = resolve;
        });
        clinicVideoBg.play();
        clinicContainer.style.display = 'block';
        const totalAnimationDuration = 15000;
        (0, $bHJE2.default)({
            targets: clinicContainer,
            opacity: 1,
            easing: 'linear',
            duration: 200,
            complete: function() {
                setTimeout(function() {
                    $0722f6f5174d6b24$export$202fa63ff075abc0.moveTimeout = 20;
                    $0722f6f5174d6b24$export$202fa63ff075abc0.moveClinic(clinicVan);
                }, 600);
                (0, $bHJE2.default)({
                    targets: clinicVan,
                    translateX: [
                        {
                            value: 0,
                            duration: 10
                        },
                        {
                            value: 300,
                            duration: 700
                        }
                    ],
                    rotate: [
                        {
                            value: 0,
                            duration: 100
                        },
                        {
                            value: 4,
                            duration: 600
                        },
                        {
                            value: 0,
                            duration: 200
                        }
                    ],
                    easing: 'easeOutCubic',
                    complete: function() {
                        const bobbing = (0, $bHJE2.default)({
                            targets: clinicVan,
                            loop: true,
                            scaleX: [
                                {
                                    value: 0.98,
                                    duration: 250,
                                    easing: 'easeInOutCubic'
                                },
                                {
                                    value: 1.02,
                                    duration: 250,
                                    easing: 'easeInOutCubic'
                                }
                            ],
                            scaleY: [
                                {
                                    value: 1.01,
                                    duration: 200,
                                    easing: 'easeInOutCubic'
                                },
                                {
                                    value: 0.99,
                                    duration: 200,
                                    easing: 'easeInOutCubic'
                                }
                            ]
                        });
                        setTimeout(function() {
                            bobbing.pause();
                            console.log("Stopping clinic move animation...", $0722f6f5174d6b24$export$202fa63ff075abc0.clinicMoveAnimationInterval);
                            clearInterval($0722f6f5174d6b24$export$202fa63ff075abc0.clinicMoveAnimationInterval);
                            $0722f6f5174d6b24$export$202fa63ff075abc0.clinicMoveAnimationInterval = null;
                        }, totalAnimationDuration + 1000);
                        (0, $bHJE2.default)({
                            delay: totalAnimationDuration,
                            targets: clinicContainer,
                            opacity: 0,
                            easing: 'linear',
                            duration: 200,
                            complete: function() {
                                console.log("Hiding clinic...");
                                clinicVan.style.left = '110px';
                                clinicVan.transform = '';
                                setTimeout(function() {
                                    inforoll.start();
                                }, 1000);
                            }
                        });
                    }
                });
            }
        });
    }
};
window.infobarClinic = $0722f6f5174d6b24$export$202fa63ff075abc0;



var $bHJE2 = parcelRequire("bHJE2");




/**
 * The shared skew-and-slide geometry of the three tricolour panels.
 *
 * The flags are parallelograms: each `.long-flag` is skewed 18.5°, and its contents are
 * skewed back by the same amount so the text stays upright. Sliding a panel out means
 * translating it `flagOutExtent` px while holding that skew — which is why the skew is a
 * one-frame `steps(1)` tween rather than a static transform: anime.js overwrites the
 * whole `transform`, so every animation has to restate it.
 */ const $1daf0addf1662597$export$c2960897e2ae6368 = {
    /** How far a panel slides out from behind the 20 px tricolour stripe. */ flagOutExtent: 220,
    linearOutDuration: 550,
    skewProperties: {
        value: 18.5,
        easing: 'steps(1)',
        duration: 1
    },
    skewPropertiesNegative: {
        value: -18.5,
        easing: 'steps(1)',
        duration: 1
    },
    futureRunAnimationDuration: 200
};
window.flagGeometry = $1daf0addf1662597$export$c2960897e2ae6368;



var $bHJE2 = parcelRequire("bHJE2");



const $23430f38b30726b4$export$ea9d8207948d9e8a = {
    incentiveVisibleTime: 20000,
    fixedIncentivePercent: 0,
    // Each panel resolves its own deferred when it leaves the screen. The driver owns
    // what comes next; a panel calling its successor is what created the
    // infobar → overlay-renderer → flag-renderer → infobar import cycle.
    greenFinished: undefined,
    playGreen: ()=>{
        const done = new Promise((resolve)=>{
            $23430f38b30726b4$export$ea9d8207948d9e8a.greenFinished = resolve;
        });
        $23430f38b30726b4$export$ea9d8207948d9e8a.showGreen();
        return done;
    },
    showGreen: ()=>{
        if ((0, $cd2554817816328b$export$28cf49ad70f82d12).incentives.length == 0) {
            var _incentiveFlag_greenFinished;
            (_incentiveFlag_greenFinished = $23430f38b30726b4$export$ea9d8207948d9e8a.greenFinished) === null || _incentiveFlag_greenFinished === void 0 ? void 0 : _incentiveFlag_greenFinished.call($23430f38b30726b4$export$ea9d8207948d9e8a);
            return;
        }
        (0, $bHJE2.default)({
            targets: [
                '#flag-piece-green>.long-flag',
                '#flag-piece-white>.long-flag',
                '#flag-piece-red>.long-flag'
            ],
            translateX: (0, $1daf0addf1662597$export$c2960897e2ae6368).flagOutExtent,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewProperties,
            easing: 'easeOutQuint',
            duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).linearOutDuration,
            complete: $23430f38b30726b4$export$ea9d8207948d9e8a.showGreenContents
        });
    },
    showGreenContents: ()=>{
        var _incentiveFlag_greenFinished;
        if ((0, $cd2554817816328b$export$28cf49ad70f82d12).incentives.length == 0) (_incentiveFlag_greenFinished = $23430f38b30726b4$export$ea9d8207948d9e8a.greenFinished) === null || _incentiveFlag_greenFinished === void 0 ? void 0 : _incentiveFlag_greenFinished.call($23430f38b30726b4$export$ea9d8207948d9e8a);
        else (0, $bHJE2.default)({
            targets: '#arrow-incentive',
            translateX: 80,
            opacity: 1,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewPropertiesNegative,
            easing: 'linear',
            duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration,
            complete: $23430f38b30726b4$export$ea9d8207948d9e8a.startIncentivesLoop
        });
    },
    startIncentivesLoop: ()=>{
        (0, $cd2554817816328b$export$28cf49ad70f82d12).incentives.forEach(function(incentive, i) {
            setTimeout(function() {
                $23430f38b30726b4$export$ea9d8207948d9e8a.populateAndShowIncentiveData(incentive);
            }, $23430f38b30726b4$export$ea9d8207948d9e8a.incentiveVisibleTime * i);
        });
        setTimeout(function() {
            $23430f38b30726b4$export$ea9d8207948d9e8a.hideGreenContents();
        }, $23430f38b30726b4$export$ea9d8207948d9e8a.incentiveVisibleTime * (0, $cd2554817816328b$export$28cf49ad70f82d12).incentives.length);
    },
    hideGreenContents: ()=>{
        (0, $bHJE2.default)({
            targets: '#arrow-incentive',
            translateX: 100,
            opacity: 0,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewPropertiesNegative,
            easing: 'linear',
            duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration,
            complete: ()=>{
                var _incentiveFlag_greenFinished;
                return (_incentiveFlag_greenFinished = $23430f38b30726b4$export$ea9d8207948d9e8a.greenFinished) === null || _incentiveFlag_greenFinished === void 0 ? void 0 : _incentiveFlag_greenFinished.call($23430f38b30726b4$export$ea9d8207948d9e8a);
            }
        });
    },
    populateAndShowIncentiveData: (incentive)=>{
        $23430f38b30726b4$export$ea9d8207948d9e8a.showIncentiveContainer(incentive.type);
        if (incentive.type === 'option') $23430f38b30726b4$export$ea9d8207948d9e8a.populateAndShowOptionIncentiveData(incentive);
        else if (incentive.type === 'fixed') $23430f38b30726b4$export$ea9d8207948d9e8a.populateAndShowFixedIncentiveData(incentive);
    },
    showIncentiveContainer: (type)=>{
        const fixedIncentiveContainerElement = document.querySelector('.fixed-data');
        const optionIncentiveContainerElement = document.querySelector('.bar-data');
        const isFixed = type === 'fixed';
        fixedIncentiveContainerElement.style.display = isFixed ? 'flex' : 'none';
        optionIncentiveContainerElement.style.display = isFixed ? 'none' : 'flex';
    },
    showIncentiveGameData: (incentive)=>{
        const incentiveElement = document.querySelector('.incentive-data');
        const incentiveGameNameElement = incentiveElement.querySelector('.game-name');
        const incentiveGameCategoryElement = incentiveElement.querySelector('.game-category');
        incentiveGameNameElement.innerHTML = incentive.gameName;
        incentiveGameCategoryElement.innerHTML = incentive.name;
        (0, $bHJE2.default)({
            targets: '.incentive-data .game-data',
            translateX: 0,
            opacity: 1,
            easing: 'easeOutSine',
            duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration
        });
        setTimeout(function() {
            (0, $bHJE2.default)({
                targets: '.incentive-data .game-data',
                translateX: 20,
                opacity: 0,
                easing: 'easeOutSine',
                duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration,
                complete: function() {
                    (0, $bHJE2.default)({
                        targets: '.incentive-data .game-data',
                        translateX: -20,
                        opacity: 0,
                        easing: 'steps(1)',
                        duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration
                    });
                }
            });
        }, $23430f38b30726b4$export$ea9d8207948d9e8a.incentiveVisibleTime - (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration * 3);
    },
    populateAndShowFixedIncentiveData: (incentive)=>{
        if (incentive.type !== 'fixed') return;
        $23430f38b30726b4$export$ea9d8207948d9e8a.showIncentiveGameData(incentive);
        var _incentive_total;
        let formattedTotal = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR'
        }).format((_incentive_total = incentive.total) !== null && _incentive_total !== void 0 ? _incentive_total : 0);
        var _incentive_goal;
        let formattedGoal = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR'
        }).format((_incentive_goal = incentive.goal) !== null && _incentive_goal !== void 0 ? _incentive_goal : 0);
        console.log(incentive, formattedTotal, formattedGoal);
        const donationTotalsNumberElement = document.querySelector('.incentive-data .fixed-data .donation-totals-number');
        donationTotalsNumberElement.innerHTML = formattedTotal + " / " + formattedGoal;
        const percent = incentive.total * 100 / incentive.goal;
        console.log(incentive.total * 100 / incentive.goal, percent);
        $23430f38b30726b4$export$ea9d8207948d9e8a.moveFixedIncentiveBar(percent);
    },
    moveFixedIncentiveBar: (percent)=>{
        if (percent > 100) percent = 100;
        else if (percent < 0) percent = 0;
        const minMargin = -705;
        const maxMargin = 0;
        const marginDelta = minMargin - maxMargin;
        const marginPercent = marginDelta * percent / 100;
        const margin = minMargin - marginPercent;
        $23430f38b30726b4$export$ea9d8207948d9e8a.fixedIncentivePercent = 0;
        const percentElement = document.querySelector('.incentive-data .fixed-data .donation-bar-progressbar .percent');
        const hideDelay = $23430f38b30726b4$export$ea9d8207948d9e8a.incentiveVisibleTime - 1300;
        const duration = (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration * 4;
        percentElement.innerHTML = "0%";
        (0, $bHJE2.default)({
            targets: '.incentive-data .fixed-data .donation-bar-progressbar',
            translateX: [
                {
                    value: minMargin,
                    duration: 10
                }
            ],
            easing: 'steps(1)',
            complete: function() {
                (0, $bHJE2.default)({
                    targets: '.incentive-data .fixed-data .donation-totals',
                    translateY: [
                        {
                            value: 0
                        },
                        {
                            value: -35,
                            delay: hideDelay
                        }
                    ],
                    opacity: [
                        {
                            value: 1
                        },
                        {
                            value: 0,
                            delay: hideDelay
                        }
                    ],
                    easing: 'easeOutQuint',
                    duration: duration
                });
                (0, $bHJE2.default)({
                    targets: '.incentive-data .fixed-data .donation-bar-container',
                    translateY: [
                        {
                            value: 0
                        },
                        {
                            value: 40,
                            delay: hideDelay
                        }
                    ],
                    opacity: [
                        {
                            value: 1
                        },
                        {
                            value: 0,
                            delay: hideDelay
                        }
                    ],
                    easing: 'easeOutQuint',
                    duration: duration
                });
                (0, $bHJE2.default)({
                    targets: '.incentive-data .fixed-data .donation-bar-progressbar',
                    translateX: [
                        {
                            value: margin,
                            duration: percent * 50
                        }
                    ],
                    easing: 'easeOutCirc'
                });
                (0, $bHJE2.default)({
                    targets: $23430f38b30726b4$export$ea9d8207948d9e8a,
                    fixedIncentivePercent: percent,
                    easing: 'easeOutCirc',
                    duration: percent * 50,
                    update: function() {
                        percentElement.innerHTML = parseInt($23430f38b30726b4$export$ea9d8207948d9e8a.fixedIncentivePercent) + '%';
                    }
                });
            }
        });
    },
    populateAndShowOptionIncentiveData: (incentive)=>{
        if (incentive.type !== 'option') return;
        $23430f38b30726b4$export$ea9d8207948d9e8a.showIncentiveGameData(incentive);
        const noOptionsElement = document.querySelector('.incentive-data .bar-data .no-options');
        let options = incentive.options;
        if (options.length === 0) {
            noOptionsElement.style.display = 'flex';
            setTimeout(function() {
                (0, $bHJE2.default)({
                    targets: noOptionsElement,
                    easing: 'easeOutQuint',
                    opacity: [
                        {
                            value: 1
                        },
                        {
                            value: 0,
                            delay: $23430f38b30726b4$export$ea9d8207948d9e8a.incentiveVisibleTime - 1000
                        }
                    ],
                    translateX: [
                        {
                            value: 0
                        },
                        {
                            value: 40,
                            delay: $23430f38b30726b4$export$ea9d8207948d9e8a.incentiveVisibleTime - 1000
                        },
                        {
                            value: -40,
                            delay: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration
                        }
                    ],
                    duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration * 3
                }, 1000);
            });
        } else {
            noOptionsElement.style.display = 'none';
            const barPopupWait = 80;
            const percents = [
                100,
                85,
                75
            ];
            const allEmpty = options.filter((o)=>o.total == 0).length === options.length;
            for(let i in options){
                i = Number(i);
                if (i >= 3) break;
                let option = options[i];
                let indexFromOne = i + 1;
                $23430f38b30726b4$export$ea9d8207948d9e8a.populateOptionIncentiveBarData(indexFromOne, option);
                setTimeout(function() {
                    $23430f38b30726b4$export$ea9d8207948d9e8a.showOptionIncentiveBar(indexFromOne, allEmpty ? 75 : percents[i]);
                }, barPopupWait * indexFromOne);
            }
        }
    },
    populateOptionIncentiveBarData: (i, childIncentive)=>{
        const incentiveElement = document.querySelector('.incentive-data');
        const incentiveBarElement = incentiveElement.querySelector('.bar-' + i);
        const incentiveGameNameElement = incentiveBarElement.querySelector('.bar-name');
        const incentiveGameTotalElement = incentiveBarElement.querySelector('.bar-total');
        incentiveGameNameElement.innerHTML = childIncentive.name;
        let formattedNumber = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR'
        }).format(childIncentive.total);
        incentiveGameTotalElement.innerHTML = formattedNumber;
    },
    showOptionIncentiveBar: (i, percent)=>{
        const minMargin = -90;
        const maxMargin = -15;
        const marginDelta = minMargin - maxMargin;
        const marginPercent = marginDelta * percent / 100;
        const margin = minMargin - marginPercent;
        (0, $bHJE2.default)({
            targets: '.incentive-data .bar-' + i,
            marginBottom: margin,
            easing: 'easeOutSine',
            duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration,
            delay: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration,
            complete: function() {
                setTimeout(function() {
                    (0, $bHJE2.default)({
                        targets: '.incentive-data .bar-' + i,
                        marginBottom: minMargin,
                        easing: 'easeOutSine',
                        duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration
                    });
                }, $23430f38b30726b4$export$ea9d8207948d9e8a.incentiveVisibleTime - 1000);
            }
        });
    }
};
window.incentiveFlag = $23430f38b30726b4$export$ea9d8207948d9e8a;



var $hIdhk = parcelRequire("hIdhk");

var $d0Ch3 = parcelRequire("d0Ch3");
$hIdhk.extend($d0Ch3);

var $18ZYM = parcelRequire("18ZYM");
$hIdhk.extend($18ZYM);

let $4e5b150c2a9d80b1$export$be4eef6e6efe3255 = {
    nextRunElement: '#flag-piece-red>.long-flag>#next-run',
    futureRuns: [],
    futureRunAnimationDelay: 20000,
    redFinished: undefined,
    whiteFinished: undefined,
    retractFinished: undefined,
    playRed: ()=>{
        const done = new Promise((resolve)=>{
            $4e5b150c2a9d80b1$export$be4eef6e6efe3255.redFinished = resolve;
        });
        $4e5b150c2a9d80b1$export$be4eef6e6efe3255.showRed();
        return done;
    },
    playWhite: ()=>{
        const done = new Promise((resolve)=>{
            $4e5b150c2a9d80b1$export$be4eef6e6efe3255.whiteFinished = resolve;
        });
        $4e5b150c2a9d80b1$export$be4eef6e6efe3255.showWhite();
        return done;
    },
    playRetract: ()=>{
        const done = new Promise((resolve)=>{
            $4e5b150c2a9d80b1$export$be4eef6e6efe3255.retractFinished = resolve;
        });
        $4e5b150c2a9d80b1$export$be4eef6e6efe3255.clearFlag();
        return done;
    },
    showRed: ()=>{
        $4e5b150c2a9d80b1$export$be4eef6e6efe3255.setNextRunData();
        if (typeof (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).nextRun === 'undefined') {
            var // The driver skips this segment via when(), so reaching here means it was
            // called by hand. Just report done.
            _flagRenderer_redFinished;
            (_flagRenderer_redFinished = $4e5b150c2a9d80b1$export$be4eef6e6efe3255.redFinished) === null || _flagRenderer_redFinished === void 0 ? void 0 : _flagRenderer_redFinished.call($4e5b150c2a9d80b1$export$be4eef6e6efe3255);
            return;
        }
        (0, $bHJE2.default)({
            targets: '#flag-piece-red>.long-flag',
            translateX: (0, $1daf0addf1662597$export$c2960897e2ae6368).flagOutExtent,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewProperties,
            easing: 'easeOutQuint',
            duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).linearOutDuration,
            complete: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.showNextRun
        });
    },
    showNextRun: ()=>{
        (0, $bHJE2.default)({
            targets: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.nextRunElement,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewPropertiesNegative,
            opacity: 1,
            translateX: 10,
            easing: 'linear',
            duration: 400,
            complete: function() {
                $4e5b150c2a9d80b1$export$be4eef6e6efe3255.hideNextGameIn(10);
            }
        });
    },
    showArrow1: ()=>{
        if ($4e5b150c2a9d80b1$export$be4eef6e6efe3255.futureRuns.length < 2) {
            $4e5b150c2a9d80b1$export$be4eef6e6efe3255.showFutureRuns();
            return;
        }
        (0, $bHJE2.default)({
            targets: '#arrow-1',
            opacity: 1,
            easing: 'linear',
            duration: 200,
            complete: function() {
                if ($4e5b150c2a9d80b1$export$be4eef6e6efe3255.futureRuns.length > 2) $4e5b150c2a9d80b1$export$be4eef6e6efe3255.showArrow2();
                else $4e5b150c2a9d80b1$export$be4eef6e6efe3255.showFutureRuns();
            }
        });
    },
    showArrow2: ()=>{
        (0, $bHJE2.default)({
            targets: '#arrow-2',
            opacity: 1,
            easing: 'linear',
            duration: 200,
            complete: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.showFutureRuns
        });
    },
    hideArrow1: ()=>{
        (0, $bHJE2.default)({
            targets: '#arrow-1',
            opacity: 0,
            easing: 'linear',
            duration: 200
        });
    },
    hideArrow2: ()=>{
        (0, $bHJE2.default)({
            targets: '#arrow-2',
            opacity: 0,
            easing: 'linear',
            duration: 200
        });
    },
    showFutureRuns: ()=>{
        const futureRuns = document.querySelectorAll('#future-runs>.future-run');
        let t = (0, $bHJE2.default).timeline();
        futureRuns.forEach(function(runEl, index) {
            t.add({
                targets: runEl.querySelector('.game-time'),
                opacity: 1,
                translateX: 10,
                easing: 'linear',
                duration: 200,
                complete: function() {
                    (0, $bHJE2.default)({
                        // hides name if alternate mode is on
                        targets: runEl.querySelector('.game-name.alternate'),
                        opacity: 0,
                        easing: 'linear',
                        duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration,
                        direction: 'alternate',
                        loop: 6,
                        delay: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.futureRunAnimationDelay / 12,
                        endDelay: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.futureRunAnimationDelay / 12
                    });
                    (0, $bHJE2.default)({
                        // shows category if alternate mode is on
                        targets: runEl.querySelector('.game-category.alternate'),
                        opacity: 1,
                        easing: 'linear',
                        duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration,
                        direction: 'alternate',
                        loop: 6,
                        delay: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.futureRunAnimationDelay / 12,
                        endDelay: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.futureRunAnimationDelay / 12
                    });
                    (0, $bHJE2.default)({
                        targets: runEl.querySelector('.game-time'),
                        opacity: 0,
                        translateX: 0,
                        easing: 'linear',
                        duration: 200,
                        delay: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.futureRunAnimationDelay
                    });
                }
            }).add({
                targets: runEl.querySelector('.game-data'),
                opacity: 1,
                translateX: 10,
                easing: 'linear',
                duration: 200,
                complete: function() {
                    (0, $bHJE2.default)({
                        targets: runEl.querySelector('.game-data'),
                        opacity: 0,
                        translateX: 0,
                        easing: 'linear',
                        duration: 200,
                        delay: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.futureRunAnimationDelay,
                        complete: function() {
                            if (index === futureRuns.length - 1) {
                                var _flagRenderer_whiteFinished;
                                $4e5b150c2a9d80b1$export$be4eef6e6efe3255.hideArrow1();
                                $4e5b150c2a9d80b1$export$be4eef6e6efe3255.hideArrow2();
                                (_flagRenderer_whiteFinished = $4e5b150c2a9d80b1$export$be4eef6e6efe3255.whiteFinished) === null || _flagRenderer_whiteFinished === void 0 ? void 0 : _flagRenderer_whiteFinished.call($4e5b150c2a9d80b1$export$be4eef6e6efe3255);
                            }
                        }
                    });
                }
            });
        });
    },
    hideNextGame: ()=>{
        (0, $bHJE2.default)({
            targets: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.nextRunElement,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewPropertiesNegative,
            opacity: 0,
            translateX: 10,
            easing: 'linear',
            duration: 400,
            complete: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.resetNextGamePosition
        });
    },
    resetNextGamePosition: ()=>{
        (0, $bHJE2.default)({
            targets: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.nextRunElement,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewPropertiesNegative,
            opacity: 0,
            translateX: 0,
            easing: 'linear',
            duration: 400,
            complete: function() {
                // The old chain paused 400 ms here before showWhite(); keep the beat so
                // the panels still change over at the same rhythm.
                setTimeout(()=>{
                    var _flagRenderer_redFinished;
                    return (_flagRenderer_redFinished = $4e5b150c2a9d80b1$export$be4eef6e6efe3255.redFinished) === null || _flagRenderer_redFinished === void 0 ? void 0 : _flagRenderer_redFinished.call($4e5b150c2a9d80b1$export$be4eef6e6efe3255);
                }, 400);
            }
        });
    },
    hideNextGameIn: (seconds)=>{
        setTimeout($4e5b150c2a9d80b1$export$be4eef6e6efe3255.hideNextGame, seconds * 1000);
    },
    showWhiteIn: (seconds)=>{
        setTimeout($4e5b150c2a9d80b1$export$be4eef6e6efe3255.showWhite, seconds * 1000);
    },
    setNextRunData: ()=>{
        var _schedule_nextRun, _schedule_nextRun_submission, _schedule_nextRun1, _schedule_nextRun_submission_runners, _schedule_nextRun_submission1, _schedule_nextRun2;
        const gameNameEl = document.querySelector('#flag-piece-red>.long-flag>#next-run>.game-name');
        var _schedule_nextRun_name;
        gameNameEl.innerHTML = (_schedule_nextRun_name = (_schedule_nextRun = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).nextRun) === null || _schedule_nextRun === void 0 ? void 0 : _schedule_nextRun.name) !== null && _schedule_nextRun_name !== void 0 ? _schedule_nextRun_name : 'N/A';
        const gameCategoryEl = document.querySelector('#flag-piece-red>.long-flag>#next-run>.game-category');
        var _schedule_nextRun_submission_category;
        gameCategoryEl.innerHTML = (_schedule_nextRun_submission_category = (_schedule_nextRun1 = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).nextRun) === null || _schedule_nextRun1 === void 0 ? void 0 : (_schedule_nextRun_submission = _schedule_nextRun1.submission) === null || _schedule_nextRun_submission === void 0 ? void 0 : _schedule_nextRun_submission.category) !== null && _schedule_nextRun_submission_category !== void 0 ? _schedule_nextRun_submission_category : '';
        const gameRunnerEl = document.querySelector('#flag-piece-red>.long-flag>#next-run>.game-runner>.game-runner-name');
        var _schedule_nextRun_submission_runners_map;
        const runners = (_schedule_nextRun_submission_runners_map = (_schedule_nextRun2 = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).nextRun) === null || _schedule_nextRun2 === void 0 ? void 0 : (_schedule_nextRun_submission1 = _schedule_nextRun2.submission) === null || _schedule_nextRun_submission1 === void 0 ? void 0 : (_schedule_nextRun_submission_runners = _schedule_nextRun_submission1.runners) === null || _schedule_nextRun_submission_runners === void 0 ? void 0 : _schedule_nextRun_submission_runners.map((r)=>{
            var _r_user;
            return (_r_user = r.user) === null || _r_user === void 0 ? void 0 : _r_user.name;
        })) !== null && _schedule_nextRun_submission_runners_map !== void 0 ? _schedule_nextRun_submission_runners_map : [];
        const runnerFormattedString = runners.join(' <span class="no-hl">e</span> ');
        gameRunnerEl.innerHTML = runnerFormattedString;
        const gameRunnerParentEl = document.querySelector('#flag-piece-red>.long-flag>#next-run>.game-runner');
        if (runnerFormattedString === '') gameRunnerParentEl.classList.add('hide');
        else gameRunnerParentEl.classList.remove('hide');
    },
    // Counts to the run itself, after its setup: projected_start (every overrun already
    // folded in by the backend) plus setup_time, compared straight against the real clock.
    setFutureRunData: ()=>{
        $4e5b150c2a9d80b1$export$be4eef6e6efe3255.futureRuns = (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).next5.slice(1, 4);
        const futureRuns = $4e5b150c2a9d80b1$export$be4eef6e6efe3255.futureRuns;
        // console.log(futureRuns);
        const runElements = document.querySelectorAll('#future-runs>.future-run');
        runElements.forEach((runElement, i)=>{
            var _run_submission;
            const run = futureRuns[i];
            let shouldClear = false;
            if (typeof run === 'undefined') shouldClear = true;
            // console.log(typeof run, run);
            let waitTimeLabel = [];
            const futureRunDurationSelector = runElement.querySelector('.game-time');
            const gameTimeInEl = futureRunDurationSelector.querySelector('.game-time-in');
            if (shouldClear) gameTimeInEl.innerHTML = "";
            else {
                waitTimeLabel = (0, $08f0832b872ea799$export$eb11d1adfbce682d)((0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).getRunStartDate(run));
                gameTimeInEl.innerHTML = waitTimeLabel.label;
            }
            const gameTimeEstimateEl = futureRunDurationSelector.querySelector('.game-time-estimate');
            if (shouldClear) gameTimeEstimateEl.innerHTML = "";
            else gameTimeEstimateEl.innerHTML = waitTimeLabel.duration;
            const futureRunSelector = runElement.querySelector('.game-data');
            const gameNameEl = futureRunSelector.querySelector('.game-name');
            var _run_name;
            if (shouldClear) gameNameEl.innerHTML = "";
            else gameNameEl.innerHTML = (_run_name = run.name) !== null && _run_name !== void 0 ? _run_name : 'N/A';
            const gameCategoryEl = futureRunSelector.querySelector('.game-category');
            var _run_submission_category;
            const categoryName = (_run_submission_category = run === null || run === void 0 ? void 0 : (_run_submission = run.submission) === null || _run_submission === void 0 ? void 0 : _run_submission.category) !== null && _run_submission_category !== void 0 ? _run_submission_category : '';
            if (shouldClear) gameCategoryEl.innerHTML = "";
            else gameCategoryEl.innerHTML = categoryName;
            gameNameEl.classList.remove('alternate');
            gameCategoryEl.classList.remove('alternate');
            gameNameEl.style.opacity = "";
            gameCategoryEl.style.opacity = "";
            if (categoryName !== '' && gameNameEl.getBoundingClientRect().top !== gameCategoryEl.getBoundingClientRect().top) {
                gameNameEl.classList.add('alternate');
                gameCategoryEl.classList.add('alternate');
            }
            const gameRunnerNameEl = futureRunSelector.querySelector('.game-runner>.game-runner-name');
            const gameRunnerEl = futureRunSelector.querySelector('.game-runner');
            if (shouldClear) {
                gameRunnerNameEl.innerHTML = "";
                gameRunnerEl.classList.add('hide');
            } else {
                var _run_submission_runners, _run_submission1;
                var _run_submission_runners_map;
                const runners = (_run_submission_runners_map = (_run_submission1 = run.submission) === null || _run_submission1 === void 0 ? void 0 : (_run_submission_runners = _run_submission1.runners) === null || _run_submission_runners === void 0 ? void 0 : _run_submission_runners.map((r)=>{
                    var _r_user;
                    return (_r_user = r.user) === null || _r_user === void 0 ? void 0 : _r_user.name;
                })) !== null && _run_submission_runners_map !== void 0 ? _run_submission_runners_map : [];
                const runnerFormattedString = runners.join(' <span class="no-hl">e</span> ');
                gameRunnerNameEl.innerHTML = runnerFormattedString;
                gameRunnerEl.classList.remove('hide');
                if (runnerFormattedString === '') gameRunnerEl.classList.add('hide');
            }
        });
    },
    showWhite: ()=>{
        $4e5b150c2a9d80b1$export$be4eef6e6efe3255.setFutureRunData();
        if ($4e5b150c2a9d80b1$export$be4eef6e6efe3255.futureRuns.length < 1) {
            var _flagRenderer_whiteFinished;
            (_flagRenderer_whiteFinished = $4e5b150c2a9d80b1$export$be4eef6e6efe3255.whiteFinished) === null || _flagRenderer_whiteFinished === void 0 ? void 0 : _flagRenderer_whiteFinished.call($4e5b150c2a9d80b1$export$be4eef6e6efe3255);
            return;
        }
        (0, $bHJE2.default)({
            targets: [
                '#flag-piece-white>.long-flag',
                '#flag-piece-red>.long-flag'
            ],
            translateX: (0, $1daf0addf1662597$export$c2960897e2ae6368).flagOutExtent,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewProperties,
            easing: 'easeOutQuint',
            duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).linearOutDuration,
            complete: $4e5b150c2a9d80b1$export$be4eef6e6efe3255.showArrow1
        });
    },
    clearFlag: ()=>{
        (0, $bHJE2.default)({
            targets: '#arrow-incentive',
            translateX: 0,
            opacity: 0,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewPropertiesNegative,
            easing: 'linear',
            duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).futureRunAnimationDuration
        });
        (0, $bHJE2.default).timeline().add({
            targets: '#flag-piece-green>.long-flag',
            translateX: (0, $1daf0addf1662597$export$c2960897e2ae6368).flagOutExtent + 20,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewProperties,
            easing: 'easeOutCubic',
            duration: (0, $1daf0addf1662597$export$c2960897e2ae6368).linearOutDuration * 2
        }).add({
            targets: '#flag-piece-green>.long-flag',
            translateX: (0, $1daf0addf1662597$export$c2960897e2ae6368).flagOutExtent,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewProperties,
            easing: 'easeInCubic',
            duration: 600
        }).add({
            targets: '#flag-piece-red>.long-flag',
            translateX: (0, $1daf0addf1662597$export$c2960897e2ae6368).flagOutExtent,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewProperties,
            duration: 0.8
        }, '-=750').add({
            targets: '#flag-piece-white>.long-flag',
            translateX: (0, $1daf0addf1662597$export$c2960897e2ae6368).flagOutExtent,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewProperties,
            duration: 0.8
        }, '-=750').add({
            targets: '.long-flag',
            translateX: 0,
            skew: (0, $1daf0addf1662597$export$c2960897e2ae6368).skewProperties,
            duration: 1880,
            easing: 'easeOutCubic',
            complete: function() {
                var _flagRenderer_retractFinished;
                (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).refreshSchedule();
                (_flagRenderer_retractFinished = $4e5b150c2a9d80b1$export$be4eef6e6efe3255.retractFinished) === null || _flagRenderer_retractFinished === void 0 ? void 0 : _flagRenderer_retractFinished.call($4e5b150c2a9d80b1$export$be4eef6e6efe3255);
            }
        });
    }
};
window.flagRenderer = $4e5b150c2a9d80b1$export$be4eef6e6efe3255;








/**
 * The infobar cycle, as a table instead of a chain of callbacks.
 *
 * Each segment plays, resolves, and the driver picks the next one whose `when()` holds.
 * Nothing knows its successor, which is what lets the panels be reordered, skipped or
 * added without editing three other functions — and what removes the
 * `infobar → overlay-renderer → flag-renderer → infobar` import cycle, since neither
 * renderer has to reach for the next one any more.
 *
 * Two things the old chain could not do:
 *
 *  - `?stopLoop` is one check here rather than six `if (window.stopLoop) return` guards
 *    scattered across three files, where forgetting one silently broke debug mode.
 *  - every segment has a deadline. anime.js runs on requestAnimationFrame, which OBS
 *    throttles for inactive browser sources; if a `complete:` handler never fired the
 *    old chain stopped dead until someone reloaded the source. Now the segment is
 *    abandoned and the cycle carries on.
 */ /** Rejects after `ms`, so a stalled segment cannot wedge the cycle. */ function $7829655bcaf64623$var$deadline(ms, name) {
    return new Promise((_, reject)=>{
        setTimeout(()=>reject(new Error(`segment "${name}" did not finish within ${ms} ms`)), ms);
    });
}
const $7829655bcaf64623$export$c04a9f24a4230e1f = {
    /** 'idle' | 'frozen' | the name of the segment on screen. Readable from the console. */ state: 'idle',
    running: false,
    index: 0,
    segments: [
        {
            name: 'inforoll',
            when: ()=>true,
            maxMs: 150000,
            enter: ()=>(0, $da5008b34906a1ca$export$d083befd4444a793).play(),
            // A frozen inforoll parks the cycle: the bar holds one static line and no
            // panel follows it. That has always been the behaviour, but as a side effect
            // of advanceNextRow() returning early — here it is a decision.
            haltAfter: ()=>(0, $cd2554817816328b$export$28cf49ad70f82d12).getFreezeInforoll()
        },
        {
            name: 'goal',
            when: ()=>true,
            maxMs: 45000,
            enter: ()=>(0, $be3f8327a460878c$export$7f0207607007e8df).playDonationGoal()
        },
        {
            name: 'red',
            when: ()=>typeof (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).nextRun !== 'undefined',
            maxMs: 30000,
            enter: ()=>(0, $4e5b150c2a9d80b1$export$be4eef6e6efe3255).playRed()
        },
        {
            name: 'white',
            when: ()=>(0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).next5.length > 1,
            maxMs: 50000,
            enter: ()=>(0, $4e5b150c2a9d80b1$export$be4eef6e6efe3255).playWhite()
        },
        {
            name: 'green',
            when: ()=>(0, $cd2554817816328b$export$28cf49ad70f82d12).incentives.length > 0,
            maxMs: ()=>20000 * (0, $cd2554817816328b$export$28cf49ad70f82d12).incentives.length + 20000,
            enter: ()=>(0, $23430f38b30726b4$export$ea9d8207948d9e8a).playGreen()
        },
        {
            // Always runs, including after a skipped panel: it retracts whatever is out
            // and re-derives the schedule before the next pass reads it.
            name: 'retract',
            when: ()=>true,
            maxMs: 25000,
            enter: ()=>(0, $4e5b150c2a9d80b1$export$be4eef6e6efe3255).playRetract()
        }
    ],
    start: ()=>{
        if ($7829655bcaf64623$export$c04a9f24a4230e1f.running) return;
        $7829655bcaf64623$export$c04a9f24a4230e1f.running = true;
        $7829655bcaf64623$export$c04a9f24a4230e1f.index = 0;
        $7829655bcaf64623$export$c04a9f24a4230e1f.loop();
    },
    stop: ()=>{
        $7829655bcaf64623$export$c04a9f24a4230e1f.running = false;
        $7829655bcaf64623$export$c04a9f24a4230e1f.state = 'idle';
    },
    loop: async ()=>{
        while($7829655bcaf64623$export$c04a9f24a4230e1f.running){
            var _segment_haltAfter;
            const segment = $7829655bcaf64623$export$c04a9f24a4230e1f.segments[$7829655bcaf64623$export$c04a9f24a4230e1f.index];
            $7829655bcaf64623$export$c04a9f24a4230e1f.index = ($7829655bcaf64623$export$c04a9f24a4230e1f.index + 1) % $7829655bcaf64623$export$c04a9f24a4230e1f.segments.length;
            if (!segment.when()) continue;
            $7829655bcaf64623$export$c04a9f24a4230e1f.state = segment.name;
            const limit = typeof segment.maxMs === 'function' ? segment.maxMs() : segment.maxMs;
            try {
                await Promise.race([
                    segment.enter(),
                    $7829655bcaf64623$var$deadline(limit, segment.name)
                ]);
            } catch (error) {
                // A stalled or throwing segment loses its turn; the cycle does not.
                console.error(`Cycle segment "${segment.name}" failed:`, error);
            }
            if ((_segment_haltAfter = segment.haltAfter) === null || _segment_haltAfter === void 0 ? void 0 : _segment_haltAfter.call(segment)) {
                $7829655bcaf64623$export$c04a9f24a4230e1f.state = 'frozen';
                $7829655bcaf64623$export$c04a9f24a4230e1f.running = false;
                return;
            }
            // ?stopLoop: play the segment that was asked for, then park. One check, where
            // the old chain needed a guard inside every hand-off.
            if (window.stopLoop) {
                $7829655bcaf64623$export$c04a9f24a4230e1f.running = false;
                $7829655bcaf64623$export$c04a9f24a4230e1f.state = 'idle';
                return;
            }
        }
    }
};
window.cycle = $7829655bcaf64623$export$c04a9f24a4230e1f;




/**
 * The break screen's ad/incentive carousel: `ad → every incentive → next ad → …`,
 * forever, independent of the infobar cycle.
 *
 * It used to drive itself — showAdBreak() called startBreakIncentiveLoop(), which called
 * showAdBreak() back — which had two consequences worth remembering:
 *
 *  - starting it twice created two chains racing over the same two elements, and it was
 *    being started on every schedule change (measured 1, 2, 4, 6 concurrent runs over
 *    four run changes);
 *  - with no ads *and* no incentives it became a `setTimeout(…, 0)` busy loop, because
 *    the delay before the next ad was `incentives.length * step` and that is zero.
 *
 * Both are structural, so both are fixed here rather than patched: one driver, started
 * once, with a floor delay for the nothing-to-show case.
 */ const $4775767dfcc46ecf$var$IDLE_RECHECK_MS = 5000;
/** Resolves after `ms` of the page's own clock. */ const $4775767dfcc46ecf$var$wait = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $4775767dfcc46ecf$export$202f07f6c788b877 = {
    /** 'idle' | 'ad' | 'incentive' | 'empty'. Readable from the console. */ state: 'idle',
    running: false,
    adIndex: 0,
    /** Safe to call on every schedule refresh: only the first call does anything. */ start: ()=>{
        if ($4775767dfcc46ecf$export$202f07f6c788b877.running) return;
        $4775767dfcc46ecf$export$202f07f6c788b877.running = true;
        $4775767dfcc46ecf$export$202f07f6c788b877.loop();
    },
    stop: ()=>{
        $4775767dfcc46ecf$export$202f07f6c788b877.running = false;
        $4775767dfcc46ecf$export$202f07f6c788b877.state = 'idle';
    },
    loop: async ()=>{
        while($4775767dfcc46ecf$export$202f07f6c788b877.running){
            const ads = (0, $cd2554817816328b$export$28cf49ad70f82d12).getBreakScreenAds();
            var _live_incentives;
            const incentives = (_live_incentives = (0, $cd2554817816328b$export$28cf49ad70f82d12).incentives) !== null && _live_incentives !== void 0 ? _live_incentives : [];
            if (ads.length === 0 && incentives.length === 0) {
                // Nothing configured yet. Idle politely instead of spinning.
                $4775767dfcc46ecf$export$202f07f6c788b877.state = 'empty';
                await $4775767dfcc46ecf$var$wait($4775767dfcc46ecf$var$IDLE_RECHECK_MS);
                continue;
            }
            if (ads.length > 0) {
                $4775767dfcc46ecf$export$202f07f6c788b877.state = 'ad';
                if ($4775767dfcc46ecf$export$202f07f6c788b877.adIndex >= ads.length) $4775767dfcc46ecf$export$202f07f6c788b877.adIndex = 0;
                (0, $1c96bf6ab9cbc36f$export$1939100814978ddc).currentAdBreakIndex = $4775767dfcc46ecf$export$202f07f6c788b877.adIndex;
                await (0, $1c96bf6ab9cbc36f$export$1939100814978ddc).playAd($4775767dfcc46ecf$export$202f07f6c788b877.adIndex);
                $4775767dfcc46ecf$export$202f07f6c788b877.adIndex = ($4775767dfcc46ecf$export$202f07f6c788b877.adIndex + 1) % ads.length;
            }
            var _live_incentives1;
            // Re-read each time: a poll can add, remove or reorder incentives mid-cycle.
            for (const incentive of (_live_incentives1 = (0, $cd2554817816328b$export$28cf49ad70f82d12).incentives) !== null && _live_incentives1 !== void 0 ? _live_incentives1 : []){
                if (!$4775767dfcc46ecf$export$202f07f6c788b877.running) return;
                $4775767dfcc46ecf$export$202f07f6c788b877.state = 'incentive';
                await (0, $1c96bf6ab9cbc36f$export$1939100814978ddc).playBreakIncentive(incentive);
                await $4775767dfcc46ecf$var$wait(1500); // the gap the old loop left between incentives
            }
        }
    }
};
window.breakCarousel = $4775767dfcc46ecf$export$202f07f6c788b877;



// STRAPI
setTimeout((0, $cd2554817816328b$export$28cf49ad70f82d12).fetchGufInfo, 200);
setTimeout((0, $cd2554817816328b$export$28cf49ad70f82d12).fetchGufInfo, 3000);
setInterval((0, $cd2554817816328b$export$28cf49ad70f82d12).fetchGufInfo, 15000);
const $899ce338dc97feb6$var$queryString = window.location.search;
const $899ce338dc97feb6$var$urlParams = new URLSearchParams($899ce338dc97feb6$var$queryString);
const $899ce338dc97feb6$var$debug = $899ce338dc97feb6$var$urlParams.get('debug') === 'true' || false;
const $899ce338dc97feb6$var$debugDonationFrequency = parseInt($899ce338dc97feb6$var$urlParams.get('debugDonationFrequency') || 1000);
const $899ce338dc97feb6$var$debugDonationMaxXSpawn = parseInt($899ce338dc97feb6$var$urlParams.get('debugDonationMaxXSpawn') || 100);
window.debugDonationMaxXSpawn = $899ce338dc97feb6$var$debugDonationMaxXSpawn;
const $899ce338dc97feb6$var$stopLoop = $899ce338dc97feb6$var$urlParams.get('stopLoop') === 'true' || false;
console.log("Looping is", !$899ce338dc97feb6$var$stopLoop ? "enabled" : "disabled");
window.stopLoop = $899ce338dc97feb6$var$stopLoop;
const $899ce338dc97feb6$var$showControls = $899ce338dc97feb6$var$urlParams.get('showControls') === 'true' || false;
window.showControls = $899ce338dc97feb6$var$showControls;
if ($899ce338dc97feb6$var$showControls) document.getElementById("debug-controls").classList.remove("hide");
// Wired here rather than as inline onclick=, which needed the renderers to be on
// window at parse time. They still are, for the devtools console, but the page no
// longer depends on it.
const $899ce338dc97feb6$var$debugButtons = {
    'advance-infobar': ()=>(0, $da5008b34906a1ca$export$d083befd4444a793).start(),
    'show-donation-goal': ()=>(0, $be3f8327a460878c$export$7f0207607007e8df).showDonationGoalProgressBar(),
    'show-red': ()=>(0, $4e5b150c2a9d80b1$export$be4eef6e6efe3255).showRed(),
    'show-white': ()=>(0, $4e5b150c2a9d80b1$export$be4eef6e6efe3255).showWhite(),
    'show-green': ()=>incentiveFlag.showGreen()
};
Object.entries($899ce338dc97feb6$var$debugButtons).forEach(([id, handler])=>{
    var _document_getElementById;
    (_document_getElementById = document.getElementById(id)) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.addEventListener('click', handler);
});
if (!$899ce338dc97feb6$var$stopLoop) (0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenReady((0, $7829655bcaf64623$export$c04a9f24a4230e1f).start);
// OENGUS
setInterval(function() {
    (0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).updateCurrentTime();
}, 3000);
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenReady((0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).refreshSchedule);
// every poll: the backend reprojects the remaining slots when staff close one out
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenUpdated((0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).refreshSchedule);
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenUpdated((0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).showSchedulePreview);
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenUpdated((0, $cd2554817816328b$export$28cf49ad70f82d12).parseIncentives);
// The break screen's carousel runs independently of the infobar cycle. It needs ads and
// incentives, not the schedule, so it hangs off the poll *after* parseIncentives —
// callWhenRefreshed fires earlier in the same poll, when live.incentives is still
// empty, and the carousel would idle a full recheck before showing anything. start() is
// idempotent, so this means "as soon as there is data" without a flag of its own.
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenUpdated((0, $4775767dfcc46ecf$export$202f07f6c788b877).start);
// The ISC logo / #GUFA26 crossfade is independent of everything else.
(0, $54c5c48ea8e293c0$export$d25884e0854c2eaf).fadeInLogo('isc-logo');
// RENDERERS
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenReady(function() {
    (0, $58023c6713a64ee8$export$f1bc67d49dee77a6).fadeInOutRunnerName(1);
    (0, $58023c6713a64ee8$export$f1bc67d49dee77a6).fadeInOutRunnerName(2);
    setTimeout((0, $846c6604f52b4faa$export$73a1920e79733bc4).startFizzleWatcher, 5000);
    (0, $be3f8327a460878c$export$7f0207607007e8df).startDonationLeaderboardToggleLoop();
    (0, $be3f8327a460878c$export$7f0207607007e8df).showBreakDonationContainer();
});
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenUpdated((0, $be3f8327a460878c$export$7f0207607007e8df).updateDonations);
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenUpdated((0, $be3f8327a460878c$export$7f0207607007e8df).updateDonatorsLeaderboard);
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenUpdated((0, $be3f8327a460878c$export$7f0207607007e8df).updateDonationLeaderboard);
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenUpdated((0, $be3f8327a460878c$export$7f0207607007e8df).updateDonationReason);
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenUpdated((0, $be3f8327a460878c$export$7f0207607007e8df).maybeUpdateDonationGoal);
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenUpdated((0, $58023c6713a64ee8$export$f1bc67d49dee77a6).updateHostName);
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenUpdated((0, $58023c6713a64ee8$export$f1bc67d49dee77a6).updateBreakScreenHost);
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenUpdated((0, $be3f8327a460878c$export$7f0207607007e8df).maybeShowLeaderboard);
// Only when the derived schedule actually moves
(0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).callWhenRefreshed((0, $58023c6713a64ee8$export$f1bc67d49dee77a6).updateRunnerName);
(0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).callWhenRefreshed((0, $58023c6713a64ee8$export$f1bc67d49dee77a6).updateCurrentRunInfo);
(0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).callWhenRefreshed((0, $58023c6713a64ee8$export$f1bc67d49dee77a6).updateCouch);
(0, $19fa0b0de9ebfc4b$export$60974f670aa8d75e).callWhenRefreshed((0, $846c6604f52b4faa$export$73a1920e79733bc4).updateAndShowAllBreakRuns);
// AUDIO — inert without ?bgm=true
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenReady((0, $534c039c68d25dba$export$5167e49cdb69acbf).setUp);
(0, $cd2554817816328b$export$28cf49ad70f82d12).callWhenReady((0, $534c039c68d25dba$export$5167e49cdb69acbf).scrollBgmLoop);


//# sourceMappingURL=repo.c3daa934.js.map
